import React, { useEffect, useMemo, useState } from 'react';
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListSubheader,
  MenuItem,
  Switch,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import Chip from '@mui/material/Chip';
import CircularProgress from '@mui/material/CircularProgress';
import SaveIcon from '@mui/icons-material/Save';
import RefreshIcon from '@mui/icons-material/Refresh';
import PreviewIcon from '@mui/icons-material/Preview';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import AddBoxIcon from '@mui/icons-material/AddBox';
import OpenWithIcon from '@mui/icons-material/OpenWith';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import UndoIcon from '@mui/icons-material/Undo';
import RedoIcon from '@mui/icons-material/Redo';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import axios from 'axios';
import { ensurePdfFontsLoaded } from '../styles/pdfFonts';

ensurePdfFontsLoaded();
import QRCode from 'qrcode';

// ─── Layouts base por formato (Opción A: se cargan si la plantilla es legacy) ──
const ts = () => `el_${Date.now()}_${Math.floor(Math.random() * 9999)}`;

const BASE_LAYOUTS = {
  T80: [
    { id: ts(), type: 'logo',    x: 12,  y: 12,  width: 55, height: 40, borderRadius: 0, locked: false },
    { id: ts(), type: 'field',   x: 72,  y: 14,  width: 142, height: 14, fontSize: 9,  color: '#000', align: 'left',   token: 'empresa.razon_social',   locked: false },
    { id: ts(), type: 'text',    x: 72,  y: 30,  width: 142, height: 10, fontSize: 7,  color: '#333', align: 'left',   text: 'RUC: {{empresa.ruc}}',    locked: false },
    { id: ts(), type: 'text',    x: 72,  y: 41,  width: 142, height: 10, fontSize: 7,  color: '#555', align: 'left',   text: '{{empresa.direccion}}',   locked: false },
    { id: ts(), type: 'line',    x1: 12, y1: 58, x2: 214,   y2: 58, lineWidth: 1, color: '#aaa' },
    { id: ts(), type: 'field',   x: 12,  y: 62,  width: 203, height: 14, fontSize: 10, color: '#000', align: 'center', token: 'comprobante.tipo_label', locked: false },
    { id: ts(), type: 'text',    x: 12,  y: 79,  width: 203, height: 12, fontSize: 9,  color: '#000', align: 'center', text: '{{comprobante.serie}}-{{comprobante.numero}}', locked: false },
    { id: ts(), type: 'line',    x1: 12, y1: 96, x2: 214,   y2: 96, lineWidth: 1, color: '#aaa' },
    { id: ts(), type: 'text',    x: 12,  y: 100, width: 203, height: 10, fontSize: 7,  color: '#555', align: 'left',   text: 'Cliente: {{comprobante.razon_social}}', locked: false },
    { id: ts(), type: 'text',    x: 12,  y: 112, width: 203, height: 10, fontSize: 7,  color: '#555', align: 'left',   text: 'RUC/DNI: {{comprobante.numero_documento}}', locked: false },
    { id: ts(), type: 'text',    x: 12,  y: 124, width: 203, height: 10, fontSize: 7,  color: '#555', align: 'left',   text: 'Fecha: {{comprobante.fecha_emision}}', locked: false },
    { id: ts(), type: 'line',    x1: 12, y1: 137, x2: 214,  y2: 137, lineWidth: 1, color: '#aaa' },
    { id: ts(), type: 'detalle_table', x: 12, y: 141, width: 203, rowHeight: 14, headerHeight: 16, showHeader: true, showHeaderShade: true, headerFillColor: '#efefef', showRowLine: true,
      columns: [
        { label: 'Cant', token: '{{detalle.cantidad}}', width: 35, align: 'right' },
        { label: 'Descripcion', token: '{{detalle.descripcion_producto}}', width: 113, align: 'left', wrap: true },
        { label: 'P.U.', token: '{{detalle.precio_unitario}}', width: 28, align: 'right' },
        { label: 'Total', token: '{{detalle.total}}', width: 27, align: 'right' }
      ]
    },
    { id: ts(), type: 'totales',      x: 12,  y: 360, width: 203, height: 60, borderColor: '#555' },
    { id: ts(), type: 'cuotas_table', x: 12,  y: 432, width: 203, height: 58, rowHeight: 12, headerHeight: 14, fontSize: 7, showHeader: false, showHeaderShade: false, showRowLine: true, borderColor: '#b0bec5', autoAdjustColumns: false,
      columns: [
        { label: 'Cuota', token: '{{cuota.numero_label}}', width: 78, align: 'left' },
        { label: 'Fecha', token: '{{cuota.fecha}}', width: 58, align: 'center' },
        { label: 'Monto', token: '{{cuota.monto_formateado}}', width: 67, align: 'right' }
      ]
    },
    { id: ts(), type: 'line',         x1: 12, y1: 502, x2: 214, y2: 502, lineWidth: 1, color: '#aaa' },
    { id: ts(), type: 'sunat_message',x: 12,  y: 506, width: 203, height: 10, fontSize: 6, color: '#777', align: 'center' },
    { id: ts(), type: 'qr',           x: 62,  y: 520, width: 100, height: 80, locked: false },
    { id: ts(), type: 'hash',         x: 12,  y: 606, width: 203, height: 10, fontSize: 6, color: '#777', align: 'center' }
  ],
  A4: [
    { id: ts(), type: 'logo',    x: 28,  y: 25,  width: 100, height: 70, borderRadius: 0, locked: false },
    { id: ts(), type: 'field',   x: 28,  y: 100, width: 280, height: 14, fontSize: 11, color: '#000', align: 'left',   token: 'empresa.razon_social',   locked: false },
    { id: ts(), type: 'text',    x: 28,  y: 116, width: 280, height: 11, fontSize: 9,  color: '#333', align: 'left',   text: 'RUC: {{empresa.ruc}}',    locked: false },
    { id: ts(), type: 'text',    x: 28,  y: 129, width: 280, height: 10, fontSize: 8,  color: '#555', align: 'left',   text: '{{empresa.direccion}}',   locked: false },
    { id: ts(), type: 'rect',    x: 347, y: 25,  width: 220, height: 80, strokeColor: '#333', fillColor: null, borderRadius: 0 },
    { id: ts(), type: 'field',   x: 355, y: 35,  width: 204, height: 14, fontSize: 10, color: '#000', align: 'center', token: 'comprobante.tipo_label', locked: false },
    { id: ts(), type: 'text',    x: 355, y: 57,  width: 204, height: 14, fontSize: 11, color: '#000', align: 'center', text: '{{comprobante.serie}}-{{comprobante.numero}}', locked: false },
    { id: ts(), type: 'text',    x: 355, y: 75,  width: 204, height: 11, fontSize: 9,  color: '#555', align: 'center', text: 'Fecha: {{comprobante.fecha_emision}}', locked: false },
    { id: ts(), type: 'line',    x1: 28, y1: 150, x2: 567,  y2: 150, lineWidth: 1, color: '#999' },
    { id: ts(), type: 'text',    x: 28,  y: 156, width: 539, height: 11, fontSize: 9,  color: '#333', align: 'left',   text: 'Cliente: {{comprobante.razon_social}} - RUC/DNI: {{comprobante.numero_documento}}', locked: false },
    { id: ts(), type: 'text',    x: 28,  y: 169, width: 539, height: 11, fontSize: 9,  color: '#555', align: 'left',   text: 'Moneda: {{comprobante.moneda}}   Condición pago: {{comprobante.condicion_pago}}', locked: false },
    { id: ts(), type: 'line',    x1: 28, y1: 184, x2: 567,  y2: 184, lineWidth: 1, color: '#999' },
    { id: ts(), type: 'detalle_table', x: 28, y: 188, width: 539, rowHeight: 16, headerHeight: 18, showHeader: true, showHeaderShade: true, headerFillColor: '#efefef', showRowLine: true,
      columns: [
        { label: 'Cant', token: '{{detalle.cantidad}}', width: 50, align: 'right' },
        { label: 'Descripcion', token: '{{detalle.descripcion_producto}}', width: 269, align: 'left', wrap: true },
        { label: 'P.Unit', token: '{{detalle.precio_unitario}}', width: 73, align: 'right' },
        { label: 'Subt', token: '{{detalle.subtotal}}', width: 73, align: 'right' },
        { label: 'Total', token: '{{detalle.total}}', width: 74, align: 'right' }
      ]
    },
    { id: ts(), type: 'totales',      x: 347, y: 540, width: 220, height: 74, borderColor: '#444' },
    { id: ts(), type: 'cuotas_table', x: 28,  y: 540, width: 300, height: 76, rowHeight: 15, headerHeight: 17, fontSize: 8, showHeader: true, showHeaderShade: true, headerFillColor: '#eef4ff', showRowLine: true, borderColor: '#90caf9', autoAdjustColumns: false,
      columns: [
        { label: 'Cuota', token: '{{cuota.numero_label}}', width: 110, align: 'left' },
        { label: 'Fecha', token: '{{cuota.fecha}}', width: 85, align: 'center' },
        { label: 'Monto', token: '{{cuota.monto_formateado}}', width: 105, align: 'right' }
      ]
    },
    { id: ts(), type: 'line',         x1: 28, y1: 630, x2: 567, y2: 630, lineWidth: 1, color: '#aaa' },
    { id: ts(), type: 'sunat_message',x: 28,  y: 635, width: 539, height: 11, fontSize: 8, color: '#777', align: 'left' },
    { id: ts(), type: 'hash',         x: 28,  y: 648, width: 539, height: 11, fontSize: 7, color: '#888', align: 'left' },
    { id: ts(), type: 'qr',           x: 28,  y: 665, width: 100, height: 80, locked: false }
  ],
  A5: [
    { id: ts(), type: 'logo',    x: 20,  y: 20,  width: 80, height: 55, borderRadius: 0, locked: false },
    { id: ts(), type: 'field',   x: 20,  y: 78,  width: 220, height: 12, fontSize: 10, color: '#000', align: 'left',   token: 'empresa.razon_social',   locked: false },
    { id: ts(), type: 'text',    x: 20,  y: 92,  width: 220, height: 10, fontSize: 8,  color: '#333', align: 'left',   text: 'RUC: {{empresa.ruc}} | {{empresa.direccion}}', locked: false },
    { id: ts(), type: 'rect',    x: 260, y: 20,  width: 140, height: 65, strokeColor: '#333', fillColor: null, borderRadius: 0 },
    { id: ts(), type: 'field',   x: 268, y: 28,  width: 124, height: 12, fontSize: 9,  color: '#000', align: 'center', token: 'comprobante.tipo_label', locked: false },
    { id: ts(), type: 'text',    x: 268, y: 47,  width: 124, height: 12, fontSize: 10, color: '#000', align: 'center', text: '{{comprobante.serie}}-{{comprobante.numero}}', locked: false },
    { id: ts(), type: 'text',    x: 268, y: 62,  width: 124, height: 10, fontSize: 8,  color: '#555', align: 'center', text: '{{comprobante.fecha_emision}}', locked: false },
    { id: ts(), type: 'line',    x1: 20, y1: 108, x2: 400,  y2: 108, lineWidth: 1, color: '#999' },
    { id: ts(), type: 'text',    x: 20,  y: 112, width: 380, height: 11, fontSize: 8,  color: '#333', align: 'left',   text: 'Cliente: {{comprobante.razon_social}} - {{comprobante.numero_documento}}', locked: false },
    { id: ts(), type: 'line',    x1: 20, y1: 128, x2: 400,  y2: 128, lineWidth: 1, color: '#999' },
    { id: ts(), type: 'detalle_table', x: 20, y: 132, width: 380, rowHeight: 14, headerHeight: 16, showHeader: true, showHeaderShade: true, headerFillColor: '#efefef', showRowLine: true,
      columns: [
        { label: 'Cant', token: '{{detalle.cantidad}}', width: 45, align: 'right' },
        { label: 'Descripcion', token: '{{detalle.descripcion_producto}}', width: 195, align: 'left', wrap: true },
        { label: 'P.Unit', token: '{{detalle.precio_unitario}}', width: 70, align: 'right' },
        { label: 'Total', token: '{{detalle.total}}', width: 70, align: 'right' }
      ]
    },
    { id: ts(), type: 'totales',      x: 240, y: 380, width: 160, height: 60, borderColor: '#444' },
    { id: ts(), type: 'cuotas_table', x: 20,  y: 380, width: 200, height: 62, rowHeight: 13, headerHeight: 15, fontSize: 8, showHeader: true, showHeaderShade: true, headerFillColor: '#eef4ff', showRowLine: true, borderColor: '#90caf9', autoAdjustColumns: false,
      columns: [
        { label: 'Cuota', token: '{{cuota.numero_label}}', width: 78, align: 'left' },
        { label: 'Fecha', token: '{{cuota.fecha}}', width: 52, align: 'center' },
        { label: 'Monto', token: '{{cuota.monto_formateado}}', width: 70, align: 'right' }
      ]
    },
    { id: ts(), type: 'line',         x1: 20, y1: 450, x2: 400, y2: 450, lineWidth: 1, color: '#aaa' },
    { id: ts(), type: 'hash',         x: 20,  y: 454, width: 380, height: 10, fontSize: 6, color: '#888', align: 'left' },
    { id: ts(), type: 'qr',           x: 20,  y: 468, width: 85,  height: 70, locked: false }
  ]
};

const CANVAS_BY_FORMAT = {
  A4: { w: 595, h: 842 },
  A5: { w: 420, h: 595 },
  T80: { w: 227, h: 900 }
};

const SCALE = 0.45;
const MIN_ZOOM = 40;
const MAX_ZOOM = 300;
const TOKEN_GROUP_LABELS = {
  empresa: 'Empresa',
  comprobante: 'Comprobante',
  detalle: 'Detalle',
  cuota: 'Cuota'
};
const DEFAULT_TOTALES_ROWS = [
  { label: 'Op. Gravada', token: '{{comprobante.total_gravada}}', align: 'left', money: true },
  { label: 'IGV', token: '{{comprobante.total_igv}}', align: 'left', money: true },
  { label: 'TOTAL ({{comprobante.moneda}})', token: '{{comprobante.total}}', align: 'left', money: true, bold: true }
];
function getDefaultCuotasColumns(formato = 'A4') {
  const fmt = String(formato || 'A4').toUpperCase();
  if (fmt === 'T80') {
    return [
      { label: 'Cuota', token: '{{cuota.numero_label}}', width: 78, align: 'left' },
      { label: 'Fecha', token: '{{cuota.fecha}}', width: 58, align: 'center' },
      { label: 'Monto', token: '{{cuota.monto_formateado}}', width: 67, align: 'right' }
    ];
  }
  if (fmt === 'A5') {
    return [
      { label: 'Cuota', token: '{{cuota.numero_label}}', width: 78, align: 'left' },
      { label: 'Fecha', token: '{{cuota.fecha}}', width: 52, align: 'center' },
      { label: 'Monto', token: '{{cuota.monto_formateado}}', width: 70, align: 'right' }
    ];
  }
  return [
    { label: 'Cuota', token: '{{cuota.numero_label}}', width: 110, align: 'left' },
    { label: 'Fecha', token: '{{cuota.fecha}}', width: 85, align: 'center' },
    { label: 'Monto', token: '{{cuota.monto_formateado}}', width: 105, align: 'right' }
  ];
}

function safeParseConfig(raw) {
  try {
    if (!raw) return {};
    const obj = typeof raw === 'string' ? JSON.parse(raw) : raw;
    if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return obj || {};
    // Strip numeric-string keys produced by accidental JS string spread
    const keys = Object.keys(obj);
    if (!keys.some(k => /^\d+$/.test(k))) return obj;
    const clean = {};
    for (const k of keys) { if (!/^\d+$/.test(k)) clean[k] = obj[k]; }
    return clean;
  } catch (e) {
    return {};
  }
}

function clamp(n, min, max) {
  return Math.max(min, Math.min(max, n));
}

function cloneDeep(value) {
  return JSON.parse(JSON.stringify(value));
}

function humanizeTokenLabel(token) {
  return String(token || '')
    .replace(/\./g, ' - ')
    .replace(/_/g, ' ')
    .replace(/\b([a-z])/g, (_, c) => c.toUpperCase());
}

function resolvePreviewTemplate(input, context, rowContext = null) {
  const raw = String(input || '');
  return raw.replace(/\{\{\s*([\w.]+)\s*\}\}/g, (_, token) => {
    const path = String(token || '');
    if (path.startsWith('detalle.') && rowContext) {
      const rowValue = path.replace(/^detalle\./, '').split('.').reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), rowContext);
      return rowValue === undefined || rowValue === null ? '' : String(rowValue);
    }
    const value = path.split('.').reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), context || {});
    return value === undefined || value === null ? '' : String(value);
  });
}

const ALIGN_THRESHOLD = 6;

const FONT_OPTIONS = [
  { label: 'Helvetica (normal)', value: 'Helvetica' },
  { label: 'Helvetica Bold', value: 'Helvetica-Bold' },
  { label: 'Helvetica Italic', value: 'Helvetica-Oblique' },
  { label: 'Helvetica Bold Italic', value: 'Helvetica-BoldOblique' },
  { label: 'Times Roman', value: 'Times-Roman' },
  { label: 'Times Bold', value: 'Times-Bold' },
  { label: 'Times Italic', value: 'Times-Italic' },
  { label: 'Times Bold Italic', value: 'Times-BoldItalic' },
  { label: 'Courier', value: 'Courier' },
  { label: 'Courier Bold', value: 'Courier-Bold' },
  { label: 'Courier Italic', value: 'Courier-Oblique' },
  { label: 'Courier Bold Italic', value: 'Courier-BoldOblique' },
];

// Mapea la familia elegida (Helvetica/Times/Courier) a la fuente real embebida
// en el PDF (Carlito/Tinos/Cousine, ver pdfFonts.css) para que la vista previa
// del editor se vea igual que el PDF final. El peso/itálica ya se resuelve
// aparte via fontWeight/fontStyle — el @font-face elige el archivo correcto.
const CSS_FONT_FAMILY_MAP = {
  'Helvetica': 'Carlito', 'Helvetica-Bold': 'Carlito', 'Helvetica-Oblique': 'Carlito', 'Helvetica-BoldOblique': 'Carlito',
  'Times-Roman': 'Tinos', 'Times-Bold': 'Tinos', 'Times-Italic': 'Tinos', 'Times-BoldItalic': 'Tinos',
  'Courier': 'Cousine', 'Courier-Bold': 'Cousine', 'Courier-Oblique': 'Cousine', 'Courier-BoldOblique': 'Cousine',
};
function cssFontFamily(el) {
  return (el && CSS_FONT_FAMILY_MAP[el.font]) || 'Carlito';
}

function computeAlignmentGuides(dragEl, nx, ny, allElements, dragIndex, scaleFactor = SCALE) {
  const guides = { h: [], v: [] };
  if (!dragEl || dragEl.type === 'line') return { snappedX: nx, snappedY: ny, guides };

  const dW = Number(dragEl.width) || 100;
  const dH = Number(dragEl.height) || 20;
  let snappedX = nx;
  let snappedY = ny;

  for (let i = 0; i < allElements.length; i++) {
    if (i === dragIndex || !allElements[i] || allElements[i].type === 'line') continue;
    const el = allElements[i];
    const eW = Number(el.width) || 100;
    const eH = Number(el.height) || 20;
    const ex = Number(el.x) || 0;
    const ey = Number(el.y) || 0;

    const vChecks = [
      [nx, ex, 0],
      [nx + dW, ex + eW, -dW],
      [nx + dW / 2, ex + eW / 2, -dW / 2],
      [nx, ex + eW, 0],
      [nx + dW, ex, -dW]
    ];
    for (const [da, ea, offset] of vChecks) {
      if (Math.abs(da - ea) <= ALIGN_THRESHOLD) {
        snappedX = ea + offset;
        const guideX = ea * scaleFactor;
        if (!guides.v.find((g) => Math.abs(g.x - guideX) < 2)) {
          const top = Math.min(snappedY, ey) * scaleFactor;
          const bottom = Math.max(snappedY + dH, ey + eH) * scaleFactor;
          guides.v.push({ x: guideX, y1: top - 15, y2: bottom + 15 });
        }
        break;
      }
    }

    const hChecks = [
      [ny, ey, 0],
      [ny + dH, ey + eH, -dH],
      [ny + dH / 2, ey + eH / 2, -dH / 2],
      [ny, ey + eH, 0],
      [ny + dH, ey, -dH]
    ];
    for (const [da, ea, offset] of hChecks) {
      if (Math.abs(da - ea) <= ALIGN_THRESHOLD) {
        snappedY = ea + offset;
        const guideY = ea * scaleFactor;
        if (!guides.h.find((g) => Math.abs(g.y - guideY) < 2)) {
          const left = Math.min(snappedX, ex) * scaleFactor;
          const right = Math.max(snappedX + dW, ex + eW) * scaleFactor;
          guides.h.push({ y: guideY, x1: left - 15, x2: right + 15 });
        }
        break;
      }
    }
  }

  return { snappedX, snappedY, guides };
}

function newElement(type, formato = 'A4') {
  const base = {
    id: `el_${Date.now()}_${Math.floor(Math.random() * 10000)}`,
    type,
    x: 20,
    y: 20,
    width: 160,
    height: 20,
    fontSize: 9,
    color: '#111111',
    align: 'left',
    locked: false
  };

  if (type === 'logo') {
    return { ...base, width: 90, height: 60, borderRadius: 0, strokeColor: '#333333' };
  }
  if (type === 'rect') {
    return { ...base, width: 180, height: 40, strokeColor: '#444444', fillColor: null, borderRadius: 0 };
  }
  if (type === 'grupo') {
    // Mismas propiedades visuales que 'rect' (reutiliza su mismo render), pero
    // ademas actua como contenedor: los controles con groupId=este id heredan
    // su visibilidad (si el grupo se oculta, se ocultan todos) y su 'seguir
    // anterior' encadena solo contra hermanos del mismo grupo.
    return { ...base, width: 180, height: 60, strokeColor: '#444444', fillColor: null, borderRadius: 0, title: 'Grupo', titlePosition: 'top-border' };
  }
  if (type === 'line') {
    return { ...base, x1: 20, y1: 20, x2: 220, y2: 20, lineWidth: 1, color: '#333333' };
  }
  if (type === 'field') {
    return { ...base, token: 'comprobante.correlativo', width: 180, height: 20 };
  }
  if (type === 'detalle_table') {
    return {
      ...base,
      x: 20,
      y: 180,
      width: 555,
      rowHeight: 16,
      rowPaddingTop: 0,
      rowPaddingBottom: 2,
      headerHeight: 18,
      paginationMode: 'grow',
      maxRowsPerPage: 20,
      repeatHeaderOnNewPage: true,
      showHeader: true,
      showHeaderShade: true,
      headerFillColor: '#efefef',
      showRowLine: true,
      columns: [
        { label: 'Cant', token: '{{detalle.cantidad}}', width: 50, align: 'right' },
        { label: 'Descripcion', token: '{{detalle.descripcion_producto}}', width: 295, align: 'left', wrap: true },
        { label: 'P.Unit', token: '{{detalle.precio_unitario}}', width: 70, align: 'right' },
        { label: 'Subt', token: '{{detalle.subtotal}}', width: 70, align: 'right' },
        { label: 'Total', token: '{{detalle.total}}', width: 70, align: 'right' }
      ]
    };
  }
  if (type === 'totales') {
    return { ...base, x: 355, y: 540, width: 220, height: 74, borderColor: '#444444', followDetail: false, gapFromDetail: 4, followPrev: false, flowGap: 4 };
  }
  if (type === 'cuotas_table') {
    const fmt = String(formato || 'A4').toUpperCase();
    const width = fmt === 'T80' ? 203 : fmt === 'A5' ? 200 : 300;
    const height = fmt === 'T80' ? 58 : fmt === 'A5' ? 62 : 76;
    const rowHeight = fmt === 'T80' ? 12 : fmt === 'A5' ? 13 : 15;
    const headerHeight = fmt === 'T80' ? 14 : fmt === 'A5' ? 15 : 17;
    return {
      ...base,
      x: fmt === 'T80' ? 12 : fmt === 'A5' ? 20 : 28,
      y: fmt === 'T80' ? 432 : fmt === 'A5' ? 380 : 540,
      width,
      height,
      rowHeight,
      headerHeight,
      fontSize: fmt === 'T80' ? 7 : 8,
      showHeader: fmt !== 'T80',
      showHeaderShade: fmt !== 'T80',
      showRowLine: true,
      borderColor: fmt === 'T80' ? '#b0bec5' : '#90caf9',
      headerFillColor: fmt === 'T80' ? '#efefef' : '#eef4ff',
      followDetail: false,
      gapFromDetail: 4,
      followPrev: false,
      flowGap: 4,
      autoAdjustColumns: false,
      columns: cloneDeep(getDefaultCuotasColumns(fmt))
    };
  }
  if (type === 'qr' || type === 'hash' || type === 'sunat_message') {
    return { ...base, width: 250, height: 18, text: type === 'qr' ? '[QR]' : '', followPrev: false, flowGap: 4 };
  }
  if (type === 'image') {
    return { ...base, width: 120, height: 80, imageData: null, objectFit: 'contain', opacity: 100, locked: false };
  }
  if (type === 'grid') {
    const fmt = String(formato || 'A4').toUpperCase();
    const gridW = fmt === 'T80' ? 179 : fmt === 'A5' ? 340 : 420;
    return {
      ...base, x: 20, y: 200, width: gridW, height: 40,
      rows: 2, cols: 3, rowHeight: 18,
      headerRow: true,
      cells: [['Banco', 'CCI', 'N° Cuenta'], ['BCP', '', '']],
      colWidths: Array(3).fill(Math.round(gridW / 3)),
      borderColor: '#555555', borderWidth: 0.5,
      fillColor: null, headerFillColor: '#e8eaf6',
      fontSize: 8, color: '#111111', align: 'left'
    };
  }
  if (type === 'detalle_totales') {
    const fmt = String(formato || 'A4').toUpperCase();
    const w = fmt === 'T80' ? 203 : fmt === 'A5' ? 380 : 539;
    return {
      ...base,
      x: fmt === 'T80' ? 12 : fmt === 'A5' ? 20 : 28,
      y: fmt === 'T80' ? 141 : fmt === 'A5' ? 132 : 188,
      width: w,
      rowHeight: fmt === 'T80' ? 14 : 16,
      headerHeight: fmt === 'T80' ? 16 : 18,
      showHeader: true,
      showHeaderShade: true,
      headerFillColor: '#efefef',
      showRowLine: true,
      showColLines: false,
      showOuterBorder: true,
      borderColor: '#666666',
      borderWidth: 0.5,
      totalesRows: cloneDeep(DEFAULT_TOTALES_ROWS),
      totalesFontSize: fmt === 'T80' ? 7 : 9,
      totalesRowHeight: fmt === 'T80' ? 12 : 14,
      columns: fmt === 'T80'
        ? [
            { label: 'Cant', token: '{{detalle.cantidad}}', width: 35, align: 'right' },
            { label: 'Descripcion', token: '{{detalle.descripcion_producto}}', width: 113, align: 'left', wrap: true },
            { label: 'P.U.', token: '{{detalle.precio_unitario}}', width: 28, align: 'right' },
            { label: 'Total', token: '{{detalle.total}}', width: 27, align: 'right' }
          ]
        : fmt === 'A5'
          ? [
              { label: 'Cant', token: '{{detalle.cantidad}}', width: 45, align: 'right' },
              { label: 'Descripcion', token: '{{detalle.descripcion_producto}}', width: 195, align: 'left', wrap: true },
              { label: 'P.Unit', token: '{{detalle.precio_unitario}}', width: 70, align: 'right' },
              { label: 'Total', token: '{{detalle.total}}', width: 70, align: 'right' }
            ]
          : [
              { label: 'Cant', token: '{{detalle.cantidad}}', width: 50, align: 'right' },
              { label: 'Descripcion', token: '{{detalle.descripcion_producto}}', width: 269, align: 'left', wrap: true },
              { label: 'P.Unit', token: '{{detalle.precio_unitario}}', width: 73, align: 'right' },
              { label: 'Subt', token: '{{detalle.subtotal}}', width: 73, align: 'right' },
              { label: 'Total', token: '{{detalle.total}}', width: 74, align: 'right' }
            ]
    };
  }

  return { ...base, text: 'Texto personalizado' };
}

function normalizeHexColor(value, fallback = '#000000') {
  const text = String(value || '').trim();
  return /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(text) ? text : fallback;
}

function ColorField({ label, value, onChange, pickerFallback = '#000000' }) {
  const current = value ?? '';
  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: 0.75, alignItems: 'center' }}>
      <TextField
        label={label}
        size='small'
        value={current}
        onChange={(e) => onChange(e.target.value)}
      />
      <input
        type='color'
        value={normalizeHexColor(current, pickerFallback)}
        onChange={(e) => onChange(e.target.value)}
        style={{ width: 36, height: 36, padding: 0, border: '1px solid #d0d0d0', borderRadius: 4, background: 'transparent' }}
        title='Paleta de color'
      />
    </Box>
  );
}

export default function EditorPlantillaPdf({ open, onClose, plantilla, onSave, loading }) {
  const [config, setConfig] = useState({});
  const [previewId, setPreviewId] = useState('1');
  const [catalogo, setCatalogo] = useState({ tokens: [], token_meta: [], groups: { empresa: [], comprobante: [], detalle: [], cuota: [] }, sample_layout: null });
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [dragState, setDragState] = useState(null);
  const [footerSelectedIndex, setFooterSelectedIndex] = useState(-1);
  const [footerDragState, setFooterDragState] = useState(null);
  const [snapEnabled, setSnapEnabled] = useState(true);
  const [gridSize, setGridSize] = useState(5);
  const [history, setHistory] = useState([]);
  const [future, setFuture] = useState([]);
  const [guides, setGuides] = useState({ h: [], v: [] });
  const clipboardRef = React.useRef(null);

  const [previewBlobUrl, setPreviewBlobUrl] = useState(null);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [autoPreview, setAutoPreview] = useState(false);
  const [useSampleData, setUseSampleData] = useState(false);
  const [compareMode, setCompareMode] = useState(false);
  const [mousePos, setMousePos] = useState({ x: null, y: null, inside: false });
  const [jumpX, setJumpX] = useState('');
  const [jumpY, setJumpY] = useState('');
  const [zoomPct, setZoomPct] = useState(100);
  const [previewContext, setPreviewContext] = useState(null);
  const [qrPreviewMap, setQrPreviewMap] = useState({});
  const [empresaLogoDataUrl, setEmpresaLogoDataUrl] = useState(null);
  const autoPreviewTimerRef = React.useRef(null);
  // ── Multi-página ────────────────────────────────────────────────────────────
  const [extraPagesInfo, setExtraPagesInfo] = useState([]); // [{id, nombre}]
  const [activePageIdx, setActivePageIdx] = useState(0);    // 0 = pág principal, 1+ = extra
  const pageElementsRef = React.useRef([]);                 // elementos por página (backup)

  const formato = (plantilla?.formato || 'A4').toUpperCase();
  const canvas = CANVAS_BY_FORMAT[formato] || CANVAS_BY_FORMAT.A4;
  const scale = SCALE * (Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, Number(zoomPct || 100))) / 100);
  const canvasW = Math.round(canvas.w * scale);
  const canvasH = Math.round(canvas.h * scale);
  const footerEnabled = !!(config?.footer?.enabled);
  const footerHeight = Math.max(20, Number(config?.footer?.height || 40));
  const footerElements = Array.isArray(config?.footer?.elements) ? config.footer.elements : [];
  const footerCanvasH = Math.round(footerHeight * scale);
  const footerSelected = footerSelectedIndex >= 0 ? footerElements[footerSelectedIndex] : null;

  const clampZoom = (value) => Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, Number(value || 100)));

  const zoomStep = (dir) => {
    setZoomPct((prev) => clampZoom(Number(prev || 100) + (dir > 0 ? 10 : -10)));
  };

  const zoomFit = (mode) => {
    const targetW = compareMode ? 420 : 760;
    const targetH = compareMode ? 470 : 720;
    const fitW = (targetW / (canvas.w * SCALE)) * 100;
    const fitH = (targetH / (canvas.h * SCALE)) * 100;
    const next = mode === 'width' ? fitW : Math.min(fitW, fitH);
    setZoomPct(clampZoom(Math.round(next)));
  };

  const handleCanvasWheel = (ev) => {
    if (!ev.ctrlKey) return;
    ev.preventDefault();
    setZoomPct((prev) => {
      const step = ev.deltaY < 0 ? 8 : -8;
      return clampZoom(Number(prev || 100) + step);
    });
  };

  useEffect(() => {
    if (!open) return;
    const parsed = safeParseConfig(plantilla?.config_json);
    const hasLayout = parsed.layout && Array.isArray(parsed.layout.elements) && parsed.layout.elements.length > 0;
    let layout;
    if (hasLayout) {
      layout = parsed.layout;
    } else {
      // Plantilla legacy o vacía → auto-cargar layout base por formato
      const fmt = (plantilla?.formato || 'A4').toUpperCase();
      const baseElements = (BASE_LAYOUTS[fmt] || BASE_LAYOUTS.A4).map((el) => ({
        ...el,
        id: `el_${Date.now()}_${Math.floor(Math.random() * 99999)}_${el.type}`
      }));
      layout = { enabled: true, elements: baseElements };
    }
    setConfig({ ...parsed, layout, footer: parsed.footer && typeof parsed.footer === 'object' ? parsed.footer : { enabled: false, height: 40, elements: [] } });
    setSelectedIndex(layout.elements.length > 0 ? 0 : -1);
    setHistory([]);
    setFuture([]);
    // Inicializar páginas adicionales
    const epArr = Array.isArray(parsed.extraPages) ? parsed.extraPages : [];
    setExtraPagesInfo(epArr.map((ep) => ({
      id: ep.id || `ep_${Date.now()}_${Math.floor(Math.random() * 99999)}`,
      nombre: ep.nombre || 'Hoja adicional'
    })));
    pageElementsRef.current = [
      layout.elements || [],
      ...epArr.map((ep) => (Array.isArray(ep.elements) ? ep.elements : []))
    ];
    setActivePageIdx(0);
    setPreviewBlobUrl((prev) => {
      if (prev) URL.revokeObjectURL(prev);
      return null;
    });
    setPreviewOpen(false);
    setCompareMode(false);
    setZoomPct(100);
  }, [open, plantilla]);

  useEffect(() => {
    return () => {
      if (autoPreviewTimerRef.current) clearTimeout(autoPreviewTimerRef.current);
      if (previewBlobUrl) URL.revokeObjectURL(previewBlobUrl);
    };
  }, [previewBlobUrl]);

  useEffect(() => {
    if (!open) return;
    const load = async () => {
      try {
        const { data } = await axios.get('/api/reporte-pdf/catalogo-campos');
        setCatalogo(data || { tokens: [], token_meta: [], groups: { empresa: [], comprobante: [], detalle: [], cuota: [] }, sample_layout: null });
      } catch (e) {
        setCatalogo({ tokens: [], token_meta: [], groups: { empresa: [], comprobante: [], detalle: [], cuota: [] }, sample_layout: null });
      }
    };
    load();
  }, [open]);

  // Cargar logo de empresa para previsualización en el canvas
  useEffect(() => {
    if (!open) return;
    axios.get('/api/empresa-config')
      .then(({ data }) => {
        if (data?.logo_base64 && data.logo_base64.length > 32) {
          setEmpresaLogoDataUrl(`data:image/png;base64,${data.logo_base64}`);
        } else {
          setEmpresaLogoDataUrl(null);
        }
      })
      .catch(() => setEmpresaLogoDataUrl(null));
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const id = Number(previewId);
    if (!Number.isFinite(id) || id <= 0) {
      setPreviewContext(null);
      return;
    }

    let cancelled = false;
    // Pasar tipo_comprobante de la plantilla como override para que el preview
    // muestre el tipo correcto (ej: COTIZACIÓN en lugar de FACTURA)
    const tipoOverride = plantilla?.tipo_comprobante ? `?tipo_comprobante_override=${encodeURIComponent(plantilla.tipo_comprobante)}` : '';
    axios.get(`/api/reporte-pdf/contexto/${id}${tipoOverride}`)
      .then(({ data }) => {
        if (!cancelled) setPreviewContext(data || null);
      })
      .catch(() => {
        if (!cancelled) setPreviewContext(null);
      });

    return () => {
      cancelled = true;
    };
  }, [open, previewId, plantilla?.tipo_comprobante]);

  useEffect(() => {
    if (!dragState) return;

    const handleMove = (ev) => {
      const rect = dragState.canvasRect;
      const mx = ev.clientX - rect.left;
      const my = ev.clientY - rect.top;

      if (dragState.mode === 'resize') {
        const dx = (ev.clientX - dragState.startClientX) / scale;
        const dy = (ev.clientY - dragState.startClientY) / scale;
        const nw = Math.max(10, snapValue(Math.round(dragState.startWidth + dx)));
        const nh = Math.max(10, snapValue(Math.round(dragState.startHeight + dy)));
        updateSelected({ width: nw, height: nh }, { track: false });
        return;
      }

      let nx = clamp(snapValue(Math.round((mx / scale) - dragState.offsetX)), 0, canvas.w - 10);
      let ny = clamp(snapValue(Math.round((my / scale) - dragState.offsetY)), 0, canvas.h - 10);

      // Guías de alineación automáticas
      const snapEl = dragState.beforeElements?.[dragState.index];
      if (snapEl && snapEl.type !== 'line') {
        const { snappedX, snappedY, guides: gd } = computeAlignmentGuides(
          snapEl, nx, ny, dragState.beforeElements, dragState.index, scale
        );
        nx = clamp(snappedX, 0, canvas.w - 10);
        ny = clamp(snappedY, 0, canvas.h - 10);
        setGuides(gd);
      }

      setConfig((prev) => {
        const next = { ...(prev || {}) };
        const layout = next.layout && Array.isArray(next.layout.elements)
          ? { ...next.layout, elements: [...next.layout.elements] }
          : { enabled: true, elements: [] };
        const el = layout.elements[dragState.index];
        if (!el) return prev;

        if (el.type === 'line') {
          const origEl = dragState.beforeElements[dragState.index];
          const dx = nx - Number(origEl.x1 || 0);
          const dy = ny - Number(origEl.y1 || 0);
          layout.elements[dragState.index] = {
            ...el,
            x1: clamp(Number(origEl.x1 || 0) + dx, 0, canvas.w),
            y1: clamp(Number(origEl.y1 || 0) + dy, 0, canvas.h),
            x2: clamp(Number(origEl.x2 || 0) + dx, 0, canvas.w),
            y2: clamp(Number(origEl.y2 || 0) + dy, 0, canvas.h)
          };
        } else {
          layout.elements[dragState.index] = { ...el, x: nx, y: ny };
        }

        next.layout = layout;
        return next;
      });
    };

    const handleUp = () => {
      setDragState(null);
      setGuides({ h: [], v: [] });
      if (dragState.beforeElements) {
        setHistory((prev) => [...prev.slice(-49), cloneDeep(dragState.beforeElements)]);
        setFuture([]);
      }
    };

    window.addEventListener('mousemove', handleMove);
    window.addEventListener('mouseup', handleUp);
    return () => {
      window.removeEventListener('mousemove', handleMove);
      window.removeEventListener('mouseup', handleUp);
    };
  }, [dragState, canvas.w, canvas.h, gridSize, snapEnabled, scale]);

  // ── useEffect: drag de elementos del pie de página ────────────────────────
  useEffect(() => {
    if (!footerDragState) return;
    const handleMove = (ev) => {
      const rect = footerDragState.canvasRect;
      const mx = ev.clientX - rect.left;
      const my = ev.clientY - rect.top;
      const nx = clamp(snapValue(Math.round((mx / scale) - footerDragState.offsetX)), 0, canvas.w - 10);
      const ny = clamp(snapValue(Math.round((my / scale) - footerDragState.offsetY)), 0, footerHeight - 2);
      setConfig(prev => {
        const fc = prev?.footer || {};
        const els = [...(Array.isArray(fc.elements) ? fc.elements : [])];
        const el = els[footerDragState.index];
        if (!el) return prev;
        if (el.type === 'line') {
          const origEl = footerDragState.beforeElements[footerDragState.index];
          const dx = nx - Number(origEl.x1 || 0);
          const dy = ny - Number(origEl.y1 || 0);
          els[footerDragState.index] = {
            ...el,
            x1: clamp(Number(origEl.x1 || 0) + dx, 0, canvas.w),
            y1: clamp(Number(origEl.y1 || 0) + dy, 0, footerHeight),
            x2: clamp(Number(origEl.x2 || 0) + dx, 0, canvas.w),
            y2: clamp(Number(origEl.y2 || 0) + dy, 0, footerHeight)
          };
        } else {
          els[footerDragState.index] = { ...el, x: nx, y: ny };
        }
        return { ...prev, footer: { ...fc, elements: els } };
      });
    };
    const handleUp = () => setFooterDragState(null);
    window.addEventListener('mousemove', handleMove);
    window.addEventListener('mouseup', handleUp);
    return () => { window.removeEventListener('mousemove', handleMove); window.removeEventListener('mouseup', handleUp); };
  }, [footerDragState, canvas.w, footerHeight, scale, snapEnabled, gridSize]);

  const elements = useMemo(() => {
    const layout = config?.layout;
    if (!layout || !Array.isArray(layout.elements)) return [];
    return layout.elements;
  }, [config]);

  const tokenMetaMap = useMemo(() => {
    const map = new Map();
    const meta = catalogo?.token_meta;
    if (!meta) return map;
    if (Array.isArray(meta)) {
      for (const item of meta) {
        if (item?.token) map.set(item.token, item.label || item.token);
      }
    } else if (typeof meta === 'object') {
      // Formato legado: { "token": "label" }
      for (const [token, label] of Object.entries(meta)) {
        map.set(token, String(label || token));
      }
    }
    return map;
  }, [catalogo]);

  const catalogGroups = useMemo(() => {
    const groups = catalogo?.groups || {};
    const used = new Set();
    const ordered = [];

    for (const key of ['empresa', 'comprobante', 'detalle', 'cuota']) {
      const tokens = Array.isArray(groups[key]) ? groups[key] : [];
      if (!tokens.length) continue;
      ordered.push({ key, label: TOKEN_GROUP_LABELS[key] || humanizeTokenLabel(key), tokens });
      tokens.forEach((token) => used.add(token));
    }

    const others = (catalogo?.tokens || []).filter((token) => !used.has(token));
    if (others.length) ordered.push({ key: 'otros', label: 'Otros', tokens: others });
    return ordered;
  }, [catalogo]);

  const detalleCatalogTokens = useMemo(() => {
    const fromGroup = (catalogo?.groups?.detalle || []).filter((token) => String(token || '').startsWith('detalle.'));
    const fromAll = (catalogo?.tokens || []).filter((token) => String(token || '').startsWith('detalle.'));
    return Array.from(new Set([...fromGroup, ...fromAll]));
  }, [catalogo]);

  const totalesCatalogTokens = useMemo(() => {
    const fromComprobante = catalogo?.groups?.comprobante || [];
    const fromEmpresa = catalogo?.groups?.empresa || [];
    const fromAll = (catalogo?.tokens || []).filter((token) => !String(token || '').startsWith('detalle.'));
    return Array.from(new Set([...fromComprobante, ...fromEmpresa, ...fromAll]));
  }, [catalogo]);

  const cuotaCatalogTokens = useMemo(() => {
    const fromGroup = (catalogo?.groups?.cuota || []).filter((token) => String(token || '').startsWith('cuota.'));
    const fromAll = (catalogo?.tokens || []).filter((token) => String(token || '').startsWith('cuota.'));
    return Array.from(new Set([...fromGroup, ...fromAll]));
  }, [catalogo]);

  useEffect(() => {
    let cancelled = false;
    const qrElements = elements.filter((el) => el.type === 'qr');
    if (!qrElements.length || !previewContext?.token_context) {
      setQrPreviewMap({});
      return;
    }

    Promise.all(qrElements.map(async (el, idx) => {
      const qrText = resolvePreviewTemplate(el.text || '{{comprobante.qr_text}}', previewContext.token_context, previewContext.sample_detail || null) || 'QR';
      const dataUrl = await QRCode.toDataURL(qrText, {
        errorCorrectionLevel: 'M',
        margin: 1,
        width: 256
      });
      return [el.id || `qr_${idx}`, dataUrl];
    }))
      .then((entries) => {
        if (!cancelled) setQrPreviewMap(Object.fromEntries(entries));
      })
      .catch(() => {
        if (!cancelled) setQrPreviewMap({});
      });

    return () => {
      cancelled = true;
    };
  }, [elements, previewContext]);

  const selected = selectedIndex >= 0 ? elements[selectedIndex] : null;

  useEffect(() => {
    if (!selected) {
      setJumpX('');
      setJumpY('');
      return;
    }
    if (selected.type === 'line') {
      setJumpX(String(Number(selected.x1 || 0)));
      setJumpY(String(Number(selected.y1 || 0)));
    } else {
      setJumpX(String(Number(selected.x || 0)));
      setJumpY(String(Number(selected.y || 0)));
    }
  }, [selectedIndex]);

  const snapValue = (value) => {
    if (!snapEnabled) return value;
    const step = Math.max(1, Number(gridSize || 1));
    return Math.round(value / step) * step;
  };

  // ── Helpers para pie de página ──────────────────────────────────────────────
  const setFooterConfig = (patch) => setConfig(prev => ({
    ...prev,
    footer: { enabled: true, height: footerHeight, elements: footerElements, ...(prev?.footer || {}), ...patch }
  }));
  const setFooterElements = (next) => setConfig(prev => ({
    ...prev,
    footer: { enabled: true, height: footerHeight, ...(prev?.footer || {}), elements: next }
  }));
  const updateFooterSelected = (patch) => {
    if (footerSelectedIndex < 0) return;
    setFooterElements(footerElements.map((el, i) => i === footerSelectedIndex ? { ...el, ...patch } : el));
  };
  const addFooterElement = (type) => {
    const fw = canvas.w;
    const id = `f_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    // Offset x según cuántos elementos no-línea ya existen, para evitar solapamiento total
    const nonLineCount = footerElements.filter(e => e.type !== 'line').length;
    const offsetX = Math.min(nonLineCount * 50, fw * 0.5);
    let el;
    if (type === 'line') el = { id, type: 'line', x1: 0, y1: 2, x2: fw, y2: 2, color: '#999999', lineWidth: 0.5 };
    else if (type === 'text') el = { id, type: 'text', x: 10 + offsetX, y: 14, width: Math.max(60, fw - 20 - offsetX), height: 14, fontSize: 7, color: '#555555', align: 'center', text: 'Texto pie de página' };
    else if (type === 'field') el = { id, type: 'field', x: 10 + offsetX, y: 14, width: 90, height: 14, fontSize: 7, color: '#555555', align: 'left', token: 'fecha_impresion' };
    else if (type === 'qr') el = { id, type: 'qr', x: 10 + offsetX, y: 2, width: 35, height: 35 };
    else if (type === 'hash') el = { id, type: 'hash', x: 10 + offsetX, y: 14, width: Math.max(80, fw - 20 - offsetX), height: 10, fontSize: 6, color: '#555555', align: 'left' };
    else if (type === 'sunat_message') el = { id, type: 'sunat_message', x: 10 + offsetX, y: 14, width: Math.max(80, fw - 20 - offsetX), height: 10, fontSize: 6, color: '#555555', align: 'left' };
    else if (type === 'grid') el = { id, type: 'grid', x: 10 + offsetX, y: 2, rows: 2, cols: 3, rowHeight: 14, width: 150, height: 28, fontSize: 7, borderColor: '#555555', borderWidth: 0.5, cells: [['', '', ''], ['', '', '']] };
    else if (type === 'image') el = { id, type: 'image', x: 10 + offsetX, y: 2, width: 60, height: 30, imageData: null, objectFit: 'contain', opacity: 100 };
    else return;
    const next = [...footerElements, el];
    setFooterElements(next);
    setFooterSelectedIndex(next.length - 1);
    setSelectedIndex(-1);
  };

  const generatePreview = async (els) => {
    // 0 = datos de muestra; id real del comprobante en otro caso
    const id = useSampleData ? 0 : Number(previewId);
    if (!useSampleData && (!Number.isFinite(id) || id <= 0)) return;
    // Guardar página activa en ref para que el preview incluya todos los elementos actuales
    pageElementsRef.current[activePageIdx] = [...(els || elements)];
    setPreviewLoading(true);
    try {
      const resp = await axios.post(
        '/api/reporte-pdf/preview-draft',
        {
          comprobante_id: id,
          formato,
          elements: pageElementsRef.current[0] || [],
          draft_config: {
            alto_contraste_termico: !!(config.alto_contraste_termico),
            super_alto_contraste_termico: !!(config.super_alto_contraste_termico),
            pageHeightMode: config.pageHeightMode || 'fixed',
            pageBottomPadding: Number(config.pageBottomPadding ?? 8),
            pageMinHeight: Number(config.pageMinHeight ?? 120),
            pageMaxHeight: Number(config.pageMaxHeight ?? 5000),
            pageFixedHeight: Number(config.pageFixedHeight ?? 1000),
            extra_pages: extraPagesInfo.map((info, i) => ({
              id: info.id,
              nombre: info.nombre,
              elements: pageElementsRef.current[i + 1] || []
            })),
            footer: config.footer || { enabled: false, height: 40, elements: [] }
          },
          tipo_comprobante_override: plantilla?.tipo_comprobante || null
        },
        { responseType: 'blob' }
      );
      const url = URL.createObjectURL(resp.data);
      setPreviewBlobUrl((prev) => {
        if (prev) URL.revokeObjectURL(prev);
        return url;
      });
      setPreviewOpen(true);
    } catch (err) {
      let errMsg = err.message;
      try {
        if (err.response?.data instanceof Blob) {
          const text = await err.response.data.text();
          const json = JSON.parse(text);
          errMsg = json.error || errMsg;
        } else {
          errMsg = err.response?.data?.error || errMsg;
        }
      } catch {}
      if (err.response?.status === 401) {
        alert('Sesión expirada. Por favor, cierra sesión y vuelve a iniciar sesión.');
      } else {
        alert(`Error al generar preview: ${errMsg}`);
      }
    } finally {
      setPreviewLoading(false);
    }
  };

  // Auto-preview debounced al cambiar elementos
  useEffect(() => {
    if (!autoPreview || !open) return;
    clearTimeout(autoPreviewTimerRef.current);
    autoPreviewTimerRef.current = setTimeout(() => {
      generatePreview(elements);
    }, 2000);
    return () => clearTimeout(autoPreviewTimerRef.current);
  }, [elements, autoPreview, open]);

  const setElements = (nextElements) => {
    setConfig((prev) => ({
      ...(prev || {}),
      layout: {
        enabled: true,
        elements: nextElements
      }
    }));
  };

  const commitElements = (nextElements, nextSelected = selectedIndex) => {
    setHistory((prev) => [...prev.slice(-49), cloneDeep(elements)]);
    setFuture([]);
    setElements(nextElements);
    setSelectedIndex(nextSelected);
  };

  const undo = () => {
    if (!history.length) return;
    const prevState = history[history.length - 1];
    setHistory((prev) => prev.slice(0, -1));
    setFuture((prev) => [cloneDeep(elements), ...prev].slice(0, 50));
    setElements(cloneDeep(prevState));
    setSelectedIndex((prev) => {
      if (prevState.length === 0) return -1;
      return Math.min(Math.max(prev, 0), prevState.length - 1);
    });
  };

  const redo = () => {
    if (!future.length) return;
    const nextState = future[0];
    setFuture((prev) => prev.slice(1));
    setHistory((prev) => [...prev.slice(-49), cloneDeep(elements)]);
    setElements(cloneDeep(nextState));
    setSelectedIndex((prev) => {
      if (nextState.length === 0) return -1;
      return Math.min(Math.max(prev, 0), nextState.length - 1);
    });
  };

  const addElement = (type) => {
    const next = [...elements, newElement(type, formato)];
    commitElements(next, next.length - 1);
  };

  const applySample = () => {
    if (!catalogo?.sample_layout?.elements) return;
    const next = catalogo.sample_layout.elements.map((e, i) => ({ ...e, id: `sample_${i}_${Date.now()}` }));
    commitElements(next, next.length > 0 ? 0 : -1);
  };

  const removeSelected = () => {
    if (selectedIndex < 0) return;
    const next = elements.filter((_, i) => i !== selectedIndex);
    commitElements(next, next.length ? Math.min(selectedIndex, next.length - 1) : -1);
  };

  const duplicateSelected = () => {
    if (selectedIndex < 0) return;
    const source = elements[selectedIndex];
    if (!source) return;

    const copied = JSON.parse(JSON.stringify(source));
    copied.id = `el_${Date.now()}_${Math.floor(Math.random() * 10000)}`;

    if (copied.type === 'line') {
      copied.x1 = clamp(Number(copied.x1 || 0) + 8, 0, canvas.w);
      copied.y1 = clamp(Number(copied.y1 || 0) + 8, 0, canvas.h);
      copied.x2 = clamp(Number(copied.x2 || 0) + 8, 0, canvas.w);
      copied.y2 = clamp(Number(copied.y2 || 0) + 8, 0, canvas.h);
    } else {
      copied.x = clamp(Number(copied.x || 0) + 8, 0, canvas.w - 5);
      copied.y = clamp(Number(copied.y || 0) + 8, 0, canvas.h - 5);
    }

    const next = [...elements, copied];
    commitElements(next, next.length - 1);
  };

  const moveLayer = (direction) => {
    if (selectedIndex < 0) return;
    const next = [...elements];
    const current = next[selectedIndex];
    if (!current) return;

    let targetIndex = selectedIndex;
    if (direction === 'up') targetIndex = Math.max(0, selectedIndex - 1);
    if (direction === 'down') targetIndex = Math.min(next.length - 1, selectedIndex + 1);
    if (direction === 'top') targetIndex = next.length - 1;
    if (direction === 'bottom') targetIndex = 0;
    if (targetIndex === selectedIndex) return;

    next.splice(selectedIndex, 1);
    next.splice(targetIndex, 0, current);
    commitElements(next, targetIndex);
  };

  const alignSelectedToCanvas = (mode) => {
    if (!selected || selectedIndex < 0) return;

    if (selected.type === 'line') {
      const x1 = Number(selected.x1 || 0);
      const y1 = Number(selected.y1 || 0);
      const x2 = Number(selected.x2 || 0);
      const y2 = Number(selected.y2 || 0);
      const minX = Math.min(x1, x2);
      const maxX = Math.max(x1, x2);
      const minY = Math.min(y1, y2);
      const maxY = Math.max(y1, y2);
      const w = maxX - minX;
      const h = maxY - minY;

      let tx = minX;
      let ty = minY;
      if (mode === 'left') tx = 0;
      if (mode === 'centerX') tx = (canvas.w - w) / 2;
      if (mode === 'right') tx = canvas.w - w;
      if (mode === 'top') ty = 0;
      if (mode === 'centerY') ty = (canvas.h - h) / 2;
      if (mode === 'bottom') ty = canvas.h - h;

      const dx = tx - minX;
      const dy = ty - minY;
      updateSelected({
        x1: clamp(x1 + dx, 0, canvas.w),
        y1: clamp(y1 + dy, 0, canvas.h),
        x2: clamp(x2 + dx, 0, canvas.w),
        y2: clamp(y2 + dy, 0, canvas.h)
      });
      return;
    }

    const w = Math.max(10, Number(selected.width || 100));
    const h = Math.max(10, Number(selected.height || 20));
    let nx = Number(selected.x || 0);
    let ny = Number(selected.y || 0);

    if (mode === 'left') nx = 0;
    if (mode === 'centerX') nx = Math.round((canvas.w - w) / 2);
    if (mode === 'right') nx = Math.max(0, canvas.w - w);
    if (mode === 'top') ny = 0;
    if (mode === 'centerY') ny = Math.round((canvas.h - h) / 2);
    if (mode === 'bottom') ny = Math.max(0, canvas.h - h);

    updateSelected({ x: clamp(nx, 0, canvas.w), y: clamp(ny, 0, canvas.h) });
  };

  const stretchSelectedFullWidth = () => {
    if (!selected || selectedIndex < 0 || selected.type === 'line') return;
    updateSelected({ x: 0, width: canvas.w });
  };

  const alignFooterSelectedToBox = (mode) => {
    if (!footerSelected || footerSelectedIndex < 0) return;
    const w = Math.max(10, Number(footerSelected.width || 60));
    const h = Math.max(5, Number(footerSelected.height || 30));
    let nx = Number(footerSelected.x || 0);
    let ny = Number(footerSelected.y || 0);

    if (mode === 'left') nx = 0;
    if (mode === 'right') nx = Math.max(0, canvas.w - w);
    if (mode === 'top') ny = 0;
    if (mode === 'bottom') ny = Math.max(0, footerHeight - h);

    updateFooterSelected({ x: clamp(nx, 0, canvas.w), y: clamp(ny, 0, footerHeight) });
  };

  const applyJumpCoordinates = () => {
    if (!selected) return;
    const tx = Number(jumpX);
    const ty = Number(jumpY);
    if (!Number.isFinite(tx) || !Number.isFinite(ty)) return;

    if (selected.type === 'line') {
      const x1 = Number(selected.x1 || 0);
      const y1 = Number(selected.y1 || 0);
      const x2 = Number(selected.x2 || 0);
      const y2 = Number(selected.y2 || 0);
      const dx = tx - x1;
      const dy = ty - y1;
      updateSelected({
        x1: clamp(tx, 0, canvas.w),
        y1: clamp(ty, 0, canvas.h),
        x2: clamp(x2 + dx, 0, canvas.w),
        y2: clamp(y2 + dy, 0, canvas.h)
      });
      return;
    }

    updateSelected({
      x: clamp(Math.round(tx), 0, canvas.w),
      y: clamp(Math.round(ty), 0, canvas.h)
    });
  };

  const exportLayoutJson = async () => {
    try {
      const payload = JSON.stringify({ layout: { enabled: true, elements } }, null, 2);
      await navigator.clipboard.writeText(payload);
      alert('Layout JSON copiado al portapapeles.');
    } catch (e) {
      alert('No se pudo copiar al portapapeles.');
    }
  };

  const importLayoutJson = () => {
    const raw = window.prompt('Pega aqui el JSON del layout (objeto con layout.elements o array de elements):');
    if (!raw) return;
    try {
      const parsed = JSON.parse(raw);
      const incoming = Array.isArray(parsed)
        ? parsed
        : (Array.isArray(parsed?.layout?.elements) ? parsed.layout.elements : null);
      if (!incoming) {
        alert('JSON invalido. Se esperaba un array o layout.elements.');
        return;
      }
      const normalized = incoming.map((el) => ({
        ...el,
        id: el.id || `el_${Date.now()}_${Math.floor(Math.random() * 100000)}`,
        locked: Boolean(el.locked)
      }));
      commitElements(normalized, normalized.length ? 0 : -1);
    } catch (e) {
      alert(`JSON invalido: ${e.message}`);
    }
  };

  const updateSelected = (patch, options = { track: true }) => {
    if (selectedIndex < 0) return;
    const next = elements.map((el, i) => (i === selectedIndex ? { ...el, ...patch } : el));
    if (options.track) {
      commitElements(next, selectedIndex);
    } else {
      setElements(next);
    }
  };

  const updateDetalleTableColumns = (updater) => {
    if (!selected || selected.type !== 'detalle_table') return;
    const current = Array.isArray(selected.columns) ? selected.columns : [];
    const nextColumns = updater(cloneDeep(current));
    updateSelected({ columns: nextColumns });
  };

  const updateTotalesRows = (updater) => {
    if (!selected || selected.type !== 'totales') return;
    const current = Array.isArray(selected.rows) && selected.rows.length > 0
      ? selected.rows
      : DEFAULT_TOTALES_ROWS;
    const nextRows = updater(cloneDeep(current));
    updateSelected({ rows: nextRows });
  };

  const updateCuotasTableColumns = (updater) => {
    if (!selected || selected.type !== 'cuotas_table') return;
    const current = Array.isArray(selected.columns) && selected.columns.length > 0
      ? selected.columns
      : getDefaultCuotasColumns(formato);
    const nextColumns = updater(cloneDeep(current));
    updateSelected({ columns: nextColumns });
  };

  const nudge = (dx, dy, stepOverride = null) => {
    if (!selected) return;
    const step = stepOverride ?? (snapEnabled ? Math.max(1, Number(gridSize || 1)) : 1);
    const mx = dx * step;
    const my = dy * step;

    if (selected.type === 'line') {
      updateSelected({
        x1: clamp(Number(selected.x1 || 0) + mx, 0, canvas.w),
        y1: clamp(Number(selected.y1 || 0) + my, 0, canvas.h),
        x2: clamp(Number(selected.x2 || 0) + mx, 0, canvas.w),
        y2: clamp(Number(selected.y2 || 0) + my, 0, canvas.h)
      });
      return;
    }
    updateSelected({
      x: clamp(Number(selected.x || 0) + mx, 0, canvas.w),
      y: clamp(Number(selected.y || 0) + my, 0, canvas.h)
    });
  };

  // ── Gestión de páginas adicionales ─────────────────────────────────────────
  const switchPage = (newIdx) => {
    if (newIdx === activePageIdx) return;
    // Guardar elementos de la página activa en el ref
    pageElementsRef.current[activePageIdx] = [...(config?.layout?.elements || [])];
    // Cargar elementos de la nueva página
    const newElements = [...(pageElementsRef.current[newIdx] || [])];
    setConfig((prev) => ({ ...prev, layout: { enabled: true, elements: newElements } }));
    setActivePageIdx(newIdx);
    setSelectedIndex(-1);
    setHistory([]);
    setFuture([]);
  };

  const addExtraPage = () => {
    // Guardar página actual en ref
    pageElementsRef.current[activePageIdx] = [...(config?.layout?.elements || [])];
    const newId = `ep_${Date.now()}_${Math.floor(Math.random() * 99999)}`;
    const newIdx = extraPagesInfo.length + 1;
    pageElementsRef.current[newIdx] = [];
    setExtraPagesInfo((prev) => [...prev, { id: newId, nombre: `Hoja ${prev.length + 2}` }]);
    setConfig((prev) => ({ ...prev, layout: { enabled: true, elements: [] } }));
    setActivePageIdx(newIdx);
    setSelectedIndex(-1);
    setHistory([]);
    setFuture([]);
  };

  const deleteExtraPage = (pageIdx) => {
    if (pageIdx < 1) return;
    // Guardar página actual en ref
    pageElementsRef.current[activePageIdx] = [...(config?.layout?.elements || [])];
    // Reconstruir ref sin la página eliminada
    const newRef = [pageElementsRef.current[0], ...pageElementsRef.current.slice(1).filter((_, i) => i !== pageIdx - 1)];
    pageElementsRef.current = newRef;
    const newInfo = extraPagesInfo.filter((_, i) => i !== pageIdx - 1);
    setExtraPagesInfo(newInfo);
    // Volver a la página anterior o main
    const newActiveIdx = Math.max(0, pageIdx - 1);
    const newElements = [...(pageElementsRef.current[newActiveIdx] || [])];
    setConfig((prev) => ({ ...prev, layout: { enabled: true, elements: newElements } }));
    setActivePageIdx(newActiveIdx);
    setSelectedIndex(-1);
    setHistory([]);
    setFuture([]);
  };

  const renameExtraPage = (pageIdx, newNombre) => {
    setExtraPagesInfo((prev) => prev.map((ep, i) => (i === pageIdx - 1 ? { ...ep, nombre: newNombre } : ep)));
  };

  const save = async () => {
    try {
      // Guardar página activa en ref antes de serializar
      pageElementsRef.current[activePageIdx] = [...(config?.layout?.elements || [])];
      const mainElements = pageElementsRef.current[0] || [];
      const epPayload = extraPagesInfo.map((info, i) => ({
        id: info.id,
        nombre: info.nombre,
        elements: pageElementsRef.current[i + 1] || []
      }));
      const payload = {
        ...config,
        layout: { enabled: true, elements: mainElements },
        extraPages: epPayload
      };

      await axios.put(`/api/reporte-pdf/plantillas/${plantilla.id}`, {
        nombre: plantilla.nombre,
        config_json: JSON.stringify(payload),
        usuario: 'admin'
      });

      if (onSave) await onSave(payload);
      onClose();
    } catch (err) {
      alert(`Error: ${err.response?.data?.error || err.message}`);
    }
  };

  const exportarLayout = () => {
    try {
      const payload = {
        ...config,
        layout: { enabled: true, elements }
      };
      const exportData = {
        nombre: plantilla?.nombre || 'plantilla',
        formato: plantilla?.formato || 'A4',
        tipo_comprobante: plantilla?.tipo_comprobante || '01',
        config_json: JSON.stringify(payload)
      };
      const blob = new Blob([JSON.stringify(exportData, null, 2)], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${(plantilla?.nombre || 'plantilla').replace(/[^a-zA-Z0-9áéíóúñ]/gi, '_')}.json`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (err) {
      alert(`Error al exportar: ${err.message}`);
    }
  };

  useEffect(() => {
    if (!open) return;

    const onKeyDown = (ev) => {
      const tag = String(ev.target?.tagName || '').toLowerCase();
      const isTypingTarget = tag === 'input' || tag === 'textarea' || ev.target?.isContentEditable;
      const ctrl = ev.ctrlKey || ev.metaKey;
      if (ctrl && ev.key.toLowerCase() === 'z' && !ev.shiftKey) {
        ev.preventDefault();
        undo();
        return;
      }
      if ((ctrl && ev.key.toLowerCase() === 'y') || (ctrl && ev.shiftKey && ev.key.toLowerCase() === 'z')) {
        ev.preventDefault();
        redo();
        return;
      }
      if (ctrl && ev.key.toLowerCase() === 'c' && selectedIndex >= 0 && !isTypingTarget) {
        ev.preventDefault();
        if (elements[selectedIndex]) clipboardRef.current = cloneDeep(elements[selectedIndex]);
        return;
      }
      if (ctrl && ev.key.toLowerCase() === 'v' && clipboardRef.current) {
        ev.preventDefault();
        const pasted = cloneDeep(clipboardRef.current);
        pasted.id = `el_${Date.now()}_${Math.floor(Math.random() * 10000)}`;
        if (pasted.type === 'line') {
          pasted.x1 = clamp((Number(pasted.x1) || 0) + 10, 0, canvas.w);
          pasted.y1 = clamp((Number(pasted.y1) || 0) + 10, 0, canvas.h);
          pasted.x2 = clamp((Number(pasted.x2) || 0) + 10, 0, canvas.w);
          pasted.y2 = clamp((Number(pasted.y2) || 0) + 10, 0, canvas.h);
        } else {
          pasted.x = clamp((Number(pasted.x) || 0) + 10, 0, canvas.w - 5);
          pasted.y = clamp((Number(pasted.y) || 0) + 10, 0, canvas.h - 5);
        }
        const next = [...elements, pasted];
        commitElements(next, next.length - 1);
        return;
      }
      if (ev.key === 'Delete' && selectedIndex >= 0) {
        ev.preventDefault();
        removeSelected();
        return;
      }

      if (!isTypingTarget && selectedIndex >= 0 && ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(ev.key)) {
        ev.preventDefault();
        // Alt = micro ajuste (1px), Shift = macro (10px), default = grid/snap step
        const stepOverride = ev.altKey ? 1 : (ev.shiftKey ? 10 : null);
        if (ev.key === 'ArrowLeft') nudge(-1, 0, stepOverride);
        if (ev.key === 'ArrowRight') nudge(1, 0, stepOverride);
        if (ev.key === 'ArrowUp') nudge(0, -1, stepOverride);
        if (ev.key === 'ArrowDown') nudge(0, 1, stepOverride);
      }
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [open, undo, redo, selectedIndex]);

  const renderElementInCanvas = (el, index) => {
    const isSelected = index === selectedIndex;

    if (el.type === 'line') {
      const x1 = Number(el.x1 || 0) * scale;
      const y1 = Number(el.y1 || 0) * scale;
      const x2 = Number(el.x2 || 0) * scale;
      const y2 = Number(el.y2 || 0) * scale;
      return (
        <line
          key={el.id || index}
          x1={x1}
          y1={y1}
          x2={x2}
          y2={y2}
          stroke={el.color || '#333333'}
          strokeWidth={isSelected ? 3 : 2}
          onMouseDown={(ev) => {
            ev.stopPropagation();
            setSelectedIndex(index);
            if (!el.locked) {
              const rect = ev.currentTarget.ownerSVGElement.getBoundingClientRect();
              const offsetX = (ev.clientX - rect.left) / scale - Number(el.x1 || 0);
              const offsetY = (ev.clientY - rect.top) / scale - Number(el.y1 || 0);
              setDragState({
                mode: 'move',
                index,
                canvasRect: rect,
                offsetX,
                offsetY,
                beforeElements: cloneDeep(elements)
              });
            }
          }}
        />
      );
    }

    const left = Number(el.x || 0) * scale;
    const top = Number(el.y || 0) * scale;
    const w = Math.max(20, Number(el.width || 120)) * scale;
    const h = Math.max(12, Number(el.height || 20)) * scale;

    let label = el.type.toUpperCase();
    if (el.type === 'field') label = previewContext?.token_context ? resolvePreviewTemplate(`{{${el.token || 'campo'}}}`, previewContext.token_context, previewContext.sample_detail || null) || `{{${el.token || 'campo'}}}` : `{{${el.token || 'campo'}}}`;
    if (el.type === 'text') label = previewContext?.token_context ? resolvePreviewTemplate(el.text || 'Texto', previewContext.token_context, previewContext.sample_detail || null) || el.text || 'Texto' : el.text || 'Texto';
    if (el.type === 'detalle_table') {
      const cols = Array.isArray(el.columns) ? el.columns.map((col) => col.label).filter(Boolean) : [];
      label = cols.length ? `DETALLE: ${cols.join(' | ')}` : 'DETALLE_TABLE';
    }
    if (el.type === 'totales') {
      const rows = Array.isArray(el.rows) ? el.rows.map((row) => row.label).filter(Boolean) : [];
      label = rows.length ? `TOTALES: ${rows.join(' | ')}` : 'TOTALES';
    }
    if (el.type === 'cuotas_table') {
      const cols = Array.isArray(el.columns) ? el.columns.map((col) => col.label).filter(Boolean) : [];
      label = cols.length ? `CUOTAS: ${cols.join(' | ')}` : 'CUOTAS_TABLE';
    }
    if (el.type === 'detalle_totales') {
      const cols = Array.isArray(el.columns) ? el.columns.map((col) => col.label).filter(Boolean) : [];
      label = cols.length ? `DETALLE+TOT: ${cols.join(' | ')}` : 'DETALLE_TOTALES';
    }
    if (el.type === 'image') {
      label = '🖼 IMAGEN';
    }

    // ── Grilla estática ────────────────────────────────────────────────────────
    if (el.type === 'grid') {
      const numRows = Math.max(1, Number(el.rows || 2));
      const numCols = Math.max(1, Number(el.cols || 3));
      const rowHpx = Math.max(8, Number(el.rowHeight || 18)) * scale;
      const totalH = numRows * rowHpx;
      const cws = Array.isArray(el.colWidths) && el.colWidths.length === numCols
        ? el.colWidths.map((n) => Number(n) * scale)
        : Array(numCols).fill(w / numCols);
      // El ancho real es la SUMA de colWidths, no el width del elemento
      const totalW = cws.reduce((a, b) => a + b, 0);
      const bwPx = Math.max(0.5, (el.borderWidth || 0.5) * scale);
      const bc = el.borderColor || '#555555';
      const padTPx = Math.max(0, Number(el.cellPadTop ?? 2)) * scale;
      const padLPx = Math.max(0, Number(el.cellPadLeft ?? 2)) * scale;
      const padRPx = Math.max(0, Number(el.cellPadRight ?? 2)) * scale;
      const headerPadTPx = Math.max(0, Number(el.headerPadTop ?? el.cellPadTop ?? 2)) * scale;
      const gridBorderRadius = Number(el.borderRadius || 0) * scale;
      const gridMouseDown = (ev) => {
        ev.stopPropagation();
        setSelectedIndex(index);
        if (!el.locked) {
          const rect = ev.currentTarget.parentElement.getBoundingClientRect();
          const offsetX = (ev.clientX - rect.left) / scale - Number(el.x || 0);
          const offsetY = (ev.clientY - rect.top) / scale - Number(el.y || 0);
          setDragState({ mode: 'move', index, canvasRect: rect, offsetX, offsetY, beforeElements: cloneDeep(elements) });
        }
      };
      return (
        <Box key={el.id || index} onMouseDown={gridMouseDown}
          sx={{ position: 'absolute', left, top, width: totalW, height: totalH, cursor: 'move', outline: isSelected ? '2px solid #1976d2' : 'none', overflow: 'hidden', borderRadius: `${gridBorderRadius}px` }}>
          <table style={{ borderCollapse: 'collapse', tableLayout: 'fixed', fontFamily: cssFontFamily(el), fontSize: `${Math.max(6, Number(el.fontSize || 8) * scale)}px`, lineHeight: 1.2 }}>
            <tbody>
              {Array.from({ length: numRows }, (_, r) => (
                <tr key={r}>
                  {Array.from({ length: numCols }, (_, c) => {
                    const isHdr = el.headerRow && r === 0;
                    const cellText = (el.cells && el.cells[r] && el.cells[r][c] !== undefined) ? String(el.cells[r][c]) : '';
                    const tdDecoration = [el.underline ? 'underline' : '', el.strikethrough ? 'line-through' : ''].filter(Boolean).join(' ') || 'none';
                    const showRowLinesPrev = el.showRowLines !== false;
                    const showColLinesPrev = el.showColLines !== false;
                    const colLineVisiblePrev = Array.isArray(el.colLineVisible) ? el.colLineVisible : [];
                    const lineStyle = `${bwPx}px solid ${bc}`;
                    const borderTop = r === 0 ? lineStyle : 'none';
                    const borderLeft = c === 0 ? lineStyle : 'none';
                    const borderBottom = (r === numRows - 1) ? lineStyle : (showRowLinesPrev ? lineStyle : 'none');
                    const borderRight = (c === numCols - 1) ? lineStyle : ((showColLinesPrev && colLineVisiblePrev[c] !== false) ? lineStyle : 'none');
                    return (
                      <td key={c} style={{
                        width: cws[c], height: rowHpx,
                        borderTop, borderLeft, borderBottom, borderRight,
                        paddingTop: isHdr ? headerPadTPx : padTPx, paddingLeft: padLPx, paddingRight: padRPx, paddingBottom: 0,
                        background: isHdr ? (el.headerFillColor || '#e8eaf6') : (el.fillColor || 'transparent'),
                        fontWeight: isHdr ? 700 : (el.bold ? 700 : 400),
                        fontStyle: el.italic ? 'italic' : 'normal',
                        textDecoration: tdDecoration,
                        overflow: 'hidden', textAlign: el.align || 'left',
                        color: isHdr ? (el.headerColor || el.color || '#111') : (el.color || '#111'), verticalAlign: 'middle',
                        boxSizing: 'border-box', whiteSpace: 'nowrap', textOverflow: 'ellipsis',
                      }}>{cellText}</td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
          {el.locked && <Box sx={{ position: 'absolute', top: 1, right: 2, fontSize: '8px', color: '#ff9800', lineHeight: 1, pointerEvents: 'none' }}>🔒</Box>}
          {isSelected && !el.locked && (
            <Box onMouseDown={(ev) => {
              ev.stopPropagation();
              const rect = ev.currentTarget.parentElement.parentElement.getBoundingClientRect();
              setDragState({ mode: 'resize', index, canvasRect: rect, startClientX: ev.clientX, startClientY: ev.clientY, startWidth: Number(el.width || 200), startHeight: totalH / scale, beforeElements: cloneDeep(elements) });
            }}
              sx={{ position: 'absolute', right: -4, bottom: -4, width: 10, height: 10, backgroundColor: '#1976d2', borderRadius: '2px', border: '1px solid white', cursor: 'nwse-resize' }} />
          )}
        </Box>
      );
    }

    // ── Calcular propiedades de borde para el canvas ───────────────────────────
    const canvasBorderSx = (() => {
      if (isSelected) return { border: '2px solid #1976d2' };
      // cuotas_table usa showBorder como toggle; borderColor solo define el color
      if (el.type === 'cuotas_table') {
        if (!el.showBorder) return { border: '1px dashed #aaa' };
        const bwStr = `${Math.max(0.5, Number(el.borderWidth || 0.5))}px solid ${el.borderColor || '#333'}`;
        if (el.borderRadius > 0 || (el.borderTop !== false && el.borderRight !== false && el.borderBottom !== false && el.borderLeft !== false)) {
          return { border: bwStr };
        }
        return {
          borderTop: el.borderTop !== false ? bwStr : 'none',
          borderRight: el.borderRight !== false ? bwStr : 'none',
          borderBottom: el.borderBottom !== false ? bwStr : 'none',
          borderLeft: el.borderLeft !== false ? bwStr : 'none',
        };
      }
      if (el.borderColor) {
        const bwStr = `${Number(el.borderWidth || 1)}px solid ${el.borderColor}`;
        if (el.borderRadius > 0 || (el.borderTop !== false && el.borderRight !== false && el.borderBottom !== false && el.borderLeft !== false)) {
          return { border: bwStr };
        }
        return {
          borderTop: el.borderTop !== false ? bwStr : 'none',
          borderRight: el.borderRight !== false ? bwStr : 'none',
          borderBottom: el.borderBottom !== false ? bwStr : 'none',
          borderLeft: el.borderLeft !== false ? bwStr : 'none',
        };
      }
      if (el.showBorder) {
        const bwStr = `${Number(el.borderWidth || 0.5)}px solid ${el.borderColor || '#333'}`;
        if (el.borderRadius > 0 || (el.borderTop !== false && el.borderRight !== false && el.borderBottom !== false && el.borderLeft !== false)) {
          return { border: bwStr };
        }
        return {
          borderTop: el.borderTop !== false ? bwStr : 'none',
          borderRight: el.borderRight !== false ? bwStr : 'none',
          borderBottom: el.borderBottom !== false ? bwStr : 'none',
          borderLeft: el.borderLeft !== false ? bwStr : 'none',
        };
      }
      return { border: '1px dashed #aaa' };
    })();

    return (
      <Box
        key={el.id || index}
        onMouseDown={(ev) => {
          ev.stopPropagation();
          setSelectedIndex(index);
          if (!el.locked) {
            const rect = ev.currentTarget.parentElement.getBoundingClientRect();
            const offsetX = (ev.clientX - rect.left) / scale - Number(el.x || 0);
            const offsetY = (ev.clientY - rect.top) / scale - Number(el.y || 0);
            setDragState({ mode: 'move', index, canvasRect: rect, offsetX, offsetY, beforeElements: cloneDeep(elements) });
          }
        }}
        sx={{
          position: 'absolute',
          left,
          top,
          width: w,
          height: h,
          ...canvasBorderSx,
          borderRadius: Number(el.borderRadius || 0) * scale,
          background: el.fillColor || 'rgba(255,255,255,0.85)',
          color: el.color || '#111',
          fontFamily: cssFontFamily(el),
          fontSize: `${Math.max(7, Number(el.fontSize || 9) * scale)}px`,
          fontWeight: (el.bold || (el.font && String(el.font).includes('Bold'))) ? 700 : 400,
          fontStyle: el.italic ? 'italic' : 'normal',
          display: 'flex',
          // Para texto/campo con fondo o borde (recuadros tipo "badge"), el PDF
          // real ahora centra verticalmente por defecto (ver drawBoxedText en
          // reportePdfService.js) — el preview debe reflejar lo mismo para que
          // lo que se diseña aquí coincida con lo que sale impreso.
          alignItems: ((el.type === 'text' || el.type === 'field') && !el.canGrow && (el.fillColor || el.borderColor))
            ? (el.verticalAlign === 'top' ? 'flex-start' : el.verticalAlign === 'bottom' ? 'flex-end' : 'center')
            : 'flex-start',
          justifyContent: el.align === 'center' ? 'center' : el.align === 'right' ? 'flex-end' : 'flex-start',
          paddingTop: `${Number(el.paddingTop ?? 0) * scale}px`,
          paddingBottom: `${Number(el.paddingBottom ?? 0) * scale}px`,
          paddingLeft: `${Number(el.paddingLeft ?? 0) * scale}px`,
          paddingRight: `${Number(el.paddingRight ?? 0) * scale}px`,
          cursor: 'move',
          overflow: 'hidden',
          whiteSpace: el.type === 'text' ? 'pre-wrap' : 'nowrap',
          wordBreak: el.type === 'text' ? 'break-word' : 'normal'
        }}
      >
        {el.type === 'logo' && (el.imageData || empresaLogoDataUrl)
          ? <img src={el.imageData || empresaLogoDataUrl} alt='logo' style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block', pointerEvents: 'none' }} />
          : el.type === 'image' && el.imageData
            ? <img src={el.imageData} alt='img' style={{ width: '100%', height: '100%', objectFit: el.objectFit || 'contain', display: 'block', pointerEvents: 'none', opacity: (el.opacity === undefined || el.opacity === null ? 100 : el.opacity) / 100 }} />
            : el.type === 'qr' && qrPreviewMap[el.id || index]
              ? <img src={qrPreviewMap[el.id || index]} alt='qr-preview' style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block', pointerEvents: 'none', background: '#fff' }} />
              : <span style={{ pointerEvents: 'none', width: '100%', display: 'block', textAlign: el.align || 'left', textDecoration: [el.underline ? 'underline' : '', el.strikethrough ? 'line-through' : ''].filter(Boolean).join(' ') || 'none' }}>{label}</span>
        }
        {el.locked && (
          <Box sx={{ position: 'absolute', top: 1, right: 2, fontSize: '8px', color: '#ff9800', lineHeight: 1, pointerEvents: 'none' }}>🔒</Box>
        )}
        {el.canGrow && ['text', 'field'].includes(el.type) && (
          <Box sx={{ position: 'absolute', bottom: 1, right: 2, fontSize: '8px', color: '#1976d2', lineHeight: 1, pointerEvents: 'none' }} title='Puede crecer'>↕</Box>
        )}
        {isSelected && !['detalle_table'].includes(el.type) && !el.locked && (
          <Box
            onMouseDown={(ev) => {
              ev.stopPropagation();
              const rect = ev.currentTarget.parentElement.parentElement.getBoundingClientRect();
              setDragState({
                mode: 'resize',
                index,
                canvasRect: rect,
                startClientX: ev.clientX,
                startClientY: ev.clientY,
                startWidth: Number(el.width || 100),
                startHeight: Number(el.height || 20),
                beforeElements: cloneDeep(elements)
              });
            }}
            sx={{
              position: 'absolute',
              right: -4,
              bottom: -4,
              width: 10,
              height: 10,
              backgroundColor: '#1976d2',
              borderRadius: '2px',
              border: '1px solid white',
              cursor: 'nwse-resize'
            }}
          />
        )}
      </Box>
    );
  };

  const renderFooterElementInCanvas = (el, index) => {
    const isSelected = index === footerSelectedIndex;
    if (el.type === 'line') {
      return (
        <line
          key={el.id || `fl_${index}`}
          x1={Number(el.x1 || 0) * scale} y1={Number(el.y1 || 0) * scale}
          x2={Number(el.x2 || 0) * scale} y2={Number(el.y2 || 0) * scale}
          stroke={el.color || '#999999'}
          strokeWidth={isSelected ? 3 : Math.max(1, Number(el.lineWidth || 0.5))}
          style={{ cursor: 'move' }}
          onMouseDown={(ev) => {
            ev.stopPropagation();
            setSelectedIndex(-1);
            setFooterSelectedIndex(index);
            const rect = ev.currentTarget.ownerSVGElement.getBoundingClientRect();
            const offsetX = (ev.clientX - rect.left) / scale - Number(el.x1 || 0);
            const offsetY = (ev.clientY - rect.top) / scale - Number(el.y1 || 0);
            setFooterDragState({ index, canvasRect: rect, offsetX, offsetY, beforeElements: cloneDeep(footerElements) });
          }}
        />
      );
    }
    const left = Number(el.x || 0) * scale;
    const top = Number(el.y || 0) * scale;
    const w = Math.max(20, Number(el.width || 120)) * scale;
    const h = Math.max(12, Number(el.height || 14)) * scale;
    const _now = new Date();
    const _p = (n) => String(n).padStart(2, '0');
    const _fmtDatePrev = (fmt) => { const d=_now,p=_p; const dd=p(d.getDate()),mm=p(d.getMonth()+1),yy=d.getFullYear(),y2=String(yy).slice(-2); switch(fmt){case'MM/DD/YYYY':return`${mm}/${dd}/${yy}`;case'YYYY-MM-DD':return`${yy}-${mm}-${dd}`;case'DD-MM-YYYY':return`${dd}-${mm}-${yy}`;case'DD/MM/YY':return`${dd}/${mm}/${y2}`;default:return`${dd}/${mm}/${yy}`;} };
    const _fmtTimePrev = (fmt) => { const d=_now,p=_p; const h24=p(d.getHours()),min=p(d.getMinutes()),sec=p(d.getSeconds()),hr=d.getHours()%12||12,h12=p(hr),ap=d.getHours()<12?'AM':'PM'; switch(fmt){case'HH:MM:SS':return`${h24}:${min}:${sec}`;case'hh:MM am':return`${h12}:${min} ${ap}`;case'hh:MM:SS am':return`${h12}:${min}:${sec} ${ap}`;default:return`${h24}:${min}`;} };
    const label = el.type === 'field'
      ? (el.token === 'pagina_actual' ? 'Pág: 1'
        : el.token === 'total_paginas' ? 'Total: 1'
        : el.token === 'pagina_de_total' ? 'Página 1 de 1'
        : el.token === 'fecha_impresion' ? _fmtDatePrev(el.format)
        : el.token === 'hora_impresion' ? _fmtTimePrev(el.format)
        : `{{${el.token || 'campo'}}}`)
      : el.type === 'qr' ? '[QR Code]'
      : el.type === 'hash' ? '[Hash SUNAT]'
      : el.type === 'sunat_message' ? '[Msg. SUNAT]'
      : el.type === 'grid' ? '[Grid]'
      : el.type === 'image' ? '[Imagen]'
      : (el.text || 'Texto');
    return (
      <Box
        key={el.id || `fb_${index}`}
        onMouseDown={(ev) => {
          ev.stopPropagation();
          setSelectedIndex(-1);
          setFooterSelectedIndex(index);
          const rect = ev.currentTarget.parentElement.getBoundingClientRect();
          const offsetX = (ev.clientX - rect.left) / scale - Number(el.x || 0);
          const offsetY = (ev.clientY - rect.top) / scale - Number(el.y || 0);
          setFooterDragState({ index, canvasRect: rect, offsetX, offsetY, beforeElements: cloneDeep(footerElements) });
        }}
        sx={{
          position: 'absolute', left, top, width: w, height: h,
          border: isSelected ? '2px solid #7b1fa2' : '1px dashed #9575cd',
          background: el.type === 'image' && el.imageData ? 'transparent' : 'rgba(237,231,246,0.85)',
          color: el.color || '#333',
          fontFamily: cssFontFamily(el),
          fontSize: `${Math.max(7, Number(el.fontSize || 7) * scale)}px`,
          display: 'flex', alignItems: 'center',
          justifyContent: el.align === 'center' ? 'center' : el.align === 'right' ? 'flex-end' : 'flex-start',
          px: el.type === 'image' ? 0 : 0.5, cursor: 'move', overflow: 'hidden', whiteSpace: 'nowrap'
        }}
      >
        {el.type === 'image' && el.imageData
          ? <img src={el.imageData} alt='img' style={{ width: '100%', height: '100%', objectFit: el.objectFit || 'contain', display: 'block', pointerEvents: 'none', opacity: (el.opacity === undefined || el.opacity === null ? 100 : el.opacity) / 100 }} />
          : <span style={{ pointerEvents: 'none' }}>{label}</span>}
      </Box>
    );
  };

  return (
    <Dialog open={open} onClose={(_, reason) => reason !== 'backdropClick' && onClose()} maxWidth='xl' fullWidth disableEscapeKeyDown>
      <DialogTitle>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant='h6'>Diseñador por Coordenadas X/Y</Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Tooltip title='Deshacer (Ctrl+Z)'>
              <span>
                <IconButton size='small' onClick={undo} disabled={history.length === 0}>
                  <UndoIcon />
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip title='Rehacer (Ctrl+Y)'>
              <span>
                <IconButton size='small' onClick={redo} disabled={future.length === 0}>
                  <RedoIcon />
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip title='Copiar elemento (Ctrl+C)'>
              <span>
                <IconButton size='small' onClick={() => { if (selectedIndex >= 0 && elements[selectedIndex]) clipboardRef.current = cloneDeep(elements[selectedIndex]); }} disabled={selectedIndex < 0}>
                  <ContentCopyIcon />
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip title='Pegar elemento (Ctrl+V)'>
              <span>
                <IconButton size='small' onClick={() => {
                  if (!clipboardRef.current) return;
                  const pasted = cloneDeep(clipboardRef.current);
                  pasted.id = `el_${Date.now()}_${Math.floor(Math.random() * 10000)}`;
                  if (pasted.type === 'line') {
                    pasted.x1 = clamp((Number(pasted.x1) || 0) + 10, 0, canvas.w);
                    pasted.y1 = clamp((Number(pasted.y1) || 0) + 10, 0, canvas.h);
                    pasted.x2 = clamp((Number(pasted.x2) || 0) + 10, 0, canvas.w);
                    pasted.y2 = clamp((Number(pasted.y2) || 0) + 10, 0, canvas.h);
                  } else {
                    pasted.x = clamp((Number(pasted.x) || 0) + 10, 0, canvas.w - 5);
                    pasted.y = clamp((Number(pasted.y) || 0) + 10, 0, canvas.h - 5);
                  }
                  commitElements([...elements, pasted], elements.length);
                }}>
                  <ContentPasteIcon />
                </IconButton>
              </span>
            </Tooltip>
            <TextField
              label='ID preview'
              size='small'
              value={previewId}
              onChange={(e) => setPreviewId(e.target.value)}
              disabled={useSampleData}
              sx={{ width: 110 }}
            />
            <Tooltip title={useSampleData ? 'Usando datos de muestra (sin comprobante real)' : 'Activar datos de muestra para preview sin comprobantes'}>
              <Chip
                label='Muestra'
                size='small'
                color={useSampleData ? 'warning' : 'default'}
                onClick={() => setUseSampleData((v) => !v)}
                sx={{ cursor: 'pointer', height: 28 }}
              />
            </Tooltip>
            <TextField
              select
              label='Zoom'
              size='small'
              value={zoomPct}
              onChange={(e) => setZoomPct(clampZoom(Number(e.target.value || 100)))}
              sx={{ width: 100 }}
            >
              {[50, 75, 100, 125, 150, 175, 200, 250, 300].map((z) => (
                <MenuItem key={z} value={z}>{z}%</MenuItem>
              ))}
            </TextField>
            <Tooltip title='Zoom -'>
              <span>
                <IconButton size='small' onClick={() => zoomStep(-1)}>
                  <Typography variant='caption' sx={{ fontWeight: 700 }}>-</Typography>
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip title='Zoom +'>
              <span>
                <IconButton size='small' onClick={() => zoomStep(1)}>
                  <Typography variant='caption' sx={{ fontWeight: 700 }}>+</Typography>
                </IconButton>
              </span>
            </Tooltip>
            <Button size='small' variant='outlined' onClick={() => zoomFit('width')}>Ajustar ancho</Button>
            <Button size='small' variant='outlined' onClick={() => zoomFit('page')}>Ajustar pagina</Button>
            <Tooltip title={useSampleData ? 'Ver PDF real requiere un comprobante guardado: desactiva "Muestra" o usa el botón de Preview WYSIWYG' : 'Ver PDF real'}>
              <span>
                <IconButton size='small' disabled={useSampleData} onClick={async () => {
                  try {
                    const token = localStorage.getItem('token');
                    const resp = await fetch(`/api/reporte-pdf/comprobante/${previewId}?formato=${formato}&mode=inline`, {
                      headers: { 'Authorization': `Bearer ${token}` }
                    });
                    if (!resp.ok) { alert('Error al generar PDF: ' + resp.status); return; }
                    const blob = await resp.blob();
                    const url = URL.createObjectURL(blob);
                    window.open(url, '_blank');
                  } catch (e) { alert('Error al abrir PDF: ' + e.message); }
                }}>
                  <VisibilityIcon />
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip title='Preview WYSIWYG real (PDF del backend)'>
              <span>
                <IconButton size='small' onClick={() => generatePreview()} disabled={previewLoading}>
                  {previewLoading ? <CircularProgress size={18} /> : <PreviewIcon />}
                </IconButton>
              </span>
            </Tooltip>
            <Chip
              label={autoPreview ? 'Auto ON' : 'Auto OFF'}
              size='small'
              color={autoPreview ? 'success' : 'default'}
              onClick={() => setAutoPreview((v) => !v)}
              sx={{ cursor: 'pointer', height: 28 }}
            />
            <Chip
              label={compareMode ? 'Comparar ON' : 'Comparar OFF'}
              size='small'
              color={compareMode ? 'primary' : 'default'}
              onClick={async () => {
                const next = !compareMode;
                setCompareMode(next);
                if (next && !previewBlobUrl) {
                  await generatePreview();
                }
              }}
              sx={{ cursor: 'pointer', height: 28 }}
            />
          </Box>
        </Box>
      </DialogTitle>

      <DialogContent>
        {/* Panel de preview real WYSIWYG */}
        {previewOpen && previewBlobUrl && !compareMode && (
          <Box sx={{ mb: 2, border: '2px solid #4caf50', borderRadius: 1, overflow: 'hidden' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 1.5, py: 0.5, bgcolor: '#e8f5e9' }}>
              <Typography variant='subtitle2' sx={{ fontWeight: 700, color: '#2e7d32' }}>
                Preview real del PDF — {useSampleData ? 'Datos de muestra' : `ID comprobante: ${previewId}`}. Presiona el icono preview para actualizar.
              </Typography>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Tooltip title='Actualizar preview'>
                  <span>
                    <IconButton size='small' onClick={() => generatePreview()} disabled={previewLoading}>
                      {previewLoading ? <CircularProgress size={16} /> : <RefreshIcon fontSize='small' />}
                    </IconButton>
                  </span>
                </Tooltip>
                <Button size='small' onClick={() => setPreviewOpen(false)}>Cerrar</Button>
              </Box>
            </Box>
            <iframe
              src={previewBlobUrl}
              title='PDF Preview'
              style={{ width: '100%', height: 560, border: 'none', display: 'block' }}
            />
          </Box>
        )}
        <Box>
          {/* Fila 1: Biblioteca de elementos (ancho completo) */}
          <Box sx={{ mb: 2 }}>
            <Card variant='outlined'>
              <CardContent>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'flex-start' }}>
                  {/* Columna A: botones y controles */}
                  <Box sx={{ flex: '1 1 260px', minWidth: 220 }}>
                    <Typography variant='subtitle2' sx={{ fontWeight: 700, mb: 1 }}>1) Biblioteca de elementos</Typography>
                    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 0.5, mb: 1.5 }}>
                      {['text', 'field', 'rect', 'grupo', 'line', 'logo', 'image', 'grid', 'detalle_table', 'totales', 'cuotas_table', 'detalle_totales', 'qr', 'hash', 'sunat_message'].map((t) => (
                        <Button key={t} size='small' variant='outlined' onClick={() => addElement(t)} sx={{ fontSize: '0.62rem', px: 0.5, minWidth: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                          {t}
                        </Button>
                      ))}
                    </Box>
                    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 80px', gap: 1, mb: 1 }}>
                      <Button size='small' variant={snapEnabled ? 'contained' : 'outlined'} onClick={() => setSnapEnabled((v) => !v)}>
                        Snap {snapEnabled ? 'ON' : 'OFF'}
                      </Button>
                      <TextField size='small' label='Grid' type='number' value={gridSize} onChange={(e) => setGridSize(Math.max(1, Number(e.target.value || 1)))} />
                    </Box>
                    <Box sx={{ display: 'flex', gap: 1, mb: 1.5 }}>
                      <Button fullWidth size='small' variant='contained' onClick={applySample}>Cargar layout base</Button>
                      <Button fullWidth size='small' variant='outlined' onClick={duplicateSelected} disabled={selectedIndex < 0}>Duplicar</Button>
                      <Button fullWidth size='small' variant='outlined' color='error' onClick={removeSelected} disabled={selectedIndex < 0} startIcon={<DeleteIcon />}>Eliminar</Button>
                    </Box>
                    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1 }}>
                      <Button size='small' variant='outlined' onClick={exportLayoutJson}>Exportar JSON</Button>
                      <Button size='small' variant='outlined' onClick={importLayoutJson}>Importar JSON</Button>
                    </Box>
                  </Box>

                  {/* Columna B: capas */}
                  <Box sx={{ flex: '1 1 220px', minWidth: 200 }}>
                    <Typography variant='subtitle2' sx={{ fontWeight: 700, mb: 0.5 }}>2) Capas del layout</Typography>
                    <Typography variant='caption' sx={{ display: 'block', mb: 0.75, color: 'text.secondary' }}>
                      Orden = prioridad de renderizado.<br />Con &quot;Seguir anterior&quot;, los de arriba se imprimen primero.
                    </Typography>
                    <List dense sx={{ maxHeight: 180, overflowY: 'auto', border: '1px solid #e0e0e0', borderRadius: 1 }}>
                      {elements.map((el, i) => (
                        <ListItem key={el.id || i} disablePadding>
                          <ListItemButton selected={i === selectedIndex} onClick={() => setSelectedIndex(i)}>
                            <ListItemText
                              primary={`${i + 1}. ${el.type}${el.locked ? ' 🔒' : ''}`}
                              secondary={el.type === 'field' ? el.token : el.type === 'text' ? el.text : `x:${el.x ?? el.x1}, y:${el.y ?? el.y1}`}
                            />
                          </ListItemButton>
                        </ListItem>
                      ))}
                    </List>
                    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 0.75, mt: 0.75 }}>
                      <Button size='small' variant='outlined' onClick={() => moveLayer('up')} disabled={selectedIndex < 0}>Subir capa</Button>
                      <Button size='small' variant='outlined' onClick={() => moveLayer('down')} disabled={selectedIndex < 0}>Bajar capa</Button>
                      <Button size='small' variant='outlined' onClick={() => moveLayer('top')} disabled={selectedIndex < 0}>Enviar al frente</Button>
                      <Button size='small' variant='outlined' onClick={() => moveLayer('bottom')} disabled={selectedIndex < 0}>Enviar atras</Button>
                    </Box>
                  </Box>

                  {/* Columna C: catalogo y atajos */}
                  <Box sx={{ flex: '1 1 260px', minWidth: 220 }}>
                    <Typography variant='subtitle2' sx={{ fontWeight: 700, mb: 1 }}>3) Catálogo de campos (DB)</Typography>
                    <TextField
                      select
                      fullWidth
                      size='small'
                      label='Insertar token en elemento seleccionado'
                      disabled={!selected || (selected.type !== 'field' && selected.type !== 'text')}
                      value=''
                      onChange={(e) => {
                        const token = e.target.value;
                        if (!token) return;
                        if (selected?.type === 'field') updateSelected({ token });
                        if (selected?.type === 'text') updateSelected({ text: `${selected.text || ''} {{${token}}}`.trim() });
                      }}
                    >
                      {catalogGroups.flatMap((group) => ([
                        <ListSubheader key={`sub_${group.key}`}>{group.label}</ListSubheader>,
                        ...group.tokens.map((token) => (
                          <MenuItem key={token} value={token}>{`${tokenMetaMap.get(token) || humanizeTokenLabel(token)} · ${token}`}</MenuItem>
                        ))
                      ]))}
                    </TextField>
                    <Alert severity='info' sx={{ mt: 1, '& .MuiAlert-message': { fontSize: '0.72rem' } }}>
                      <b>Ctrl+C/V</b> copiar/pegar &nbsp;<b>Ctrl+Z/Y</b> deshacer/rehacer &nbsp;<b>Delete</b> eliminar<br />
                      <b>Flechas</b> mover &nbsp;<b>Alt+←</b> 1px &nbsp;<b>Shift+←</b> 10px &nbsp;Historial: {history.length} pasos.
                    </Alert>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Box>

          {/* Fila 2: Canvas + Propiedades */}
          <Box sx={{ display: { xs: 'block', md: 'flex' }, gap: 2, alignItems: 'flex-start' }}>
            <Box sx={{ flex: '1 1 0', minWidth: 0, overflow: 'hidden', mb: { xs: 2, md: 0 } }}>

            {/* ── Barra de páginas ─────────────────────────────────────────── */}
            <Card variant='outlined' sx={{ mb: 1 }}>
              <CardContent sx={{ py: '6px !important', px: 1.5 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, flexWrap: 'wrap' }}>
                  <Typography variant='caption' sx={{ fontWeight: 700, mr: 0.5, color: '#555' }}>Páginas:</Typography>
                  {/* Pestaña página principal */}
                  <Chip
                    label='Pág. 1 — Principal'
                    size='small'
                    color={activePageIdx === 0 ? 'primary' : 'default'}
                    onClick={() => switchPage(0)}
                    sx={{ cursor: 'pointer', fontWeight: activePageIdx === 0 ? 700 : 400 }}
                  />
                  {/* Pestañas páginas adicionales */}
                  {extraPagesInfo.map((ep, i) => (
                    <Chip
                      key={ep.id}
                      label={`Pág. ${i + 2} — ${ep.nombre}`}
                      size='small'
                      color={activePageIdx === i + 1 ? 'primary' : 'default'}
                      onClick={() => switchPage(i + 1)}
                      onDelete={() => deleteExtraPage(i + 1)}
                      sx={{ cursor: 'pointer', fontWeight: activePageIdx === i + 1 ? 700 : 400 }}
                    />
                  ))}
                  <Tooltip title='Agregar hoja adicional al PDF'>
                    <Button
                      size='small'
                      variant='outlined'
                      onClick={addExtraPage}
                      startIcon={<AddBoxIcon />}
                      sx={{ ml: 0.5, fontSize: '0.7rem', py: 0.25, px: 1 }}
                    >
                      Agregar página
                    </Button>
                  </Tooltip>
                  {/* Renombrar página adicional activa */}
                  {activePageIdx > 0 && (
                    <TextField
                      size='small'
                      label='Nombre de esta hoja'
                      value={extraPagesInfo[activePageIdx - 1]?.nombre || ''}
                      onChange={(e) => renameExtraPage(activePageIdx, e.target.value)}
                      sx={{ ml: 1, width: 190 }}
                      inputProps={{ maxLength: 60 }}
                    />
                  )}
                </Box>
              </CardContent>
            </Card>
            <Card variant='outlined'>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                  <Typography variant='subtitle2' sx={{ fontWeight: 700 }}>Canvas {formato} ({canvas.w} x {canvas.h})</Typography>
                  <Typography variant='caption' color='text.secondary'>Escala base {Math.round(SCALE * 100)}% · Zoom {zoomPct}% · Vista {Math.round(scale * 100)}% | {snapEnabled ? `Snap ${gridSize}px` : 'Snap OFF'} | X:{mousePos.x ?? '-'} Y:{mousePos.y ?? '-'}</Typography>
                </Box>
                {compareMode ? (
                  <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1 }}>
                    <Box
                      sx={{
                        position: 'relative',
                        width: '100%',
                        minHeight: canvasH,
                        backgroundImage: 'linear-gradient(#f2f2f2 1px, transparent 1px), linear-gradient(90deg, #f2f2f2 1px, transparent 1px)',
                        backgroundSize: '10px 10px',
                        border: '1px solid #bdbdbd',
                        overflow: 'auto',
                        cursor: dragState ? 'grabbing' : 'default'
                      }}
                      onMouseDown={() => setSelectedIndex(-1)}
                      onWheel={handleCanvasWheel}
                      onMouseMove={(ev) => {
                        const rect = ev.currentTarget.getBoundingClientRect();
                        const x = clamp(Math.round((ev.clientX - rect.left) / scale), 0, canvas.w);
                        const y = clamp(Math.round((ev.clientY - rect.top) / scale), 0, canvas.h);
                        setMousePos({ x, y, inside: true });
                      }}
                      onMouseLeave={() => setMousePos({ x: null, y: null, inside: false })}
                    >
                      <Box sx={{ position: 'relative', width: canvasW, height: canvasH }}>
                        <svg width={canvasW} height={canvasH} style={{ position: 'absolute', inset: 0, pointerEvents: 'auto' }}>
                          {elements.map((el, idx) => el.type === 'line' ? renderElementInCanvas(el, idx) : null)}
                          {guides.v.map((g, i) => (
                            <line key={`gv${i}`} x1={g.x} y1={g.y1} x2={g.x} y2={g.y2} stroke='#ff5722' strokeWidth={1} strokeDasharray='4 3' style={{ pointerEvents: 'none' }} />
                          ))}
                          {guides.h.map((g, i) => (
                            <line key={`gh${i}`} x1={g.x1} y1={g.y} x2={g.x2} y2={g.y} stroke='#ff5722' strokeWidth={1} strokeDasharray='4 3' style={{ pointerEvents: 'none' }} />
                          ))}
                          {mousePos.inside && mousePos.x !== null && mousePos.y !== null && (
                            <>
                              <line x1={mousePos.x * scale} y1={0} x2={mousePos.x * scale} y2={canvasH} stroke='#1976d2' strokeWidth={1} strokeDasharray='3 3' style={{ pointerEvents: 'none' }} />
                              <line x1={0} y1={mousePos.y * scale} x2={canvasW} y2={mousePos.y * scale} stroke='#1976d2' strokeWidth={1} strokeDasharray='3 3' style={{ pointerEvents: 'none' }} />
                            </>
                          )}
                        </svg>
                        {elements.map((el, idx) => el.type !== 'line' ? renderElementInCanvas(el, idx) : null)}
                      </Box>
                    </Box>
                    <Box sx={{ border: '1px solid #bdbdbd', minHeight: canvasH, bgcolor: '#fafafa', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      {!previewBlobUrl ? (
                        <Button variant='outlined' startIcon={<PreviewIcon />} onClick={() => generatePreview()} disabled={previewLoading}>
                          {previewLoading ? 'Generando...' : 'Generar preview real'}
                        </Button>
                      ) : (
                        <iframe
                          src={previewBlobUrl}
                          title='PDF Compare'
                          style={{ width: '100%', height: Math.max(520, canvasH), border: 'none', display: 'block' }}
                        />
                      )}
                    </Box>
                  </Box>
                ) : (
                  <Box
                    sx={{
                      position: 'relative',
                      width: canvasW,
                      height: canvasH,
                      backgroundImage: 'linear-gradient(#f2f2f2 1px, transparent 1px), linear-gradient(90deg, #f2f2f2 1px, transparent 1px)',
                      backgroundSize: '10px 10px',
                      border: '1px solid #bdbdbd',
                      mx: 'auto',
                      overflow: 'hidden',
                      cursor: dragState ? 'grabbing' : 'default'
                    }}
                    onMouseDown={() => setSelectedIndex(-1)}
                    onWheel={handleCanvasWheel}
                    onMouseMove={(ev) => {
                      const rect = ev.currentTarget.getBoundingClientRect();
                      const x = clamp(Math.round((ev.clientX - rect.left) / scale), 0, canvas.w);
                      const y = clamp(Math.round((ev.clientY - rect.top) / scale), 0, canvas.h);
                      setMousePos({ x, y, inside: true });
                    }}
                    onMouseLeave={() => setMousePos({ x: null, y: null, inside: false })}
                  >
                    <svg width={canvasW} height={canvasH} style={{ position: 'absolute', inset: 0, pointerEvents: 'auto' }}>
                      {elements.map((el, idx) => el.type === 'line' ? renderElementInCanvas(el, idx) : null)}
                      {guides.v.map((g, i) => (
                        <line key={`gv${i}`} x1={g.x} y1={g.y1} x2={g.x} y2={g.y2} stroke='#ff5722' strokeWidth={1} strokeDasharray='4 3' style={{ pointerEvents: 'none' }} />
                      ))}
                      {guides.h.map((g, i) => (
                        <line key={`gh${i}`} x1={g.x1} y1={g.y} x2={g.x2} y2={g.y} stroke='#ff5722' strokeWidth={1} strokeDasharray='4 3' style={{ pointerEvents: 'none' }} />
                      ))}
                      {mousePos.inside && mousePos.x !== null && mousePos.y !== null && (
                        <>
                          <line x1={mousePos.x * scale} y1={0} x2={mousePos.x * scale} y2={canvasH} stroke='#1976d2' strokeWidth={1} strokeDasharray='3 3' style={{ pointerEvents: 'none' }} />
                          <line x1={0} y1={mousePos.y * scale} x2={canvasW} y2={mousePos.y * scale} stroke='#1976d2' strokeWidth={1} strokeDasharray='3 3' style={{ pointerEvents: 'none' }} />
                        </>
                      )}
                    </svg>
                    {elements.map((el, idx) => el.type !== 'line' ? renderElementInCanvas(el, idx) : null)}
                  </Box>
                )}
                {/* ── Zona de Pie de Página ──────────────────────────────────── */}
                {!compareMode && footerEnabled && (
                  <Box sx={{ mx: 'auto', width: canvasW, mt: 0 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, bgcolor: '#ede7f6', borderTop: '2px dashed #9575cd', px: 1, py: 0.5 }}>
                      <Typography sx={{ fontSize: '0.65rem', color: '#7b1fa2', fontWeight: 700 }}>
                        ▼ PIE DE PÁGINA — {footerHeight}pt — se repite en todas las páginas
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        position: 'relative',
                        width: canvasW,
                        height: footerCanvasH,
                        backgroundColor: '#f3e5f5',
                        border: '1px dashed #9575cd',
                        overflow: 'hidden',
                        cursor: footerDragState ? 'grabbing' : 'default'
                      }}
                      onMouseDown={(ev) => { if (ev.target === ev.currentTarget) setFooterSelectedIndex(-1); }}
                    >
                      <svg width={canvasW} height={footerCanvasH} style={{ position: 'absolute', inset: 0, pointerEvents: 'auto' }}>
                        {footerElements.map((el, idx) => el.type === 'line' ? renderFooterElementInCanvas(el, idx) : null)}
                      </svg>
                      {footerElements.map((el, idx) => el.type !== 'line' ? renderFooterElementInCanvas(el, idx) : null)}
                    </Box>
                  </Box>
                )}
              </CardContent>
            </Card>
            </Box>

          <Box sx={{ flex: '1 1 0', minWidth: 0, overflow: 'auto' }}>
            <Card variant='outlined'>
              <CardContent>
                <Typography variant='subtitle2' sx={{ fontWeight: 700, mb: 1 }}>Propiedades</Typography>
                {formato === 'T80' && (
                  <Box sx={{ border: '1px solid #e0e0e0', borderRadius: 1, p: 1, mb: 1 }}>
                    <Typography variant='caption' sx={{ fontWeight: 700, display: 'block', mb: 0.75 }}>
                      Alto de hoja (Ticket)
                    </Typography>
                    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75 }}>
                      <TextField
                        select
                        label='Modo'
                        size='small'
                        value={config.pageHeightMode || 'fixed'}
                        onChange={(e) => setConfig((prev) => ({ ...prev, pageHeightMode: e.target.value }))}
                      >
                        <MenuItem value='fixed'>Fijo</MenuItem>
                        <MenuItem value='auto'>Auto (recorta)</MenuItem>
                      </TextField>
                      {(config.pageHeightMode || 'fixed') === 'fixed' ? (
                        <TextField
                          label='Alto fijo (pt)'
                          size='small'
                          type='number'
                          value={config.pageFixedHeight ?? 1000}
                          onChange={(e) => setConfig((prev) => ({ ...prev, pageFixedHeight: Math.max(80, Number(e.target.value || 1000)) }))}
                        />
                      ) : (
                        <TextField
                          label='Padding inferior'
                          size='small'
                          type='number'
                          value={config.pageBottomPadding ?? 8}
                          onChange={(e) => setConfig((prev) => ({ ...prev, pageBottomPadding: Math.max(0, Number(e.target.value || 0)) }))}
                        />
                      )}
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 0.75 }}>
                      <Typography variant='caption' sx={{ color: '#555' }}>Alto contraste térmica</Typography>
                      <Switch
                        size='small'
                        checked={!!config.alto_contraste_termico}
                        onChange={(e) => setConfig((prev) => ({ ...prev, alto_contraste_termico: e.target.checked }))}
                      />
                    </Box>
                    <Typography variant='caption' sx={{ color: '#888', display: 'block', fontSize: '0.65rem' }}>
                      Fuerza colores grises a negro para mejor impresión térmica
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 0.75 }}>
                      <Typography variant='caption' sx={{ color: '#555' }}>Super alto contraste</Typography>
                      <Switch
                        size='small'
                        checked={!!config.super_alto_contraste_termico}
                        onChange={(e) => setConfig((prev) => ({ ...prev, super_alto_contraste_termico: e.target.checked }))}
                      />
                    </Box>
                    <Typography variant='caption' sx={{ color: '#888', display: 'block', fontSize: '0.65rem' }}>
                      Todo en negro + negrita (máximo contraste térmico)
                    </Typography>
                  </Box>
                )}
                {/* ── Pie de Página ─────────────────────────────────────────────── */}
                <Box sx={{ border: '1px solid #ce93d8', borderRadius: 1, p: 1, mb: 1 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: footerEnabled ? 0.75 : 0 }}>
                    <Typography variant='caption' sx={{ fontWeight: 700, color: '#7b1fa2' }}>Pie de página</Typography>
                    <Switch size='small' checked={footerEnabled}
                      onChange={(e) => setConfig(prev => ({
                        ...prev,
                        footer: { enabled: e.target.checked, height: footerHeight, elements: footerElements }
                      }))}
                    />
                  </Box>
                  {footerEnabled && (
                    <>
                      <TextField size='small' label='Alto (pt)' type='number' fullWidth
                        value={footerHeight} sx={{ mb: 0.75 }}
                        onChange={(e) => setFooterConfig({ height: Math.max(15, Number(e.target.value || 40)) })}
                      />
                      <Typography variant='caption' sx={{ display: 'block', mb: 0.5, color: '#555' }}>
                        Agregar al pie: <span style={{ color: '#7b1fa2', fontWeight: 700 }}>({footerElements.length} elemento{footerElements.length !== 1 ? 's' : ''})</span>
                      </Typography>
                      <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', mb: 1 }}>
                        <Button size='small' variant='outlined' color='secondary' onClick={() => addFooterElement('line')}>Línea</Button>
                        <Button size='small' variant='outlined' color='secondary' onClick={() => addFooterElement('text')}>Texto</Button>
                        <Button size='small' variant='outlined' color='secondary' onClick={() => addFooterElement('field')}>Campo</Button>
                        <Button size='small' variant='outlined' color='secondary' onClick={() => addFooterElement('qr')}>QR</Button>
                        <Button size='small' variant='outlined' color='secondary' onClick={() => addFooterElement('hash')}>Hash</Button>
                        <Button size='small' variant='outlined' color='secondary' onClick={() => addFooterElement('sunat_message')}>Msg SUNAT</Button>
                        <Button size='small' variant='outlined' color='secondary' onClick={() => addFooterElement('grid')}>Grid</Button>
                        <Button size='small' variant='outlined' color='secondary' onClick={() => addFooterElement('image')}>Imagen</Button>
                      </Box>
                      {footerElements.length > 0 && !footerSelected && (
                        <Typography variant='caption' sx={{ display: 'block', mb: 0.5, color: '#888', fontStyle: 'italic' }}>
                          Haz clic en un elemento del pie para seleccionarlo y editarlo.
                        </Typography>
                      )}
                      {footerSelected && (
                        <Box sx={{ display: 'grid', gap: 0.75 }}>
                          <Typography variant='caption' sx={{ fontWeight: 700, color: '#7b1fa2' }}>Elemento seleccionado (pie)</Typography>
                          {footerSelected.type === 'line' ? (
                            <>
                              <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.5 }}>
                                <TextField size='small' label='x1' type='number' value={footerSelected.x1 ?? 0} onChange={(e) => updateFooterSelected({ x1: Number(e.target.value) })} />
                                <TextField size='small' label='y1' type='number' value={footerSelected.y1 ?? 0} onChange={(e) => updateFooterSelected({ y1: Number(e.target.value) })} />
                                <TextField size='small' label='x2' type='number' value={footerSelected.x2 ?? 0} onChange={(e) => updateFooterSelected({ x2: Number(e.target.value) })} />
                                <TextField size='small' label='y2' type='number' value={footerSelected.y2 ?? 0} onChange={(e) => updateFooterSelected({ y2: Number(e.target.value) })} />
                              </Box>
                              <TextField size='small' label='Grosor' type='number'
                                value={footerSelected.lineWidth ?? 0.5}
                                onChange={(e) => updateFooterSelected({ lineWidth: Number(e.target.value) })} />
                              <TextField size='small' label='Color' value={footerSelected.color || '#999999'}
                                onChange={(e) => updateFooterSelected({ color: e.target.value })} />
                            </>
                          ) : (
                            <>
                              <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.5 }}>
                                <TextField size='small' label='X' type='number' value={footerSelected.x ?? 0} onChange={(e) => updateFooterSelected({ x: Number(e.target.value) })} />
                                <TextField size='small' label='Y' type='number' value={footerSelected.y ?? 0} onChange={(e) => updateFooterSelected({ y: Number(e.target.value) })} />
                                <TextField size='small' label='Width' type='number' value={footerSelected.width ?? 120} onChange={(e) => updateFooterSelected({ width: Math.max(10, Number(e.target.value)) })} />
                                <TextField size='small' label='Height' type='number' value={footerSelected.height ?? 14} onChange={(e) => updateFooterSelected({ height: Math.max(5, Number(e.target.value)) })} />
                                {!['qr', 'grid', 'image'].includes(footerSelected.type) && (
                                  <TextField size='small' label='Font Size' type='number' value={footerSelected.fontSize ?? 7} onChange={(e) => updateFooterSelected({ fontSize: Number(e.target.value) })} />
                                )}
                              </Box>
                              {!['qr', 'grid', 'image'].includes(footerSelected.type) && (
                                <TextField size='small' select label='Alineación'
                                  value={footerSelected.align || 'left'}
                                  onChange={(e) => updateFooterSelected({ align: e.target.value })}>
                                  <MenuItem value='left'>Izquierda</MenuItem>
                                  <MenuItem value='center'>Centro</MenuItem>
                                  <MenuItem value='right'>Derecha</MenuItem>
                                </TextField>
                              )}
                              {!['qr', 'image'].includes(footerSelected.type) && (
                                <TextField size='small' label='Color' value={footerSelected.color || '#555555'}
                                  onChange={(e) => updateFooterSelected({ color: e.target.value })} />
                              )}
                              {footerSelected.type === 'image' && (
                                <Box sx={{ border: '1px solid #e8e8e8', borderRadius: 1, p: 0.75 }}>
                                  <Typography variant='caption' sx={{ fontWeight: 700, display: 'block', mb: 0.5 }}>Imagen del pie</Typography>
                                  <input
                                    type='file'
                                    accept='image/*'
                                    style={{ display: 'block', width: '100%', marginBottom: 6 }}
                                    onChange={(ev) => {
                                      const file = ev.target.files[0];
                                      if (!file) return;
                                      const reader = new FileReader();
                                      reader.onload = () => updateFooterSelected({ imageData: reader.result });
                                      reader.readAsDataURL(file);
                                    }}
                                  />
                                  {footerSelected.imageData && (
                                    <>
                                      <img
                                        src={footerSelected.imageData}
                                        alt='preview'
                                        style={{ maxWidth: '100%', maxHeight: 60, marginBottom: 6, border: '1px solid #e0e0e0', borderRadius: 4, objectFit: 'contain' }}
                                      />
                                      <Button fullWidth size='small' color='error' variant='outlined' onClick={() => updateFooterSelected({ imageData: null })} sx={{ mb: 0.75 }}>
                                        Quitar imagen
                                      </Button>
                                    </>
                                  )}
                                  <TextField
                                    select
                                    label='Ajuste de imagen'
                                    size='small'
                                    fullWidth
                                    sx={{ mb: 0.75 }}
                                    value={footerSelected.objectFit || 'contain'}
                                    onChange={(e) => updateFooterSelected({ objectFit: e.target.value })}
                                  >
                                    <MenuItem value='contain'>Contener (sin recortar)</MenuItem>
                                    <MenuItem value='cover'>Cubrir (recorta)</MenuItem>
                                  </TextField>
                                  <TextField
                                    label='Opacidad (%)'
                                    size='small'
                                    type='number'
                                    fullWidth
                                    inputProps={{ min: 0, max: 100 }}
                                    value={footerSelected.opacity ?? 100}
                                    onChange={(e) => updateFooterSelected({ opacity: Math.max(0, Math.min(100, Number(e.target.value ?? 100))) })}
                                  />
                                  <Typography variant='caption' sx={{ mt: 0.5, mb: 0.5, display: 'block', color: 'text.secondary' }}>
                                    Pegar a esquina del pie:
                                  </Typography>
                                  <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 0.5 }}>
                                    <Button size='small' variant='outlined' onClick={() => alignFooterSelectedToBox('left')}>Izq</Button>
                                    <Button size='small' variant='outlined' onClick={() => alignFooterSelectedToBox('right')}>Der</Button>
                                    <Button size='small' variant='outlined' onClick={() => alignFooterSelectedToBox('top')}>Sup</Button>
                                    <Button size='small' variant='outlined' onClick={() => alignFooterSelectedToBox('bottom')}>Inf</Button>
                                  </Box>
                                </Box>
                              )}
                              {footerSelected.type === 'field' && (
                                <>
                                  <TextField size='small' select label='Token'
                                    value={footerSelected.token || 'fecha_impresion'}
                                    onChange={(e) => updateFooterSelected({ token: e.target.value, format: undefined })}>
                                    <MenuItem value='pagina_de_total'>Página X de Y (combinado)</MenuItem>
                                    <MenuItem value='pagina_actual'>Página actual (1, 2…)</MenuItem>
                                    <MenuItem value='total_paginas'>Total de páginas</MenuItem>
                                    <MenuItem value='fecha_impresion'>Fecha impresión</MenuItem>
                                    <MenuItem value='hora_impresion'>Hora impresión</MenuItem>
                                  </TextField>
                                  {footerSelected.token === 'fecha_impresion' && (
                                    <TextField size='small' select label='Formato fecha'
                                      value={footerSelected.format || 'DD/MM/YYYY'}
                                      onChange={(e) => updateFooterSelected({ format: e.target.value })}>
                                      <MenuItem value='DD/MM/YYYY'>DD/MM/YYYY</MenuItem>
                                      <MenuItem value='DD/MM/YY'>DD/MM/YY</MenuItem>
                                      <MenuItem value='MM/DD/YYYY'>MM/DD/YYYY</MenuItem>
                                      <MenuItem value='YYYY-MM-DD'>YYYY-MM-DD</MenuItem>
                                      <MenuItem value='DD-MM-YYYY'>DD-MM-YYYY</MenuItem>
                                    </TextField>
                                  )}
                                  {footerSelected.token === 'hora_impresion' && (
                                    <TextField size='small' select label='Formato hora'
                                      value={footerSelected.format || 'HH:MM'}
                                      onChange={(e) => updateFooterSelected({ format: e.target.value })}>
                                      <MenuItem value='HH:MM'>HH:MM (24h)</MenuItem>
                                      <MenuItem value='HH:MM:SS'>HH:MM:SS (24h + segundos)</MenuItem>
                                      <MenuItem value='hh:MM am'>hh:MM AM/PM (12h)</MenuItem>
                                      <MenuItem value='hh:MM:SS am'>hh:MM:SS AM/PM (12h + seg)</MenuItem>
                                    </TextField>
                                  )}
                                </>
                              )}
                              {footerSelected.type === 'text' && (
                                <TextField size='small' label='Texto'
                                  value={footerSelected.text || ''}
                                  onChange={(e) => updateFooterSelected({ text: e.target.value })} />
                              )}
                              {footerSelected.type === 'hash' && (
                                <Alert severity='info' sx={{ '& .MuiAlert-message': { fontSize: '0.7rem' } }}>
                                  Muestra el hash/firma digital del comprobante SUNAT.
                                </Alert>
                              )}
                              {footerSelected.type === 'sunat_message' && (
                                <Alert severity='info' sx={{ '& .MuiAlert-message': { fontSize: '0.7rem' } }}>
                                  Muestra el mensaje de respuesta SUNAT del comprobante.
                                </Alert>
                              )}
                              {footerSelected.type === 'grid' && (
                                <Box sx={{ border: '1px solid #e8e8e8', borderRadius: 1, p: 0.75 }}>
                                  <Typography variant='caption' sx={{ fontWeight: 700, display: 'block', mb: 0.5 }}>Grilla (cuentas bancarias, etc.)</Typography>
                                  <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.5, mb: 0.5 }}>
                                    <TextField size='small' label='Filas' type='number' inputProps={{ min: 1, max: 10 }}
                                      value={footerSelected.rows ?? 2}
                                      onChange={(e) => {
                                        const nr = Math.max(1, Number(e.target.value || 1));
                                        const cells = Array.from({ length: nr }, (_, r) => Array.from({ length: footerSelected.cols || 3 }, (_, c) => ((footerSelected.cells || [])[r] || [])[c] || ''));
                                        updateFooterSelected({ rows: nr, cells, height: nr * (footerSelected.rowHeight || 14) });
                                      }} />
                                    <TextField size='small' label='Columnas' type='number' inputProps={{ min: 1, max: 6 }}
                                      value={footerSelected.cols ?? 3}
                                      onChange={(e) => {
                                        const nc = Math.max(1, Number(e.target.value || 1));
                                        const cells = Array.from({ length: footerSelected.rows || 2 }, (_, r) => Array.from({ length: nc }, (_, c) => ((footerSelected.cells || [])[r] || [])[c] || ''));
                                        updateFooterSelected({ cols: nc, cells });
                                      }} />
                                    <TextField size='small' label='Alto fila' type='number'
                                      value={footerSelected.rowHeight ?? 14}
                                      onChange={(e) => { const rh = Math.max(8, Number(e.target.value || 14)); updateFooterSelected({ rowHeight: rh, height: (footerSelected.rows || 2) * rh }); }} />
                                    <TextField size='small' label='Font Size' type='number'
                                      value={footerSelected.fontSize ?? 7}
                                      onChange={(e) => updateFooterSelected({ fontSize: Number(e.target.value) })} />
                                  </Box>
                                  <Typography variant='caption' sx={{ color: 'text.secondary', display: 'block', mb: 0.5 }}>Celdas</Typography>
                                  {Array.from({ length: footerSelected.rows || 2 }, (_, r) => (
                                    <Box key={r} sx={{ display: 'flex', gap: 0.5, mb: 0.5 }}>
                                      {Array.from({ length: footerSelected.cols || 3 }, (_, c) => (
                                        <TextField key={c} size='small'
                                          label={`F${r + 1}C${c + 1}`}
                                          value={((footerSelected.cells || [])[r] || [])[c] || ''}
                                          onChange={(e) => {
                                            const newCells = Array.from({ length: footerSelected.rows || 2 }, (_, ri) => [...((footerSelected.cells || [])[ri] || Array(footerSelected.cols || 3).fill(''))]);
                                            newCells[r][c] = e.target.value;
                                            updateFooterSelected({ cells: newCells });
                                          }}
                                          sx={{ minWidth: 60 }}
                                        />
                                      ))}
                                    </Box>
                                  ))}
                                </Box>
                              )}
                              <Button size='small' color='error' variant='outlined'
                                onClick={() => {
                                  setFooterElements(footerElements.filter((_, i) => i !== footerSelectedIndex));
                                  setFooterSelectedIndex(-1);
                                }}>
                                Eliminar del pie
                              </Button>
                            </>
                          )}
                        </Box>
                      )}
                    </>
                  )}
                </Box>
                {!selected ? (
                  <Alert severity='warning'>Selecciona un elemento para editar sus coordenadas y estilo.</Alert>
                ) : (
                  <Box sx={{ display: 'grid', gap: 1 }}>
                    <TextField label='Tipo' size='small' value={selected.type} disabled />
                    <Button
                      fullWidth
                      size='small'
                      variant={selected.locked ? 'contained' : 'outlined'}
                      color={selected.locked ? 'warning' : 'inherit'}
                      startIcon={selected.locked ? <LockIcon /> : <LockOpenIcon />}
                      onClick={() => updateSelected({ locked: !selected.locked })}
                      sx={{ mb: 0.5 }}
                    >
                      {selected.locked ? 'Desbloquear' : 'Bloquear elemento'}
                    </Button>

                    <Typography variant='caption' sx={{ mt: 0.5, color: 'text.secondary' }}>Alineación rápida al canvas</Typography>
                    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 0.5 }}>
                      <Button size='small' variant='outlined' onClick={() => alignSelectedToCanvas('left')}>Izq</Button>
                      <Button size='small' variant='outlined' onClick={() => alignSelectedToCanvas('centerX')}>Cen X</Button>
                      <Button size='small' variant='outlined' onClick={() => alignSelectedToCanvas('right')}>Der</Button>
                      <Button size='small' variant='outlined' onClick={() => alignSelectedToCanvas('top')}>Sup</Button>
                      <Button size='small' variant='outlined' onClick={() => alignSelectedToCanvas('centerY')}>Cen Y</Button>
                      <Button size='small' variant='outlined' onClick={() => alignSelectedToCanvas('bottom')}>Inf</Button>
                    </Box>
                    {selected.type !== 'line' && (
                      <Button size='small' variant='outlined' fullWidth onClick={stretchSelectedFullWidth} sx={{ mt: 0.5 }}>
                        Ancho de hoja (lado a lado)
                      </Button>
                    )}

                    <Typography variant='caption' sx={{ mt: 0.5, color: 'text.secondary' }}>Ir a coordenadas exactas</Typography>
                    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr auto', gap: 0.5 }}>
                      <TextField size='small' label='X destino' type='number' value={jumpX} onChange={(e) => setJumpX(e.target.value)} />
                      <TextField size='small' label='Y destino' type='number' value={jumpY} onChange={(e) => setJumpY(e.target.value)} />
                      <Button size='small' variant='contained' onClick={applyJumpCoordinates}>Ir</Button>
                    </Box>

                    {selected.type === 'line' ? (
                      <>
                        <TextField label='x1' size='small' type='number' value={selected.x1 ?? 0} onChange={(e) => updateSelected({ x1: Number(e.target.value) })} />
                        <TextField label='y1' size='small' type='number' value={selected.y1 ?? 0} onChange={(e) => updateSelected({ y1: Number(e.target.value) })} />
                        <TextField label='x2' size='small' type='number' value={selected.x2 ?? 0} onChange={(e) => updateSelected({ x2: Number(e.target.value) })} />
                        <TextField label='y2' size='small' type='number' value={selected.y2 ?? 0} onChange={(e) => updateSelected({ y2: Number(e.target.value) })} />
                        <TextField label='Grosor' size='small' type='number' value={selected.lineWidth ?? 1} onChange={(e) => updateSelected({ lineWidth: Number(e.target.value) })} />
                      </>
                    ) : (
                      <>
                        <TextField label='X' size='small' type='number' value={selected.x ?? 0} onChange={(e) => updateSelected({ x: Number(e.target.value) })} />
                        <TextField label='Y' size='small' type='number' value={selected.y ?? 0} onChange={(e) => updateSelected({ y: Number(e.target.value) })} />
                        <TextField label='Width' size='small' type='number' value={selected.width ?? 160} onChange={(e) => updateSelected({ width: Math.max(10, Number(e.target.value)) })} />
                        <TextField label='Height' size='small' type='number' value={selected.height ?? 20} onChange={(e) => updateSelected({ height: Math.max(10, Number(e.target.value)) })} />
                        <TextField label='Font Size' size='small' type='number' value={selected.fontSize ?? 9} onChange={(e) => updateSelected({ fontSize: Number(e.target.value) })} />
                      </>
                    )}

                    {selected.type === 'detalle_table' && (
                      <Box sx={{ border: '1px solid #e0e0e0', borderRadius: 1, p: 1 }}>
                        <Typography variant='caption' sx={{ fontWeight: 700, display: 'block', mb: 0.75 }}>
                          Configuracion de tabla detalle
                        </Typography>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mb: 1 }}>
                          <TextField
                            label='Alto fila'
                            size='small'
                            type='number'
                            value={selected.rowHeight ?? 16}
                            onChange={(e) => updateSelected({ rowHeight: Math.max(10, Number(e.target.value || 16)) })}
                          />
                          <TextField
                            label='Alto cabecera'
                            size='small'
                            type='number'
                            value={selected.headerHeight ?? 18}
                            onChange={(e) => updateSelected({ headerHeight: Math.max(10, Number(e.target.value || 18)) })}
                          />
                        </Box>

                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mb: 1 }}>
                          <TextField
                            label='Padding superior fila'
                            size='small'
                            type='number'
                            value={selected.rowPaddingTop ?? 0}
                            onChange={(e) => updateSelected({ rowPaddingTop: Math.max(0, Number(e.target.value || 0)) })}
                          />
                          <TextField
                            label='Padding inferior fila'
                            size='small'
                            type='number'
                            value={selected.rowPaddingBottom ?? 2}
                            onChange={(e) => updateSelected({ rowPaddingBottom: Math.max(0, Number(e.target.value || 0)) })}
                          />
                        </Box>

                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mb: 0.75 }}>
                          <TextField
                            label='Padding top cabecera'
                            size='small'
                            type='number'
                            value={selected.headerPaddingTop ?? 2}
                            onChange={(e) => updateSelected({ headerPaddingTop: Math.max(0, Number(e.target.value || 0)) })}
                          />
                          <TextField
                            label='Padding bot cabecera'
                            size='small'
                            type='number'
                            value={selected.headerPaddingBottom ?? 2}
                            onChange={(e) => updateSelected({ headerPaddingBottom: Math.max(0, Number(e.target.value || 0)) })}
                          />
                        </Box>

                        <Box sx={{ border: '1px solid #e8e8e8', borderRadius: 1, p: 0.75, mb: 1 }}>
                          <Typography variant='caption' sx={{ fontWeight: 700, display: 'block', mb: 0.5, color: '#555' }}>Padding lateral celdas (pt)</Typography>
                          <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.5 }}>
                            <TextField size='small' type='number' label='Pad Left' value={selected.paddingLeft ?? ''} placeholder='1' onChange={(e) => updateSelected({ paddingLeft: e.target.value !== '' ? Math.max(0, Number(e.target.value)) : undefined })} />
                            <TextField size='small' type='number' label='Pad Right' value={selected.paddingRight ?? ''} placeholder='1' onChange={(e) => updateSelected({ paddingRight: e.target.value !== '' ? Math.max(0, Number(e.target.value)) : undefined })} />
                          </Box>
                        </Box>

                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mb: 1 }}>
                          <Button size='small' variant={selected.showHeader !== false ? 'contained' : 'outlined'} onClick={() => updateSelected({ showHeader: !(selected.showHeader !== false) })}>
                            Cabecera
                          </Button>
                          <Button size='small' variant={selected.showRowLine ? 'contained' : 'outlined'} onClick={() => updateSelected({ showRowLine: !selected.showRowLine })}>
                            Lineas fila
                          </Button>
                          <Button size='small' variant={selected.showOuterBorder ? 'contained' : 'outlined'} onClick={() => updateSelected({ showOuterBorder: !selected.showOuterBorder })}>
                            Borde ext.
                          </Button>
                          <ColorField label='Color borde' value={selected.borderColor || '#888888'} onChange={(v) => updateSelected({ borderColor: v })} pickerFallback='#888888' />
                        </Box>

                        {/* Zebra striping para detalle_table */}
                        <Box sx={{ mb: 1 }}>
                          <Button size='small' fullWidth variant={selected.zebraStripe ? 'contained' : 'outlined'} onClick={() => updateSelected({ zebraStripe: !selected.zebraStripe })} sx={{ mb: 0.5 }}>
                            Filas alternadas (zebra)
                          </Button>
                          {selected.zebraStripe && (
                            <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.5 }}>
                              <ColorField label='Fila par' value={selected.zebraEvenColor || '#f5f5f5'} onChange={(v) => updateSelected({ zebraEvenColor: v })} pickerFallback='#f5f5f5' />
                              <ColorField label='Fila impar' value={selected.zebraOddColor || '#ffffff'} onChange={(v) => updateSelected({ zebraOddColor: v })} pickerFallback='#ffffff' />
                            </Box>
                          )}
                        </Box>

                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mb: 1 }}>
                          <TextField
                            select
                            label='Paginacion'
                            size='small'
                            value={selected.paginationMode || 'grow'}
                            onChange={(e) => updateSelected({ paginationMode: e.target.value })}
                          >
                            <MenuItem value='grow'>Libre (crece)</MenuItem>
                            <MenuItem value='auto'>Auto por alto de hoja</MenuItem>
                            <MenuItem value='fixed'>Fijo por cantidad</MenuItem>
                          </TextField>
                          {(selected.paginationMode || 'grow') === 'fixed' ? (
                            <TextField
                              label='Items por hoja'
                              size='small'
                              type='number'
                              value={selected.maxRowsPerPage ?? 20}
                              onChange={(e) => updateSelected({ maxRowsPerPage: Math.max(1, Number(e.target.value || 20)) })}
                            />
                          ) : (
                            <TextField size='small' label='Items por hoja' value='Auto' disabled />
                          )}
                        </Box>

                        {(selected.paginationMode || 'grow') !== 'grow' && (
                          <Box sx={{ display: 'grid', gridTemplateColumns: '1fr', gap: 0.75, mb: 1 }}>
                            <Button
                              size='small'
                              variant={selected.repeatHeaderOnNewPage !== false ? 'contained' : 'outlined'}
                              onClick={() => updateSelected({ repeatHeaderOnNewPage: !(selected.repeatHeaderOnNewPage !== false) })}
                            >
                              Repetir cabecera en nueva hoja
                            </Button>
                          </Box>
                        )}

                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mb: 0.5 }}>
                          <Button
                            size='small'
                            variant={selected.showHeaderShade !== false ? 'contained' : 'outlined'}
                            onClick={() => updateSelected({ showHeaderShade: !(selected.showHeaderShade !== false) })}
                          >
                            Sombreado cabecera
                          </Button>
                          <ColorField
                            label='Color sombreado'
                            value={selected.headerFillColor || '#efefef'}
                            onChange={(value) => updateSelected({ headerFillColor: value })}
                            pickerFallback='#efefef'
                          />
                        </Box>
                        <ColorField label='Color letra cabecera' value={selected.headerColor || '#333333'} onChange={(v) => updateSelected({ headerColor: v })} pickerFallback='#333333' sx={{ mb: 1 }} />

                        <Typography variant='caption' sx={{ fontWeight: 600, display: 'block', mb: 0.75 }}>
                          Columnas mostradas
                        </Typography>
                        <Box sx={{ display: 'grid', gap: 0.75 }}>
                          {(Array.isArray(selected.columns) ? selected.columns : []).map((col, colIdx) => (
                            <Box key={`col_${colIdx}`} sx={{ border: '1px dashed #cfd8dc', borderRadius: 1, p: 0.75 }}>
                              <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mb: 0.75 }}>
                                <TextField
                                  label='Titulo'
                                  size='small'
                                  value={col.label || ''}
                                  onChange={(e) => updateDetalleTableColumns((cols) => {
                                    cols[colIdx] = { ...cols[colIdx], label: e.target.value };
                                    return cols;
                                  })}
                                />
                                <TextField
                                  label='Ancho'
                                  size='small'
                                  type='number'
                                  value={col.width ?? 70}
                                  onChange={(e) => updateDetalleTableColumns((cols) => {
                                    cols[colIdx] = { ...cols[colIdx], width: Math.max(20, Number(e.target.value || 70)) };
                                    return cols;
                                  })}
                                />
                              </Box>
                              <TextField
                                label='Token'
                                size='small'
                                fullWidth
                                value={col.token || ''}
                                onChange={(e) => updateDetalleTableColumns((cols) => {
                                  cols[colIdx] = { ...cols[colIdx], token: e.target.value };
                                  return cols;
                                })}
                                sx={{ mb: 0.75 }}
                              />
                              <TextField
                                select
                                label='Token desde catalogo (detalle)'
                                size='small'
                                fullWidth
                                value=''
                                onChange={(e) => updateDetalleTableColumns((cols) => {
                                  cols[colIdx] = { ...cols[colIdx], token: `{{${e.target.value}}}` };
                                  return cols;
                                })}
                                sx={{ mb: 0.75 }}
                              >
                                {detalleCatalogTokens.map((token) => (
                                  <MenuItem key={`dt_${token}`} value={token}>{tokenMetaMap.get(token) || humanizeTokenLabel(token)}</MenuItem>
                                ))}
                              </TextField>
                              <TextField
                                label='Formato numérico (ej: #,##0.00)'
                                size='small'
                                fullWidth
                                placeholder='Ej: #,##0.00 ó #,##0'
                                value={col.format || ''}
                                onChange={(e) => updateDetalleTableColumns((cols) => {
                                  cols[colIdx] = { ...cols[colIdx], format: e.target.value };
                                  return cols;
                                })}
                                sx={{ mb: 0.75 }}
                              />
                              <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 0.75, mb: 0.75 }}>
                                <TextField
                                  select
                                  label='Alineacion (cabecera)'
                                  size='small'
                                  value={col.headerAlign || 'center'}
                                  onChange={(e) => updateDetalleTableColumns((cols) => {
                                    cols[colIdx] = { ...cols[colIdx], headerAlign: e.target.value };
                                    return cols;
                                  })}
                                >
                                  <MenuItem value='left'>Left</MenuItem>
                                  <MenuItem value='center'>Center</MenuItem>
                                  <MenuItem value='right'>Right</MenuItem>
                                </TextField>
                                <TextField
                                  select
                                  label='Alineacion (valores)'
                                  size='small'
                                  value={col.align || 'left'}
                                  onChange={(e) => updateDetalleTableColumns((cols) => {
                                    cols[colIdx] = { ...cols[colIdx], align: e.target.value };
                                    return cols;
                                  })}
                                >
                                  <MenuItem value='left'>Left</MenuItem>
                                  <MenuItem value='center'>Center</MenuItem>
                                  <MenuItem value='right'>Right</MenuItem>
                                </TextField>
                                <Button
                                  size='small'
                                  variant={col.wrap ? 'contained' : 'outlined'}
                                  onClick={() => updateDetalleTableColumns((cols) => {
                                    cols[colIdx] = { ...cols[colIdx], wrap: !cols[colIdx]?.wrap };
                                    return cols;
                                  })}
                                >
                                  Multi
                                </Button>
                              </Box>
                              <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 0.75 }}>
                                <Button
                                  size='small'
                                  variant='outlined'
                                  disabled={colIdx === 0}
                                  onClick={() => updateDetalleTableColumns((cols) => {
                                    if (colIdx <= 0) return cols;
                                    [cols[colIdx - 1], cols[colIdx]] = [cols[colIdx], cols[colIdx - 1]];
                                    return cols;
                                  })}
                                >
                                  <ArrowUpwardIcon fontSize='small' />
                                </Button>
                                <Button
                                  size='small'
                                  variant='outlined'
                                  disabled={colIdx === (Array.isArray(selected.columns) ? selected.columns.length - 1 : 0)}
                                  onClick={() => updateDetalleTableColumns((cols) => {
                                    if (colIdx >= cols.length - 1) return cols;
                                    [cols[colIdx + 1], cols[colIdx]] = [cols[colIdx], cols[colIdx + 1]];
                                    return cols;
                                  })}
                                >
                                  <ArrowDownwardIcon fontSize='small' />
                                </Button>
                                <Button
                                  size='small'
                                  color='error'
                                  variant='outlined'
                                  onClick={() => updateDetalleTableColumns((cols) => cols.filter((_, i) => i !== colIdx))}
                                >
                                  Quitar
                                </Button>
                              </Box>
                            </Box>
                          ))}
                        </Box>
                        <Button
                          size='small'
                          startIcon={<AddBoxIcon />}
                          variant='outlined'
                          sx={{ mt: 0.75 }}
                          onClick={() => updateDetalleTableColumns((cols) => ([
                            ...cols,
                            { label: `Col ${cols.length + 1}`, token: '{{detalle.descripcion_producto}}', width: 80, align: 'left' }
                          ]))}
                        >
                          Agregar columna
                        </Button>
                      </Box>
                    )}

                    {selected.type === 'totales' && (
                      <Box sx={{ border: '1px solid #e0e0e0', borderRadius: 1, p: 1 }}>
                        <Typography variant='caption' sx={{ fontWeight: 700, display: 'block', mb: 0.75 }}>
                          Configuracion de totales
                        </Typography>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mb: 1 }}>
                          <Button
                            size='small'
                            variant={selected.followDetail ? 'contained' : 'outlined'}
                            onClick={() => updateSelected({ followDetail: !selected.followDetail })}
                          >
                            Pegar a detalle
                          </Button>
                          <TextField
                            label='Separacion'
                            size='small'
                            type='number'
                            value={selected.gapFromDetail ?? 4}
                            onChange={(e) => updateSelected({ gapFromDetail: Math.max(0, Number(e.target.value || 0)) })}
                          />
                        </Box>

                        {/* ── Borde del bloque de totales ── */}
                        <Box sx={{ border: '1px solid #e8e8e8', borderRadius: 1, p: 0.75, mb: 1 }}>
                          <Typography variant='caption' sx={{ fontWeight: 700, display: 'block', mb: 0.75, color: '#555' }}>
                            Borde del recuadro
                          </Typography>
                          <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mb: 0.75 }}>
                            <Button
                              size='small'
                              variant={selected.showBorder ? 'contained' : 'outlined'}
                              onClick={() => updateSelected({ showBorder: !selected.showBorder })}
                            >
                              {selected.showBorder ? 'Borde ON' : 'Borde OFF'}
                            </Button>
                            <ColorField
                              label='Color borde'
                              value={selected.borderColor || '#444444'}
                              onChange={(value) => updateSelected({ borderColor: value })}
                              pickerFallback='#444444'
                            />
                          </Box>
                          {selected.showBorder && (
                            <>
                              <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mb: 0.75 }}>
                                <TextField
                                  label='Grosor borde'
                                  size='small'
                                  type='number'
                                  inputProps={{ min: 0.2, max: 5, step: 0.2 }}
                                  value={selected.borderWidth ?? 0.5}
                                  onChange={(e) => updateSelected({ borderWidth: Math.max(0.2, Number(e.target.value || 0.5)) })}
                                />
                                <TextField
                                  label='Radio esquinas'
                                  size='small'
                                  type='number'
                                  inputProps={{ min: 0, max: 20 }}
                                  value={selected.borderRadius ?? 0}
                                  onChange={(e) => updateSelected({ borderRadius: Math.max(0, Number(e.target.value || 0)) })}
                                />
                              </Box>
                              {/* Lados individuales (solo cuando borderRadius = 0) */}
                              {!(selected.borderRadius > 0) && (
                                <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 0.5, mb: 0.75 }}>
                                  {[['borderTop','↑ Sup'], ['borderRight','→ Der'], ['borderBottom','↓ Inf'], ['borderLeft','← Izq']].map(([key, label]) => (
                                    <Button
                                      key={key}
                                      size='small'
                                      variant={selected[key] !== false ? 'contained' : 'outlined'}
                                      onClick={() => updateSelected({ [key]: selected[key] === false ? true : false })}
                                      sx={{ fontSize: '0.6rem', px: 0.3 }}
                                    >
                                      {label}
                                    </Button>
                                  ))}
                                </Box>
                              )}
                            </>
                          )}
                          <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mb: 0.75 }}>
                            <ColorField
                              label='Fondo (fill)'
                              value={selected.fillColor || ''}
                              onChange={(value) => updateSelected({ fillColor: value || null })}
                              pickerFallback='#ffffff'
                            />
                            <Button
                              size='small'
                              variant={selected.showSeparatorLine !== false && !selected.showBorder ? 'contained' : 'outlined'}
                              disabled={!!selected.showBorder}
                              title={selected.showBorder ? 'Usa el borde completo en lugar del separador' : ''}
                              onClick={() => updateSelected({ showSeparatorLine: !(selected.showSeparatorLine !== false) })}
                            >
                              Línea sep. total
                            </Button>
                          </Box>
                        </Box>

                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mb: 1 }}>
                          <TextField
                            label='Alto fila'
                            size='small'
                            type='number'
                            value={selected.rowHeight ?? (selected.fontSize ? Number(selected.fontSize) + 4 : 13)}
                            onChange={(e) => updateSelected({ rowHeight: Math.max(10, Number(e.target.value || 13)) })}
                          />
                          <TextField
                            label='Padding vertical'
                            size='small'
                            type='number'
                            inputProps={{ min: 0, max: 20 }}
                            value={selected.paddingV ?? 3}
                            onChange={(e) => updateSelected({ paddingV: Math.max(0, Number(e.target.value || 3)) })}
                          />
                        </Box>

                        {/* Padding por lado */}
                        <Box sx={{ border: '1px solid #e8e8e8', borderRadius: 1, p: 0.75, mb: 1 }}>
                          <Typography variant='caption' sx={{ fontWeight: 700, display: 'block', mb: 0.5, color: '#555' }}>Padding interior</Typography>
                          <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: 0.5 }}>
                            <TextField size='small' type='number' label='Pad Top' value={selected.paddingTop ?? ''} placeholder='3' onChange={(e) => updateSelected({ paddingTop: e.target.value !== '' ? Math.max(0, Number(e.target.value)) : undefined })} />
                            <TextField size='small' type='number' label='Pad Bottom' value={selected.paddingBottom ?? ''} placeholder='3' onChange={(e) => updateSelected({ paddingBottom: e.target.value !== '' ? Math.max(0, Number(e.target.value)) : undefined })} />
                            <TextField size='small' type='number' label='Pad Left' value={selected.paddingLeft ?? ''} placeholder='4' onChange={(e) => updateSelected({ paddingLeft: e.target.value !== '' ? Math.max(0, Number(e.target.value)) : undefined })} />
                            <TextField size='small' type='number' label='Pad Right' value={selected.paddingRight ?? ''} placeholder='4' onChange={(e) => updateSelected({ paddingRight: e.target.value !== '' ? Math.max(0, Number(e.target.value)) : undefined })} />
                          </Box>
                          <Box sx={{ mt: 0.75 }}>
                            <TextField size='small' type='number' fullWidth label='% col etiqueta (0.1–0.9)' inputProps={{ min: 0.1, max: 0.9, step: 0.05 }} value={selected.labelWidthPct ?? 0.6} onChange={(e) => updateSelected({ labelWidthPct: Math.max(0.1, Math.min(0.9, Number(e.target.value))) })} />
                          </Box>
                        </Box>

                        {/* Colores */}
                        <Box sx={{ border: '1px solid #e8e8e8', borderRadius: 1, p: 0.75, mb: 1 }}>
                          <Typography variant='caption' sx={{ fontWeight: 700, display: 'block', mb: 0.5, color: '#555' }}>Colores filas</Typography>
                          <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.5, mb: 0.5 }}>
                            <ColorField label='Color etiqueta' value={selected.labelColor || '#444444'} onChange={(v) => updateSelected({ labelColor: v })} pickerFallback='#444444' />
                            <ColorField label='Color valor' value={selected.valueColor || '#111111'} onChange={(v) => updateSelected({ valueColor: v })} pickerFallback='#111111' />
                          </Box>
                          <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.5, mb: 0.5 }}>
                            <ColorField label='Color fila TOTAL' value={selected.totalColor || '#000000'} onChange={(v) => updateSelected({ totalColor: v })} pickerFallback='#000000' />
                            <ColorField label='Fondo fila TOTAL' value={selected.totalFillColor || ''} onChange={(v) => updateSelected({ totalFillColor: v || null })} pickerFallback='#e8f5e9' />
                          </Box>
                          {/* Zebra */}
                          <Button size='small' variant={selected.zebraStripe ? 'contained' : 'outlined'} fullWidth onClick={() => updateSelected({ zebraStripe: !selected.zebraStripe })} sx={{ mb: 0.5 }}>Filas alternadas (zebra)</Button>
                          {selected.zebraStripe && (
                            <ColorField label='Color fila par' value={selected.zebraEvenColor || '#f5f5f5'} onChange={(v) => updateSelected({ zebraEvenColor: v })} pickerFallback='#f5f5f5' />
                          )}
                          {/* Líneas entre filas */}
                          <Button size='small' variant={selected.showRowLines !== false ? 'contained' : 'outlined'} fullWidth onClick={() => updateSelected({ showRowLines: !(selected.showRowLines !== false) })} sx={{ mb: 0.5, mt: 0.5 }}>Líneas entre filas</Button>
                          {selected.showRowLines !== false && (
                            <ColorField label='Color líneas' value={selected.rowLineColor || '#dddddd'} onChange={(v) => updateSelected({ rowLineColor: v })} pickerFallback='#dddddd' />
                          )}
                          <TextField size='small' type='number' fullWidth label='Tamaño fuente fila TOTAL' value={selected.totalFontSize ?? ''} placeholder='auto' sx={{ mt: 0.5 }} onChange={(e) => updateSelected({ totalFontSize: e.target.value ? Math.max(6, Number(e.target.value)) : undefined })} />
                        </Box>

                        <Typography variant='caption' sx={{ fontWeight: 600, display: 'block', mb: 0.75 }}>
                          Filas de totales
                        </Typography>
                        <Box sx={{ display: 'grid', gap: 0.75 }}>
                          {(Array.isArray(selected.rows) && selected.rows.length > 0 ? selected.rows : DEFAULT_TOTALES_ROWS).map((row, rowIdx) => (
                            <Box key={`tot_${rowIdx}`} sx={{ border: '1px dashed #cfd8dc', borderRadius: 1, p: 0.75 }}>
                              <TextField
                                label='Titulo'
                                size='small'
                                fullWidth
                                value={row.label || ''}
                                onChange={(e) => updateTotalesRows((rows) => {
                                  rows[rowIdx] = { ...rows[rowIdx], label: e.target.value };
                                  return rows;
                                })}
                                sx={{ mb: 0.75 }}
                              />
                              <TextField
                                label='Token/Valor'
                                size='small'
                                fullWidth
                                value={row.token || row.value || ''}
                                onChange={(e) => updateTotalesRows((rows) => {
                                  rows[rowIdx] = { ...rows[rowIdx], token: e.target.value };
                                  return rows;
                                })}
                                sx={{ mb: 0.75 }}
                              />
                              <TextField
                                select
                                label='Token desde catalogo (totales)'
                                size='small'
                                fullWidth
                                value=''
                                onChange={(e) => updateTotalesRows((rows) => {
                                  rows[rowIdx] = { ...rows[rowIdx], token: `{{${e.target.value}}}` };
                                  return rows;
                                })}
                                sx={{ mb: 0.75 }}
                              >
                                {totalesCatalogTokens.map((token) => (
                                  <MenuItem key={`tot_${token}`} value={token}>{tokenMetaMap.get(token) || humanizeTokenLabel(token)}</MenuItem>
                                ))}
                              </TextField>
                              <Box sx={{ mb: 0.75 }}>
                                <ColorField
                                  label='Color de esta fila (opcional)'
                                  value={row.color || ''}
                                  onChange={(v) => updateTotalesRows((rows) => {
                                    rows[rowIdx] = { ...rows[rowIdx], color: v || null };
                                    return rows;
                                  })}
                                  pickerFallback='#111111'
                                />
                              </Box>
                              <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr auto auto auto auto', gap: 0.5 }}>
                                <TextField
                                  select
                                  label='Alineacion'
                                  size='small'
                                  value={row.align || 'left'}
                                  onChange={(e) => updateTotalesRows((rows) => {
                                    rows[rowIdx] = { ...rows[rowIdx], align: e.target.value };
                                    return rows;
                                  })}
                                >
                                  <MenuItem value='left'>Left</MenuItem>
                                  <MenuItem value='center'>Center</MenuItem>
                                  <MenuItem value='right'>Right</MenuItem>
                                </TextField>
                                <Button
                                  size='small'
                                  variant={row.money ? 'contained' : 'outlined'}
                                  onClick={() => updateTotalesRows((rows) => {
                                    rows[rowIdx] = { ...rows[rowIdx], money: !rows[rowIdx]?.money };
                                    return rows;
                                  })}
                                >
                                  Moneda
                                </Button>
                                <Button
                                  size='small'
                                  variant={row.bold ? 'contained' : 'outlined'}
                                  onClick={() => updateTotalesRows((rows) => {
                                    rows[rowIdx] = { ...rows[rowIdx], bold: !rows[rowIdx]?.bold };
                                    return rows;
                                  })}
                                >
                                  Negrita
                                </Button>
                                <Button
                                  size='small'
                                  variant='outlined'
                                  disabled={rowIdx === 0}
                                  onClick={() => updateTotalesRows((rows) => {
                                    if (rowIdx <= 0) return rows;
                                    [rows[rowIdx - 1], rows[rowIdx]] = [rows[rowIdx], rows[rowIdx - 1]];
                                    return rows;
                                  })}
                                >
                                  <ArrowUpwardIcon fontSize='small' />
                                </Button>
                                <Button
                                  size='small'
                                  variant='outlined'
                                  disabled={rowIdx === (Array.isArray(selected.rows) && selected.rows.length > 0 ? selected.rows.length - 1 : DEFAULT_TOTALES_ROWS.length - 1)}
                                  onClick={() => updateTotalesRows((rows) => {
                                    if (rowIdx >= rows.length - 1) return rows;
                                    [rows[rowIdx + 1], rows[rowIdx]] = [rows[rowIdx], rows[rowIdx + 1]];
                                    return rows;
                                  })}
                                >
                                  <ArrowDownwardIcon fontSize='small' />
                                </Button>
                                <Button
                                  size='small'
                                  color='error'
                                  variant='outlined'
                                  onClick={() => updateTotalesRows((rows) => rows.filter((_, i) => i !== rowIdx))}
                                >
                                  Quitar
                                </Button>
                              </Box>
                            </Box>
                          ))}
                        </Box>

                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mt: 0.75 }}>
                          <Button
                            size='small'
                            startIcon={<AddBoxIcon />}
                            variant='outlined'
                            onClick={() => updateTotalesRows((rows) => ([
                              ...rows,
                              { label: `Fila ${rows.length + 1}`, token: '{{comprobante.total}}', align: 'left', money: true }
                            ]))}
                          >
                            Agregar fila
                          </Button>
                          <Button
                            size='small'
                            variant='outlined'
                            onClick={() => updateSelected({ rows: cloneDeep(DEFAULT_TOTALES_ROWS) })}
                          >
                            Restaurar default
                          </Button>
                        </Box>
                      </Box>
                    )}

                    {selected.type === 'cuotas_table' && (
                      <Box sx={{ border: '1px solid #e0e0e0', borderRadius: 1, p: 1 }}>
                        <Typography variant='caption' sx={{ fontWeight: 700, display: 'block', mb: 0.75 }}>
                          Configuracion de tabla de cuotas
                        </Typography>

                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mb: 1 }}>
                          <Button
                            size='small'
                            variant={selected.followDetail ? 'contained' : 'outlined'}
                            onClick={() => updateSelected({ followDetail: !selected.followDetail })}
                          >
                            Pegar a detalle
                          </Button>
                          <TextField
                            label='Separacion'
                            size='small'
                            type='number'
                            value={selected.gapFromDetail ?? 4}
                            onChange={(e) => updateSelected({ gapFromDetail: Math.max(0, Number(e.target.value || 0)) })}
                          />
                        </Box>

                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mb: 1 }}>
                          <TextField
                            label='Alto fila'
                            size='small'
                            type='number'
                            value={selected.rowHeight ?? 15}
                            onChange={(e) => updateSelected({ rowHeight: Math.max(10, Number(e.target.value || 15)) })}
                          />
                          <TextField
                            label='Alto cabecera'
                            size='small'
                            type='number'
                            value={selected.headerHeight ?? 17}
                            onChange={(e) => updateSelected({ headerHeight: Math.max(10, Number(e.target.value || 17)) })}
                          />
                        </Box>

                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mb: 1 }}>
                          <TextField size='small' type='number' label='Pad top cabecera' value={selected.headerPaddingTop ?? ''} placeholder='2' onChange={(e) => updateSelected({ headerPaddingTop: e.target.value !== '' ? Math.max(0, Number(e.target.value)) : undefined })} />
                          <TextField size='small' type='number' label='Pad bot cabecera' value={selected.headerPaddingBottom ?? ''} placeholder='2' onChange={(e) => updateSelected({ headerPaddingBottom: e.target.value !== '' ? Math.max(0, Number(e.target.value)) : undefined })} />
                        </Box>

                        <Box sx={{ border: '1px solid #e8e8e8', borderRadius: 1, p: 0.75, mb: 1 }}>
                          <Typography variant='caption' sx={{ fontWeight: 700, display: 'block', mb: 0.5, color: '#555' }}>Padding interior celdas (pt)</Typography>
                          <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: 0.5 }}>
                            <TextField size='small' type='number' label='Pad Top' value={selected.paddingTop ?? ''} placeholder='2' onChange={(e) => updateSelected({ paddingTop: e.target.value !== '' ? Math.max(0, Number(e.target.value)) : undefined })} />
                            <TextField size='small' type='number' label='Pad Bottom' value={selected.paddingBottom ?? ''} placeholder='2' onChange={(e) => updateSelected({ paddingBottom: e.target.value !== '' ? Math.max(0, Number(e.target.value)) : undefined })} />
                            <TextField size='small' type='number' label='Pad Left' value={selected.paddingLeft ?? ''} placeholder='2' onChange={(e) => updateSelected({ paddingLeft: e.target.value !== '' ? Math.max(0, Number(e.target.value)) : undefined })} />
                            <TextField size='small' type='number' label='Pad Right' value={selected.paddingRight ?? ''} placeholder='2' onChange={(e) => updateSelected({ paddingRight: e.target.value !== '' ? Math.max(0, Number(e.target.value)) : undefined })} />
                          </Box>
                        </Box>

                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mb: 1 }}>
                          <Button
                            size='small'
                            variant={selected.showHeader !== false ? 'contained' : 'outlined'}
                            onClick={() => updateSelected({ showHeader: !(selected.showHeader !== false) })}
                          >
                            Cabecera
                          </Button>
                          <Button
                            size='small'
                            variant={selected.showRowLine !== false ? 'contained' : 'outlined'}
                            onClick={() => updateSelected({ showRowLine: !(selected.showRowLine !== false) })}
                          >
                            Lineas fila
                          </Button>
                        </Box>

                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr', gap: 0.75, mb: 1 }}>
                          <Button
                            size='small'
                            variant={selected.autoAdjustColumns ? 'contained' : 'outlined'}
                            onClick={() => updateSelected({ autoAdjustColumns: !selected.autoAdjustColumns })}
                            title='Redistribuir anchos de columnas si exceden el recuadro'
                          >
                            Auto-ajustar anchos de columnas
                          </Button>
                        </Box>

                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mb: 0.5 }}>
                          <Button
                            size='small'
                            variant={selected.showHeaderShade !== false ? 'contained' : 'outlined'}
                            onClick={() => updateSelected({ showHeaderShade: !(selected.showHeaderShade !== false) })}
                          >
                            Sombreado cabecera
                          </Button>
                          <ColorField
                            label='Color sombreado'
                            value={selected.headerFillColor || '#eef4ff'}
                            onChange={(value) => updateSelected({ headerFillColor: value })}
                            pickerFallback='#eef4ff'
                          />
                        </Box>
                        <ColorField label='Color letra cabecera' value={selected.headerColor || '#333333'} onChange={(v) => updateSelected({ headerColor: v })} pickerFallback='#333333' sx={{ mb: 1 }} />

                        {/* ── Borde del bloque de cuotas ── */}
                        <Box sx={{ border: '1px solid #e8e8e8', borderRadius: 1, p: 0.75, mb: 1 }}>
                          <Typography variant='caption' sx={{ fontWeight: 700, display: 'block', mb: 0.75, color: '#555' }}>
                            Borde del recuadro
                          </Typography>
                          <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mb: 0.75 }}>
                            <Button
                              size='small'
                              variant={selected.showBorder ? 'contained' : 'outlined'}
                              onClick={() => updateSelected({ showBorder: !selected.showBorder })}
                            >
                              {selected.showBorder ? 'Borde ON' : 'Borde OFF'}
                            </Button>
                            <ColorField
                              label='Color borde'
                              value={selected.borderColor || '#90caf9'}
                              onChange={(value) => updateSelected({ borderColor: value })}
                              pickerFallback='#90caf9'
                            />
                          </Box>
                          {selected.showBorder && (
                            <>
                              <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mb: 0.75 }}>
                                <TextField
                                  label='Grosor borde'
                                  size='small'
                                  type='number'
                                  inputProps={{ min: 0.2, max: 5, step: 0.2 }}
                                  value={selected.borderWidth ?? 0.5}
                                  onChange={(e) => updateSelected({ borderWidth: Math.max(0.2, Number(e.target.value || 0.5)) })}
                                />
                                <TextField
                                  label='Radio esquinas'
                                  size='small'
                                  type='number'
                                  inputProps={{ min: 0, max: 20 }}
                                  value={selected.borderRadius ?? 0}
                                  onChange={(e) => updateSelected({ borderRadius: Math.max(0, Number(e.target.value || 0)) })}
                                />
                              </Box>
                              {!(selected.borderRadius > 0) && (
                                <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 0.5, mb: 0.75 }}>
                                  {[['borderTop','↑ Sup'], ['borderRight','→ Der'], ['borderBottom','↓ Inf'], ['borderLeft','← Izq']].map(([key, label]) => (
                                    <Button
                                      key={key}
                                      size='small'
                                      variant={selected[key] !== false ? 'contained' : 'outlined'}
                                      onClick={() => updateSelected({ [key]: selected[key] === false ? true : false })}
                                      sx={{ fontSize: '0.6rem', px: 0.3 }}
                                    >
                                      {label}
                                    </Button>
                                  ))}
                                </Box>
                              )}
                            </>
                          )}
                          <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75 }}>
                            <ColorField
                              label='Color lineas fila'
                              value={selected.rowLineColor || '#d7e3f4'}
                              onChange={(value) => updateSelected({ rowLineColor: value })}
                              pickerFallback='#d7e3f4'
                            />
                            <ColorField
                              label='Fondo (fill)'
                              value={selected.fillColor || ''}
                              onChange={(value) => updateSelected({ fillColor: value || null })}
                              pickerFallback='#ffffff'
                            />
                          </Box>
                        </Box>

                        <Typography variant='caption' sx={{ fontWeight: 600, display: 'block', mb: 0.75 }}>
                          Columnas mostradas
                        </Typography>
                        <Box sx={{ display: 'grid', gap: 0.75 }}>
                          {(Array.isArray(selected.columns) && selected.columns.length > 0 ? selected.columns : getDefaultCuotasColumns(formato)).map((col, colIdx) => (
                            <Box key={`cuota_col_${colIdx}`} sx={{ border: '1px dashed #cfd8dc', borderRadius: 1, p: 0.75 }}>
                              <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mb: 0.75 }}>
                                <TextField
                                  label='Titulo'
                                  size='small'
                                  value={col.label || ''}
                                  onChange={(e) => updateCuotasTableColumns((cols) => {
                                    cols[colIdx] = { ...cols[colIdx], label: e.target.value };
                                    return cols;
                                  })}
                                />
                                <TextField
                                  label='Ancho'
                                  size='small'
                                  type='number'
                                  value={col.width ?? 70}
                                  onChange={(e) => updateCuotasTableColumns((cols) => {
                                    cols[colIdx] = { ...cols[colIdx], width: Math.max(20, Number(e.target.value || 70)) };
                                    return cols;
                                  })}
                                />
                              </Box>
                              <TextField
                                label='Token'
                                size='small'
                                fullWidth
                                value={col.token || ''}
                                onChange={(e) => updateCuotasTableColumns((cols) => {
                                  cols[colIdx] = { ...cols[colIdx], token: e.target.value };
                                  return cols;
                                })}
                                sx={{ mb: 0.75 }}
                              />
                              <TextField
                                select
                                label='Token desde catalogo (cuotas)'
                                size='small'
                                fullWidth
                                value=''
                                onChange={(e) => updateCuotasTableColumns((cols) => {
                                  cols[colIdx] = { ...cols[colIdx], token: `{{${e.target.value}}}` };
                                  return cols;
                                })}
                                sx={{ mb: 0.75 }}
                              >
                                {cuotaCatalogTokens.map((token) => (
                                  <MenuItem key={`ct_${token}`} value={token}>{tokenMetaMap.get(token) || humanizeTokenLabel(token)}</MenuItem>
                                ))}
                              </TextField>
                              <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr auto', gap: 0.75, mb: 0.75 }}>
                                <TextField
                                  select
                                  label='Alineacion (cabecera)'
                                  size='small'
                                  value={col.headerAlign || 'center'}
                                  onChange={(e) => updateCuotasTableColumns((cols) => {
                                    cols[colIdx] = { ...cols[colIdx], headerAlign: e.target.value };
                                    return cols;
                                  })}
                                >
                                  <MenuItem value='left'>Left</MenuItem>
                                  <MenuItem value='center'>Center</MenuItem>
                                  <MenuItem value='right'>Right</MenuItem>
                                </TextField>
                                <TextField
                                  select
                                  label='Alineacion (valores)'
                                  size='small'
                                  value={col.align || 'left'}
                                  onChange={(e) => updateCuotasTableColumns((cols) => {
                                    cols[colIdx] = { ...cols[colIdx], align: e.target.value };
                                    return cols;
                                  })}
                                >
                                  <MenuItem value='left'>Left</MenuItem>
                                  <MenuItem value='center'>Center</MenuItem>
                                  <MenuItem value='right'>Right</MenuItem>
                                </TextField>
                              </Box>
                              <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 0.75 }}>
                                <Button
                                  size='small'
                                  variant='outlined'
                                  disabled={colIdx === 0}
                                  onClick={() => updateCuotasTableColumns((cols) => {
                                    if (colIdx <= 0) return cols;
                                    [cols[colIdx - 1], cols[colIdx]] = [cols[colIdx], cols[colIdx - 1]];
                                    return cols;
                                  })}
                                >
                                  <ArrowUpwardIcon fontSize='small' />
                                </Button>
                                <Button
                                  size='small'
                                  variant='outlined'
                                  disabled={colIdx === ((Array.isArray(selected.columns) && selected.columns.length > 0 ? selected.columns : getDefaultCuotasColumns(formato)).length - 1)}
                                  onClick={() => updateCuotasTableColumns((cols) => {
                                    if (colIdx >= cols.length - 1) return cols;
                                    [cols[colIdx + 1], cols[colIdx]] = [cols[colIdx], cols[colIdx + 1]];
                                    return cols;
                                  })}
                                >
                                  <ArrowDownwardIcon fontSize='small' />
                                </Button>
                                <Button
                                  size='small'
                                  color='error'
                                  variant='outlined'
                                  onClick={() => updateCuotasTableColumns((cols) => cols.filter((_, i) => i !== colIdx))}
                                >
                                  Quitar
                                </Button>
                              </Box>
                            </Box>
                          ))}
                        </Box>

                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mt: 0.75 }}>
                          <Button
                            size='small'
                            startIcon={<AddBoxIcon />}
                            variant='outlined'
                            onClick={() => updateCuotasTableColumns((cols) => ([
                              ...cols,
                              { label: `Col ${cols.length + 1}`, token: '{{cuota.numero_label}}', width: 80, align: 'left' }
                            ]))}
                          >
                            Agregar columna
                          </Button>
                          <Button
                            size='small'
                            variant='outlined'
                            onClick={() => updateSelected({ columns: cloneDeep(getDefaultCuotasColumns(formato)) })}
                          >
                            Restaurar default
                          </Button>
                        </Box>
                      </Box>
                    )}

                    {selected.type === 'detalle_totales' && (
                      <Box sx={{ border: '1px solid #e0e0e0', borderRadius: 1, p: 1 }}>
                        <Typography variant='caption' sx={{ fontWeight: 700, display: 'block', mb: 0.75 }}>Tabla Detalle + Totales integrados</Typography>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mb: 1 }}>
                          <TextField label='Alto fila' size='small' type='number' value={selected.rowHeight ?? 16} onChange={(e) => updateSelected({ rowHeight: Math.max(10, Number(e.target.value || 16)) })} />
                          <TextField label='Alto cabecera' size='small' type='number' value={selected.headerHeight ?? 18} onChange={(e) => updateSelected({ headerHeight: Math.max(10, Number(e.target.value || 18)) })} />
                        </Box>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mb: 1 }}>
                          <TextField label='Alto fila total' size='small' type='number' value={selected.totalesRowHeight ?? 14} onChange={(e) => updateSelected({ totalesRowHeight: Math.max(10, Number(e.target.value || 14)) })} />
                          <TextField label='Font total' size='small' type='number' value={selected.totalesFontSize ?? 9} onChange={(e) => updateSelected({ totalesFontSize: Math.max(5, Number(e.target.value || 9)) })} />
                        </Box>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mb: 1 }}>
                          <TextField label='Pad top cabecera' size='small' type='number' value={selected.headerPaddingTop ?? 2} onChange={(e) => updateSelected({ headerPaddingTop: Math.max(0, Number(e.target.value || 0)) })} />
                          <TextField label='Pad bot cabecera' size='small' type='number' value={selected.headerPaddingBottom ?? 2} onChange={(e) => updateSelected({ headerPaddingBottom: Math.max(0, Number(e.target.value || 0)) })} />
                        </Box>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mb: 1 }}>
                          <TextField label='Pad top fila' size='small' type='number' value={selected.rowPaddingTop ?? 0} onChange={(e) => updateSelected({ rowPaddingTop: Math.max(0, Number(e.target.value || 0)) })} />
                          <TextField label='Pad bot fila' size='small' type='number' value={selected.rowPaddingBottom ?? 2} onChange={(e) => updateSelected({ rowPaddingBottom: Math.max(0, Number(e.target.value || 0)) })} />
                        </Box>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mb: 1 }}>
                          <TextField size='small' type='number' label='Pad Left' value={selected.paddingLeft ?? ''} placeholder='2' onChange={(e) => updateSelected({ paddingLeft: e.target.value !== '' ? Math.max(0, Number(e.target.value)) : undefined })} />
                          <TextField size='small' type='number' label='Pad Right' value={selected.paddingRight ?? ''} placeholder='2' onChange={(e) => updateSelected({ paddingRight: e.target.value !== '' ? Math.max(0, Number(e.target.value)) : undefined })} />
                        </Box>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mb: 1 }}>
                          <Button size='small' variant={selected.showHeader !== false ? 'contained' : 'outlined'} onClick={() => updateSelected({ showHeader: !(selected.showHeader !== false) })}>Cabecera</Button>
                          <Button size='small' variant={selected.showRowLine ? 'contained' : 'outlined'} onClick={() => updateSelected({ showRowLine: !selected.showRowLine })}>Líneas fila</Button>
                          <Button size='small' variant={selected.showColLines ? 'contained' : 'outlined'} onClick={() => updateSelected({ showColLines: !selected.showColLines })}>Líneas col.</Button>
                          <Button size='small' variant={selected.showOuterBorder !== false ? 'contained' : 'outlined'} onClick={() => updateSelected({ showOuterBorder: !(selected.showOuterBorder !== false) })}>Borde ext.</Button>
                        </Box>

                        {/* Zebra striping para detalle_totales */}
                        <Box sx={{ mb: 1 }}>
                          <Button size='small' fullWidth variant={selected.zebraStripe ? 'contained' : 'outlined'} onClick={() => updateSelected({ zebraStripe: !selected.zebraStripe })} sx={{ mb: 0.5 }}>
                            Filas alternadas (zebra)
                          </Button>
                          {selected.zebraStripe && (
                            <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.5 }}>
                              <ColorField label='Fila par' value={selected.zebraEvenColor || '#f5f5f5'} onChange={(v) => updateSelected({ zebraEvenColor: v })} pickerFallback='#f5f5f5' />
                              <ColorField label='Fila impar' value={selected.zebraOddColor || '#ffffff'} onChange={(v) => updateSelected({ zebraOddColor: v })} pickerFallback='#ffffff' />
                            </Box>
                          )}
                        </Box>

                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mb: 1 }}>
                          <Button size='small' variant={selected.showHeaderShade !== false ? 'contained' : 'outlined'} onClick={() => updateSelected({ showHeaderShade: !(selected.showHeaderShade !== false) })}>Sombreado cab.</Button>
                          <ColorField label='Color cab.' value={selected.headerFillColor || '#efefef'} onChange={(value) => updateSelected({ headerFillColor: value })} pickerFallback='#efefef' />
                        </Box>
                        <ColorField label='Color letra cabecera' value={selected.headerColor || '#333333'} onChange={(v) => updateSelected({ headerColor: v })} pickerFallback='#333333' sx={{ mb: 0.75 }} />
                        <ColorField label='Color borde grilla' value={selected.borderColor || '#666666'} onChange={(value) => updateSelected({ borderColor: value })} pickerFallback='#666666' />
                        <TextField label='Grosor borde' size='small' type='number' inputProps={{ step: 0.1, min: 0.1, max: 3 }} value={selected.borderWidth ?? 0.5} onChange={(e) => updateSelected({ borderWidth: Math.max(0.1, Number(e.target.value || 0.5)) })} sx={{ mt: 0.75 }} />
                        <Typography variant='caption' sx={{ fontWeight: 600, display: 'block', mt: 1, mb: 0.75 }}>Columnas de detalle</Typography>
                        <Box sx={{ display: 'grid', gap: 0.75 }}>
                          {(Array.isArray(selected.columns) ? selected.columns : []).map((col, colIdx) => (
                            <Box key={`dtot_col_${colIdx}`} sx={{ border: '1px dashed #cfd8dc', borderRadius: 1, p: 0.75 }}>
                              <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mb: 0.75 }}>
                                <TextField label='Título' size='small' value={col.label || ''} onChange={(e) => updateSelected({ columns: selected.columns.map((c, i) => i === colIdx ? { ...c, label: e.target.value } : c) })} />
                                <TextField label='Ancho' size='small' type='number' value={col.width ?? 70} onChange={(e) => updateSelected({ columns: selected.columns.map((c, i) => i === colIdx ? { ...c, width: Math.max(20, Number(e.target.value)) } : c) })} />
                              </Box>
                              <TextField label='Token' size='small' fullWidth value={col.token || ''} onChange={(e) => updateSelected({ columns: selected.columns.map((c, i) => i === colIdx ? { ...c, token: e.target.value } : c) })} sx={{ mb: 0.75 }} />
                              <TextField
                                select
                                label='Token desde catálogo (detalle)'
                                size='small'
                                fullWidth
                                value=''
                                onChange={(e) => updateSelected({ columns: selected.columns.map((c, i) => i === colIdx ? { ...c, token: `{{${e.target.value}}}` } : c) })}
                                sx={{ mb: 0.75 }}
                              >
                                {detalleCatalogTokens.map((token) => (
                                  <MenuItem key={`dtot_tk_${colIdx}_${token}`} value={token}>{tokenMetaMap.get(token) || humanizeTokenLabel(token)}</MenuItem>
                                ))}
                              </TextField>
                              <TextField
                                label='Formato numérico (ej: #,##0.00)'
                                size='small'
                                fullWidth
                                placeholder='Ej: #,##0.00 ó #,##0'
                                value={col.format || ''}
                                onChange={(e) => updateSelected({ columns: selected.columns.map((c, i) => i === colIdx ? { ...c, format: e.target.value } : c) })}
                                sx={{ mb: 0.75 }}
                              />
                              <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 0.5, mb: 0.5 }}>
                                <TextField select label='Align cab.' size='small' value={col.headerAlign || 'center'} onChange={(e) => updateSelected({ columns: selected.columns.map((c, i) => i === colIdx ? { ...c, headerAlign: e.target.value } : c) })}>
                                  <MenuItem value='left'>Left</MenuItem><MenuItem value='center'>Center</MenuItem><MenuItem value='right'>Right</MenuItem>
                                </TextField>
                                <TextField select label='Align valores' size='small' value={col.align || 'left'} onChange={(e) => updateSelected({ columns: selected.columns.map((c, i) => i === colIdx ? { ...c, align: e.target.value } : c) })}>
                                  <MenuItem value='left'>Left</MenuItem><MenuItem value='center'>Center</MenuItem><MenuItem value='right'>Right</MenuItem>
                                </TextField>
                                <Button size='small' variant={col.wrap ? 'contained' : 'outlined'} onClick={() => updateSelected({ columns: selected.columns.map((c, i) => i === colIdx ? { ...c, wrap: !c.wrap } : c) })}>Multi</Button>
                              </Box>
                              <Box sx={{ border: '1px solid #eee', borderRadius: 0.5, p: 0.5, mb: 0.5 }}>
                                <Typography variant='caption' sx={{ color: 'text.secondary', display: 'block', mb: 0.25 }}>Padding cabecera</Typography>
                                <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 0.5 }}>
                                  <TextField size='small' type='number' label='↑' value={col.headerPaddingTop ?? ''} placeholder='2' onChange={(e) => updateSelected({ columns: selected.columns.map((c, i) => i === colIdx ? { ...c, headerPaddingTop: e.target.value !== '' ? Math.max(0, Number(e.target.value)) : undefined } : c) })} />
                                  <TextField size='small' type='number' label='↓' value={col.headerPaddingBottom ?? ''} placeholder='2' onChange={(e) => updateSelected({ columns: selected.columns.map((c, i) => i === colIdx ? { ...c, headerPaddingBottom: e.target.value !== '' ? Math.max(0, Number(e.target.value)) : undefined } : c) })} />
                                  <TextField size='small' type='number' label='←' value={col.headerPaddingLeft ?? ''} placeholder='2' onChange={(e) => updateSelected({ columns: selected.columns.map((c, i) => i === colIdx ? { ...c, headerPaddingLeft: e.target.value !== '' ? Math.max(0, Number(e.target.value)) : undefined } : c) })} />
                                  <TextField size='small' type='number' label='→' value={col.headerPaddingRight ?? ''} placeholder='2' onChange={(e) => updateSelected({ columns: selected.columns.map((c, i) => i === colIdx ? { ...c, headerPaddingRight: e.target.value !== '' ? Math.max(0, Number(e.target.value)) : undefined } : c) })} />
                                </Box>
                              </Box>
                              <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 0.5, mt: 0.5 }}>
                                <Button size='small' variant='outlined' disabled={colIdx === 0} onClick={() => { const cols = [...selected.columns]; [cols[colIdx - 1], cols[colIdx]] = [cols[colIdx], cols[colIdx - 1]]; updateSelected({ columns: cols }); }}>
                                  <ArrowUpwardIcon fontSize='small' />
                                </Button>
                                <Button size='small' variant='outlined' disabled={colIdx === selected.columns.length - 1} onClick={() => { const cols = [...selected.columns]; [cols[colIdx + 1], cols[colIdx]] = [cols[colIdx], cols[colIdx + 1]]; updateSelected({ columns: cols }); }}>
                                  <ArrowDownwardIcon fontSize='small' />
                                </Button>
                                <Button size='small' color='error' variant='outlined' onClick={() => updateSelected({ columns: selected.columns.filter((_, i) => i !== colIdx) })}>Quitar</Button>
                              </Box>
                            </Box>
                          ))}
                        </Box>
                        <Button size='small' startIcon={<AddBoxIcon />} variant='outlined' sx={{ mt: 0.75, mb: 1 }}
                          onClick={() => updateSelected({ columns: [...(selected.columns || []), { label: `Col ${(selected.columns || []).length + 1}`, token: '{{detalle.descripcion_producto}}', width: 80, align: 'left' }] })}>
                          Agregar columna detalle
                        </Button>
                        <Divider sx={{ my: 1 }} />
                        <Typography variant='caption' sx={{ fontWeight: 600, display: 'block', mb: 0.75 }}>Filas de totales</Typography>
                        <Box sx={{ display: 'grid', gap: 0.75 }}>
                          {(Array.isArray(selected.totalesRows) && selected.totalesRows.length > 0 ? selected.totalesRows : DEFAULT_TOTALES_ROWS).map((row, rIdx) => (
                            <Box key={`dtot_row_${rIdx}`} sx={{ border: '1px dashed #cfd8dc', borderRadius: 1, p: 0.75 }}>
                              <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mb: 0.75 }}>
                                <TextField label='Etiqueta' size='small' value={row.label || ''} onChange={(e) => updateSelected({ totalesRows: (selected.totalesRows || DEFAULT_TOTALES_ROWS).map((r, i) => i === rIdx ? { ...r, label: e.target.value } : r) })} />
                                <TextField label='Token' size='small' value={row.token || ''} onChange={(e) => updateSelected({ totalesRows: (selected.totalesRows || DEFAULT_TOTALES_ROWS).map((r, i) => i === rIdx ? { ...r, token: e.target.value } : r) })} />
                              </Box>
                              <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr auto', gap: 0.5 }}>
                                <TextField select label='Align' size='small' value={row.align || 'left'} onChange={(e) => updateSelected({ totalesRows: (selected.totalesRows || DEFAULT_TOTALES_ROWS).map((r, i) => i === rIdx ? { ...r, align: e.target.value } : r) })}>
                                  <MenuItem value='left'>Left</MenuItem><MenuItem value='center'>Center</MenuItem><MenuItem value='right'>Right</MenuItem>
                                </TextField>
                                <Button size='small' variant={row.money ? 'contained' : 'outlined'} onClick={() => updateSelected({ totalesRows: (selected.totalesRows || DEFAULT_TOTALES_ROWS).map((r, i) => i === rIdx ? { ...r, money: !r.money } : r) })}>S/</Button>
                                <Button size='small' variant={row.bold ? 'contained' : 'outlined'} onClick={() => updateSelected({ totalesRows: (selected.totalesRows || DEFAULT_TOTALES_ROWS).map((r, i) => i === rIdx ? { ...r, bold: !r.bold } : r) })}>B</Button>
                                <Button size='small' color='error' variant='outlined' onClick={() => updateSelected({ totalesRows: (selected.totalesRows || DEFAULT_TOTALES_ROWS).filter((_, i) => i !== rIdx) })}>✕</Button>
                              </Box>
                              <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.5, mt: 0.5 }}>
                                <Button size='small' variant='outlined' disabled={rIdx === 0} onClick={() => { const rows = [...(selected.totalesRows || DEFAULT_TOTALES_ROWS)]; [rows[rIdx - 1], rows[rIdx]] = [rows[rIdx], rows[rIdx - 1]]; updateSelected({ totalesRows: rows }); }}>
                                  <ArrowUpwardIcon fontSize='small' />
                                </Button>
                                <Button size='small' variant='outlined' disabled={rIdx === (selected.totalesRows || DEFAULT_TOTALES_ROWS).length - 1} onClick={() => { const rows = [...(selected.totalesRows || DEFAULT_TOTALES_ROWS)]; [rows[rIdx + 1], rows[rIdx]] = [rows[rIdx], rows[rIdx + 1]]; updateSelected({ totalesRows: rows }); }}>
                                  <ArrowDownwardIcon fontSize='small' />
                                </Button>
                              </Box>
                            </Box>
                          ))}
                        </Box>
                        <Button size='small' startIcon={<AddBoxIcon />} variant='outlined' sx={{ mt: 0.75 }}
                          onClick={() => updateSelected({ totalesRows: [...(selected.totalesRows || cloneDeep(DEFAULT_TOTALES_ROWS)), { label: 'Nueva fila', token: '{{comprobante.total}}', align: 'right', money: true }] })}>
                          Agregar fila de total
                        </Button>
                      </Box>
                    )}

                    {selected.type !== 'grupo' && (
                      <Box sx={{ border: '1px solid #e0e0e0', borderRadius: 1, p: 1 }}>
                        <Typography variant='caption' sx={{ fontWeight: 700, display: 'block', mb: 0.75 }}>
                          Grupo
                        </Typography>
                        <TextField
                          select
                          size='small'
                          fullWidth
                          value={selected.groupId || ''}
                          onChange={(e) => updateSelected({ groupId: e.target.value || undefined })}
                          helperText='Si ocultas el grupo, este control se oculta con el. "Seguir anterior" solo encadena contra otros del mismo grupo.'
                        >
                          <MenuItem value=''>Ninguno</MenuItem>
                          {elements.filter((e) => e.type === 'grupo' && e.id !== selected.id).map((g, gi) => (
                            <MenuItem key={g.id} value={g.id}>{g.title || `Grupo ${gi + 1}`}</MenuItem>
                          ))}
                        </TextField>
                      </Box>
                    )}

                    {selected.type !== 'totales' && selected.type !== 'detalle_totales' && (
                      <Box sx={{ border: '1px solid #e0e0e0', borderRadius: 1, p: 1 }}>
                        <Typography variant='caption' sx={{ fontWeight: 700, display: 'block', mb: 0.75 }}>
                          Flujo por orden
                        </Typography>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75 }}>
                          <Button
                            size='small'
                            variant={selected.followPrev ? 'contained' : 'outlined'}
                            onClick={() => updateSelected({ followPrev: !selected.followPrev, parallelToPrev: selected.followPrev ? selected.parallelToPrev : false })}
                          >
                            Seguir anterior
                          </Button>
                          <Button
                            size='small'
                            variant={selected.parallelToPrev ? 'contained' : 'outlined'}
                            onClick={() => updateSelected({ parallelToPrev: !selected.parallelToPrev, followPrev: selected.parallelToPrev ? selected.followPrev : false })}
                          >
                            Misma fila (paralelo)
                          </Button>
                        </Box>
                        <Box sx={{ mt: 0.5 }}>
                          <TextField
                            label='Separacion flujo'
                            size='small'
                            type='number'
                            fullWidth
                            value={selected.flowGap ?? 4}
                            onChange={(e) => updateSelected({ flowGap: Math.max(0, Number(e.target.value || 0)) })}
                          />
                        </Box>
                        <Box sx={{ mt: 0.5 }}>
                          <TextField
                            label='Visible si'
                            size='small'
                            fullWidth
                            value={selected.visibleIf || ''}
                            onChange={(e) => updateSelected({ visibleIf: e.target.value || undefined })}
                            placeholder="comprobante.placa || comprobante.orden_compra"
                            helperText="Ops: || && ! == != > < >= <=   Ej: campo=='01' && !campo2"
                          />
                        </Box>
                      </Box>
                    )}

                    {selected.type === 'text' && (
                      <TextField label='Texto' size='small' multiline minRows={2} value={selected.text || ''} onChange={(e) => updateSelected({ text: e.target.value })} />
                    )}

                    {selected.type === 'field' && (
                      <TextField label='Token' size='small' value={selected.token || ''} onChange={(e) => updateSelected({ token: e.target.value })} />
                    )}

                    {(selected.type === 'field' || selected.type === 'text') && (
                      <TextField
                        label='Formato'
                        size='small'
                        placeholder='Ej: DD/MM/YYYY, number:2, upper'
                        value={selected.format || ''}
                        onChange={(e) => updateSelected({ format: e.target.value || undefined })}
                        helperText='Fechas: DD/MM/YYYY · Números: number:2 · Texto: upper / lower'
                      />
                    )}

                    {(selected.type === 'field' || selected.type === 'text') && (
                      <Box sx={{ border: '1px solid #e8e8e8', borderRadius: 1, p: 0.75 }}>
                        <Typography variant='caption' sx={{ fontWeight: 700, display: 'block', mb: 0.5, color: '#555' }}>Padding interior (pt)</Typography>
                        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: 0.5 }}>
                          <TextField size='small' type='number' label='Pad Top' value={selected.paddingTop ?? ''} placeholder='0'
                            onChange={(e) => updateSelected({ paddingTop: e.target.value !== '' ? Math.max(0, Number(e.target.value)) : undefined })} />
                          <TextField size='small' type='number' label='Pad Bottom' value={selected.paddingBottom ?? ''} placeholder='0'
                            onChange={(e) => updateSelected({ paddingBottom: e.target.value !== '' ? Math.max(0, Number(e.target.value)) : undefined })} />
                          <TextField size='small' type='number' label='Pad Left' value={selected.paddingLeft ?? ''} placeholder='0'
                            onChange={(e) => updateSelected({ paddingLeft: e.target.value !== '' ? Math.max(0, Number(e.target.value)) : undefined })} />
                          <TextField size='small' type='number' label='Pad Right' value={selected.paddingRight ?? ''} placeholder='0'
                            onChange={(e) => updateSelected({ paddingRight: e.target.value !== '' ? Math.max(0, Number(e.target.value)) : undefined })} />
                        </Box>
                      </Box>
                    )}

                    {(selected.type === 'field' || selected.type === 'text') && !selected.canGrow && (selected.fillColor || selected.borderColor) && (
                      <Box sx={{ border: '1px solid #e8e8e8', borderRadius: 1, p: 0.75, mt: 0.75 }}>
                        <Typography variant='caption' sx={{ fontWeight: 700, display: 'block', mb: 0.5, color: '#555' }}>Alineación vertical</Typography>
                        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 0.5 }}>
                          {[['top', 'Arriba'], ['middle', 'Centro'], ['bottom', 'Abajo']].map(([v, label]) => (
                            <Button key={v} size='small'
                              variant={(selected.verticalAlign || 'middle') === v ? 'contained' : 'outlined'}
                              onClick={() => updateSelected({ verticalAlign: v })}
                            >
                              {label}
                            </Button>
                          ))}
                        </Box>
                      </Box>
                    )}

                    {/* ── Panel de Grilla ── */}
                    {selected.type === 'grid' && (
                      <Box sx={{ border: '1px solid #e0e0e0', borderRadius: 1, p: 1 }}>
                        <Typography variant='caption' sx={{ fontWeight: 700, display: 'block', mb: 0.75 }}>Configuración de grilla</Typography>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mb: 0.75 }}>
                          <TextField label='Filas' size='small' type='number' inputProps={{ min: 1, max: 20 }}
                            value={selected.rows ?? 2}
                            onChange={(e) => {
                              const nr = Math.max(1, Math.min(20, Number(e.target.value || 1)));
                              const cells = Array.from({ length: nr }, (_, r) => Array.from({ length: selected.cols || 3 }, (_, c) => ((selected.cells || [])[r] || [])[c] || ''));
                              updateSelected({ rows: nr, cells, height: nr * (selected.rowHeight || 18) });
                            }} />
                          <TextField label='Columnas' size='small' type='number' inputProps={{ min: 1, max: 10 }}
                            value={selected.cols ?? 3}
                            onChange={(e) => {
                              const nc = Math.max(1, Math.min(10, Number(e.target.value || 1)));
                              const cells = Array.from({ length: selected.rows || 2 }, (_, r) => Array.from({ length: nc }, (_, c) => ((selected.cells || [])[r] || [])[c] || ''));
                              const cw = Math.round((selected.width || 200) / nc);
                              updateSelected({ cols: nc, cells, colWidths: Array(nc).fill(cw) });
                            }} />
                        </Box>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mb: 0.75 }}>
                          <TextField label='Alto fila (pt)' size='small' type='number' inputProps={{ min: 8, max: 60 }}
                            value={selected.rowHeight ?? 18}
                            onChange={(e) => { const rh = Math.max(8, Number(e.target.value || 18)); updateSelected({ rowHeight: rh, height: (selected.rows || 2) * rh }); }} />
                          <Button size='small' variant={selected.headerRow ? 'contained' : 'outlined'}
                            onClick={() => updateSelected({ headerRow: !selected.headerRow })}>
                            {selected.headerRow ? 'Cabecera ON' : 'Cabecera OFF'}
                          </Button>
                        </Box>
                        {selected.headerRow && (
                          <Box sx={{ mb: 0.75 }}>
                            <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mb: 0.75 }}>
                              <ColorField label='Fondo cab.' value={selected.headerFillColor || '#e8eaf6'} onChange={(v) => updateSelected({ headerFillColor: v })} pickerFallback='#e8eaf6' />
                              <ColorField label='Color letra cab.' value={selected.headerColor || '#333333'} onChange={(v) => updateSelected({ headerColor: v })} pickerFallback='#333333' />
                            </Box>
                            <TextField size='small' type='number' label='Pad top cabecera' value={selected.headerPadTop ?? ''} placeholder={(selected.cellPadTop ?? 2).toString()}
                              onChange={(e) => updateSelected({ headerPadTop: e.target.value === '' ? undefined : Math.max(0, Number(e.target.value)) })}
                              sx={{ width: '100%' }} />
                          </Box>
                        )}
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mb: 0.75 }}>
                          <ColorField label='Color borde' value={selected.borderColor || '#555555'} onChange={(v) => updateSelected({ borderColor: v })} pickerFallback='#555555' />
                          <TextField label='Grosor borde' size='small' type='number' inputProps={{ min: 0.2, max: 4, step: 0.2 }}
                            value={selected.borderWidth ?? 0.5}
                            onChange={(e) => updateSelected({ borderWidth: Math.max(0.2, Number(e.target.value || 0.5)) })} />
                        </Box>
                        <Typography variant='caption' sx={{ color: 'text.secondary', display: 'block', mb: 0.5 }}>
                          El borde exterior siempre se muestra; estos interruptores solo afectan las líneas internas.
                        </Typography>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mb: 0.75 }}>
                          <Button size='small' variant={selected.showRowLines !== false ? 'contained' : 'outlined'}
                            onClick={() => updateSelected({ showRowLines: selected.showRowLines === false ? true : false })}>
                            Líneas de fila
                          </Button>
                          <Button size='small' variant={selected.showColLines !== false ? 'contained' : 'outlined'}
                            onClick={() => updateSelected({ showColLines: selected.showColLines === false ? true : false })}>
                            Líneas de columna
                          </Button>
                        </Box>
                        <TextField size='small' type='number' label='Radio borde (px)' value={selected.borderRadius ?? 0} placeholder='0'
                          onChange={(e) => updateSelected({ borderRadius: Math.max(0, Number(e.target.value)) })}
                          inputProps={{ min: 0, max: 30 }} sx={{ mb: 0.75 }} fullWidth />
                        {/* Editor de celdas */}
                        <Typography variant='caption' sx={{ color: 'text.secondary', display: 'block', mb: 0.5 }}>Contenido de celdas</Typography>
                        <Box sx={{ overflowX: 'auto' }}>
                          {Array.from({ length: selected.rows || 2 }, (_, r) => (
                            <Box key={r} sx={{ display: 'flex', gap: 0.5, mb: 0.5 }}>
                              {Array.from({ length: selected.cols || 3 }, (_, c) => (
                                <TextField key={c} size='small'
                                  label={`F${r + 1}C${c + 1}`}
                                  value={((selected.cells || [])[r] || [])[c] || ''}
                                  onChange={(e) => {
                                    const newCells = (selected.cells || []).map((row) => [...row]);
                                    while (newCells.length <= r) newCells.push(Array(selected.cols || 3).fill(''));
                                    while (newCells[r].length <= c) newCells[r].push('');
                                    newCells[r][c] = e.target.value;
                                    updateSelected({ cells: newCells });
                                  }}
                                  sx={{ minWidth: 70 }}
                                />
                              ))}
                            </Box>
                          ))}
                        </Box>
                        {/* Anchos de columna */}
                        <Typography variant='caption' sx={{ color: 'text.secondary', display: 'block', mt: 0.75, mb: 0.5 }}>Anchos de columnas (pt)</Typography>
                        <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                          {Array.from({ length: selected.cols || 3 }, (_, c) => (
                            <TextField key={c} size='small' label={`C${c + 1}`} type='number' inputProps={{ min: 10 }}
                              value={((selected.colWidths || [])[c]) ?? Math.round((selected.width || 200) / (selected.cols || 3))}
                              onChange={(e) => {
                                const cws = Array.from({ length: selected.cols || 3 }, (_, i) => ((selected.colWidths || [])[i]) ?? Math.round((selected.width || 200) / (selected.cols || 3)));
                                cws[c] = Math.max(10, Number(e.target.value || 10));
                                updateSelected({ colWidths: cws });
                              }}
                              sx={{ width: 70 }}
                            />
                          ))}
                        </Box>
                        <Button size='small' variant='outlined' sx={{ mt: 0.75 }} fullWidth
                          onClick={() => {
                            const nc = selected.cols || 3; const w = selected.width || 200;
                            const cw = Math.round(w / nc);
                            updateSelected({ colWidths: Array(nc).fill(cw) });
                          }}>
                          Distribuir columnas igual
                        </Button>

                        {(selected.cols || 3) > 1 && (
                          <>
                            <Typography variant='caption' sx={{ color: 'text.secondary', display: 'block', mt: 0.75, mb: 0.5 }}>
                              Líneas divisorias entre columnas (individual)
                            </Typography>
                            <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                              {Array.from({ length: (selected.cols || 3) - 1 }, (_, i) => {
                                const visible = (Array.isArray(selected.colLineVisible) ? selected.colLineVisible : [])[i] !== false;
                                return (
                                  <Button key={i} size='small' variant={visible ? 'contained' : 'outlined'}
                                    onClick={() => {
                                      const nc = selected.cols || 3;
                                      const arr = Array.from({ length: nc - 1 }, (_, j) => ((Array.isArray(selected.colLineVisible) ? selected.colLineVisible : [])[j]) !== false);
                                      arr[i] = !arr[i];
                                      updateSelected({ colLineVisible: arr });
                                    }}>
                                    {`C${i + 1}|C${i + 2}`}
                                  </Button>
                                );
                              })}
                            </Box>
                          </>
                        )}

                        {/* Estilo texto celdas */}
                        <Box sx={{ border: '1px solid #e8e8e8', borderRadius: 1, p: 0.75, mt: 0.75 }}>
                          <Typography variant='caption' sx={{ fontWeight: 700, display: 'block', mb: 0.5 }}>Estilo texto</Typography>
                          <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 0.5, mb: 0.75 }}>
                            <Button size='small' variant={selected.bold ? 'contained' : 'outlined'} onClick={() => updateSelected({ bold: !selected.bold })} sx={{ fontWeight: 700 }}>B</Button>
                            <Button size='small' variant={selected.italic ? 'contained' : 'outlined'} onClick={() => updateSelected({ italic: !selected.italic })} sx={{ fontStyle: 'italic' }}>I</Button>
                            <Button size='small' variant={selected.underline ? 'contained' : 'outlined'} onClick={() => updateSelected({ underline: !selected.underline })} sx={{ textDecoration: 'underline' }}>U</Button>
                            <Button size='small' variant={selected.strikethrough ? 'contained' : 'outlined'} onClick={() => updateSelected({ strikethrough: !selected.strikethrough })} sx={{ textDecoration: 'line-through' }}>S</Button>
                          </Box>
                          <Typography variant='caption' sx={{ color: 'text.secondary', display: 'block', mb: 0.5 }}>Padding celda</Typography>
                          <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 0.5 }}>
                            <TextField size='small' type='number' label='Pad Top' value={selected.cellPadTop ?? 2} onChange={(e) => updateSelected({ cellPadTop: Math.max(0, Number(e.target.value)) })} />
                            <TextField size='small' type='number' label='Pad Left' value={selected.cellPadLeft ?? 2} onChange={(e) => updateSelected({ cellPadLeft: Math.max(0, Number(e.target.value)) })} />
                            <TextField size='small' type='number' label='Pad Right' value={selected.cellPadRight ?? 2} onChange={(e) => updateSelected({ cellPadRight: Math.max(0, Number(e.target.value)) })} />
                          </Box>
                        </Box>
                      </Box>
                    )}

                    {selected.type === 'qr' && (
                      <>
                        <Alert severity='info' sx={{ '& .MuiAlert-message': { fontSize: '0.7rem' } }}>
                          QR automático con {'{{comprobante.qr_text}}'}.<br />Vacío = cadena SUNAT del comprobante.
                        </Alert>
                        <TextField
                          label='QR Text'
                          size='small'
                          multiline
                          minRows={2}
                          value={selected.text || ''}
                          onChange={(e) => updateSelected({ text: e.target.value })}
                        />
                      </>
                    )}

                    {selected.type === 'logo' && (
                      <Box>
                        <Typography variant='caption' sx={{ fontWeight: 600, mb: 0.5, display: 'block' }}>Imagen del logo</Typography>
                        <input
                          type='file'
                          accept='image/*'
                          style={{ display: 'block', width: '100%', marginTop: 4 }}
                          onChange={(ev) => {
                            const file = ev.target.files[0];
                            if (!file) return;
                            const reader = new FileReader();
                            reader.onload = () => updateSelected({ imageData: reader.result });
                            reader.readAsDataURL(file);
                          }}
                        />
                        {selected.imageData && (
                          <img
                            src={selected.imageData}
                            alt='preview'
                            style={{ maxWidth: '100%', maxHeight: 60, marginTop: 4, border: '1px solid #e0e0e0', borderRadius: 4 }}
                          />
                        )}
                        {selected.imageData && (
                          <Button size='small' color='error' onClick={() => updateSelected({ imageData: null })} sx={{ mt: 0.5 }}>Quitar imagen</Button>
                        )}
                      </Box>
                    )}

                    {selected.type === 'image' && (
                      <Box sx={{ border: '1px solid #e0e0e0', borderRadius: 1, p: 1 }}>
                        <Typography variant='caption' sx={{ fontWeight: 700, display: 'block', mb: 0.75 }}>Imagen publicitaria</Typography>
                        <input
                          type='file'
                          accept='image/*'
                          style={{ display: 'block', width: '100%', marginTop: 4, marginBottom: 8 }}
                          onChange={(ev) => {
                            const file = ev.target.files[0];
                            if (!file) return;
                            const reader = new FileReader();
                            reader.onload = () => updateSelected({ imageData: reader.result });
                            reader.readAsDataURL(file);
                          }}
                        />
                        {selected.imageData && (
                          <>
                            <img
                              src={selected.imageData}
                              alt='preview'
                              style={{ maxWidth: '100%', maxHeight: 80, marginBottom: 6, border: '1px solid #e0e0e0', borderRadius: 4, objectFit: 'contain' }}
                            />
                            <Button fullWidth size='small' color='error' variant='outlined' onClick={() => updateSelected({ imageData: null })} sx={{ mb: 0.75 }}>
                              Quitar imagen
                            </Button>
                          </>
                        )}
                        <TextField
                          select
                          label='Ajuste de imagen'
                          size='small'
                          fullWidth
                          value={selected.objectFit || 'contain'}
                          onChange={(e) => updateSelected({ objectFit: e.target.value })}
                        >
                          <MenuItem value='contain'>Contener (sin recortar)</MenuItem>
                          <MenuItem value='cover'>Cubrir (recorta)</MenuItem>
                          <MenuItem value='fill'>Estirar (llena)</MenuItem>
                          <MenuItem value='none'>Sin ajuste</MenuItem>
                        </TextField>
                        <TextField
                          label='Opacidad (%)'
                          size='small'
                          type='number'
                          fullWidth
                          inputProps={{ min: 0, max: 100 }}
                          sx={{ mt: 0.75 }}
                          value={selected.opacity ?? 100}
                          onChange={(e) => updateSelected({ opacity: Math.max(0, Math.min(100, Number(e.target.value ?? 100))) })}
                          helperText='100 = opaco, valores bajos para marca de agua o fondo'
                        />
                        <Typography variant='caption' sx={{ mt: 0.75, display: 'block', color: 'text.secondary' }}>
                          Usa &quot;Alineación rápida al canvas&quot; (Izq/Der/Sup/Inf) para pegar la imagen a una esquina,
                          o &quot;Ancho de hoja&quot; para que ocupe todo el ancho de lado a lado.
                        </Typography>
                      </Box>
                    )}

                    <ColorField
                      label='Color'
                      value={selected.color || '#111111'}
                      onChange={(value) => updateSelected({ color: value })}
                      pickerFallback='#111111'
                    />
                    <TextField select label='Align' size='small' value={selected.align || 'left'} onChange={(e) => updateSelected({ align: e.target.value })}>
                      <MenuItem value='left'>Left</MenuItem>
                      <MenuItem value='center'>Center</MenuItem>
                      <MenuItem value='right'>Right</MenuItem>
                    </TextField>

                    {selected.type !== 'line' && (
                      <TextField select label='Fuente' size='small' value={selected.font || 'Helvetica'} onChange={(e) => updateSelected({ font: e.target.value })}>
                        {FONT_OPTIONS.map((opt) => (
                          <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                        ))}
                      </TextField>
                    )}

                    {/* Estilos de texto: B / I / U / Tachado */}
                    {['text', 'field', 'hash', 'sunat_message'].includes(selected.type) && (
                      <Box>
                        <Typography variant='caption' sx={{ color: 'text.secondary', display: 'block', mb: 0.5 }}>Estilo texto</Typography>
                        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 0.5 }}>
                          <Button size='small' variant={selected.bold ? 'contained' : 'outlined'} onClick={() => updateSelected({ bold: !selected.bold })} sx={{ fontWeight: 700 }}>B</Button>
                          <Button size='small' variant={selected.italic ? 'contained' : 'outlined'} onClick={() => updateSelected({ italic: !selected.italic })} sx={{ fontStyle: 'italic' }}>I</Button>
                          <Button size='small' variant={selected.underline ? 'contained' : 'outlined'} onClick={() => updateSelected({ underline: !selected.underline })} sx={{ textDecoration: 'underline' }}>U</Button>
                          <Button size='small' variant={selected.strikethrough ? 'contained' : 'outlined'} onClick={() => updateSelected({ strikethrough: !selected.strikethrough })} sx={{ textDecoration: 'line-through' }}>S</Button>
                        </Box>
                      </Box>
                    )}

                    {/* Puede crecer — solo text y field */}
                    {['text', 'field'].includes(selected.type) && (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.25 }}>
                        <Switch
                          size='small'
                          checked={!!selected.canGrow}
                          onChange={(e) => updateSelected({ canGrow: e.target.checked })}
                        />
                        <Typography variant='caption' sx={{ color: selected.canGrow ? 'primary.main' : 'text.secondary', fontWeight: selected.canGrow ? 700 : 400 }}>
                          Puede crecer ↕
                        </Typography>
                      </Box>
                    )}

                    {selected.type !== 'line' && (
                      <>
                        <Button
                          size='small'
                          variant={selected.borderColor ? 'contained' : 'outlined'}
                          onClick={() => updateSelected(selected.borderColor ? { borderColor: null } : { borderColor: '#333333' })}
                        >
                          {selected.borderColor ? 'Borde ON' : 'Borde OFF'}
                        </Button>
                        <ColorField
                          label='Border Color'
                          value={selected.borderColor ?? ''}
                          onChange={(value) => updateSelected({ borderColor: value || null })}
                          pickerFallback='#333333'
                        />
                        <TextField
                          label='Border Width'
                          size='small'
                          type='number'
                          value={selected.borderWidth ?? 1}
                          onChange={(e) => updateSelected({ borderWidth: Math.max(0, Number(e.target.value || 0)) })}
                        />
                        <TextField
                          label='Border Radius'
                          size='small'
                          type='number'
                          value={selected.borderRadius ?? 0}
                          onChange={(e) => updateSelected({ borderRadius: Math.max(0, Number(e.target.value || 0)) })}
                        />
                        {!(selected.borderRadius > 0) && selected.borderColor && (
                          <Box>
                            <Typography variant='caption' sx={{ color: 'text.secondary', display: 'block', mb: 0.5 }}>Lados del borde</Typography>
                            <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 0.5 }}>
                              {[['borderTop','↑ Sup'],['borderRight','→ Der'],['borderBottom','↓ Inf'],['borderLeft','← Izq']].map(([key, lbl]) => (
                                <Button key={key} size='small'
                                  variant={selected[key] !== false ? 'contained' : 'outlined'}
                                  onClick={() => updateSelected({ [key]: selected[key] === false ? true : false })}
                                  sx={{ fontSize: '0.6rem', px: 0.3 }}
                                >{lbl}</Button>
                              ))}
                            </Box>
                          </Box>
                        )}
                        <Button
                          size='small'
                          variant={selected.fillColor ? 'contained' : 'outlined'}
                          onClick={() => updateSelected(selected.fillColor ? { fillColor: null } : { fillColor: '#efefef' })}
                        >
                          {selected.fillColor ? 'Fondo ON' : 'Fondo OFF'}
                        </Button>
                        <ColorField
                          label='Fill Color'
                          value={selected.fillColor ?? ''}
                          onChange={(value) => updateSelected({ fillColor: value || null })}
                          pickerFallback='#efefef'
                        />
                        {['field', 'text', 'hash', 'sunat_message'].includes(selected?.type) && (
                          <Button
                            size='small'
                            variant={selected.bold ? 'contained' : 'outlined'}
                            onClick={() => updateSelected({ bold: !selected.bold })}
                          >
                            Negrita
                          </Button>
                        )}
                      </>
                    )}

                    {(selected.type === 'rect' || selected.type === 'grupo') && (
                      <Box sx={{ border: '1px solid #e0e0e0', borderRadius: 1, p: 1 }}>
                        <Typography variant='caption' sx={{ fontWeight: 700, display: 'block', mb: 0.75 }}>{selected.type === 'grupo' ? 'Título del grupo (GroupBox)' : 'Título del rect (GroupBox)'}</Typography>
                        <TextField
                          label='Título'
                          size='small'
                          fullWidth
                          value={selected.title || ''}
                          onChange={(e) => updateSelected({ title: e.target.value || undefined })}
                          placeholder='Datos de Transporte  o  {{comprobante.placa}}'
                          helperText='Admite tokens {{campo}}'
                          sx={{ mb: 0.75 }}
                        />
                        <TextField
                          select
                          label='Posición'
                          size='small'
                          fullWidth
                          value={selected.titlePosition || 'top-border'}
                          onChange={(e) => updateSelected({ titlePosition: e.target.value })}
                          sx={{ mb: 0.75 }}
                        >
                          <MenuItem value='top-border'>Sobre el borde superior (GroupBox)</MenuItem>
                          <MenuItem value='above'>Encima del rect</MenuItem>
                          <MenuItem value='inside-top'>Dentro, arriba</MenuItem>
                          <MenuItem value='below'>Debajo del rect</MenuItem>
                        </TextField>
                        <Typography variant='caption' sx={{ color: 'text.secondary', display: 'block', mb: 0.5 }}>Alineación</Typography>
                        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 0.5, mb: 0.75 }}>
                          {[['left','Izq'],['center','Centro'],['right','Der']].map(([v,lbl]) => (
                            <Button key={v} size='small'
                              variant={(selected.titleAlign || 'left') === v ? 'contained' : 'outlined'}
                              onClick={() => updateSelected({ titleAlign: v })}
                            >{lbl}</Button>
                          ))}
                        </Box>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mb: 0.75 }}>
                          <TextField label='Tamaño fuente' size='small' type='number'
                            value={selected.titleFontSize ?? 9}
                            onChange={(e) => updateSelected({ titleFontSize: Math.max(6, Number(e.target.value || 9)) })}
                          />
                          <TextField label='Padding H' size='small' type='number'
                            value={selected.titlePadding ?? 4}
                            onChange={(e) => updateSelected({ titlePadding: Math.max(0, Number(e.target.value ?? 4)) })}
                          />
                        </Box>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75, mb: 0.75 }}>
                          <ColorField label='Color texto' value={selected.titleColor || '#000000'} onChange={(v) => updateSelected({ titleColor: v })} pickerFallback='#000000' />
                          <ColorField label='Color fondo' value={selected.titleBgColor || '#ffffff'} onChange={(v) => updateSelected({ titleBgColor: v })} pickerFallback='#ffffff' />
                        </Box>
                        <Button size='small' fullWidth
                          variant={selected.titleBold ? 'contained' : 'outlined'}
                          onClick={() => updateSelected({ titleBold: !selected.titleBold })}
                          sx={{ fontWeight: 700 }}
                        >Negrita título</Button>
                      </Box>
                    )}

                    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 0.5 }}>
                      <Button size='small' variant='outlined' onClick={() => nudge(-1, 0)}><OpenWithIcon fontSize='small' sx={{ mr: 0.5 }} />X-</Button>
                      <Button size='small' variant='outlined' onClick={() => nudge(0, -1)}>Y-</Button>
                      <Button size='small' variant='outlined' onClick={() => nudge(1, 0)}>X+</Button>
                      <Button size='small' variant='outlined' onClick={() => nudge(0, 1)}>Y+</Button>
                    </Box>
                  </Box>
                )}
              </CardContent>
            </Card>
          </Box>
        </Box>
      </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={exportarLayout} variant='outlined'>Exportar JSON</Button>
        <Button onClick={save} variant='contained' startIcon={<SaveIcon />} disabled={loading}>
          {loading ? 'Guardando...' : 'Guardar Layout'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
